export const TRAINERS_BW = [
  {
    "name": "SHERMAN",
    "trainerClass": "Youngster",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "SILL",
    "trainerClass": "Youngster",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "HUITRES",
    "trainerClass": "Lass",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "PAULINA",
    "trainerClass": "Lass",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "FRITZ",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "LAYTON",
    "trainerClass": "School Kid (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "PERCY",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "SCOUT",
    "trainerClass": "School Kid (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "BERTRAN",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "TROY",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "HUITRE",
    "trainerClass": "Lady",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "POISSON",
    "trainerClass": "Lady",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "BETTY",
    "trainerClass": "Preschooler (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "HELEN",
    "trainerClass": "Preschooler (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "USEF",
    "trainerClass": "Preschooler (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "ZAID",
    "trainerClass": "Preschooler (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "MABON",
    "trainerClass": "Backpacker (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "SHAMUS",
    "trainerClass": "Backpacker (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "POLINA",
    "trainerClass": "Backpacker (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "ZLATA",
    "trainerClass": "Backpacker (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "KARSTON",
    "trainerClass": "Waiter",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "LENNART",
    "trainerClass": "Waiter",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "IKAORA",
    "trainerClass": "Waitress",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "MEENA",
    "trainerClass": "Waitress",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "FILIPPE",
    "trainerClass": "Pokemonfan (M)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "SERGIO",
    "trainerClass": "Pokemonfan (M)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "BIIJAL",
    "trainerClass": "Pokemonfan (F)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "MERYL",
    "trainerClass": "Pokemonfan (F)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "GLEN",
    "trainerClass": "Hiker",
    "pokemon": [
      "P 217",
      "P 218",
      "P 224",
      "P 225",
      "P 227",
      "P 236",
      "P 243",
      "P 260",
      "P 262",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 290",
      "P 295",
      "P 307",
      "P 309",
      "P 315",
      "P 318",
      "P 320",
      "P 321",
      "P 322",
      "P 324",
      "P 329",
      "P 337",
      "P 348",
      "P 349",
      "P 354",
      "P 356",
      "P 360",
      "P 376",
      "P 378",
      "P 381"
    ]
  },
  {
    "name": "TAPIOCA",
    "trainerClass": "Hiker",
    "pokemon": [
      "P 217",
      "P 218",
      "P 224",
      "P 225",
      "P 227",
      "P 236",
      "P 243",
      "P 260",
      "P 262",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 290",
      "P 295",
      "P 307",
      "P 309",
      "P 315",
      "P 318",
      "P 320",
      "P 321",
      "P 322",
      "P 324",
      "P 329",
      "P 337",
      "P 348",
      "P 349",
      "P 354",
      "P 356",
      "P 360",
      "P 376",
      "P 378",
      "P 381"
    ]
  },
  {
    "name": "DUNCAN",
    "trainerClass": "Fisherman",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 231",
      "P 236",
      "P 240",
      "P 243",
      "P 251",
      "P 263",
      "P 274",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 308",
      "P 328",
      "P 336",
      "P 340",
      "P 355",
      "P 357",
      "P 363",
      "P 365",
      "P 367",
      "P 369"
    ]
  },
  {
    "name": "MORGAN",
    "trainerClass": "Fisherman",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 231",
      "P 236",
      "P 240",
      "P 243",
      "P 251",
      "P 263",
      "P 274",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 308",
      "P 328",
      "P 336",
      "P 340",
      "P 355",
      "P 357",
      "P 363",
      "P 365",
      "P 367",
      "P 369"
    ]
  },
  {
    "name": "COCOME",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 228",
      "P 231",
      "P 236",
      "P 240",
      "P 242",
      "P 243",
      "P 247",
      "P 251",
      "P 253",
      "P 254",
      "P 258",
      "P 263",
      "P 265",
      "P 266",
      "P 274",
      "P 275",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 305",
      "P 308",
      "P 327",
      "P 328",
      "P 330",
      "P 331",
      "P 336",
      "P 340",
      "P 353",
      "P 355",
      "P 357",
      "P 362",
      "P 363",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 373",
      "P 383"
    ]
  },
  {
    "name": "NU",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 228",
      "P 231",
      "P 236",
      "P 240",
      "P 242",
      "P 243",
      "P 247",
      "P 251",
      "P 253",
      "P 254",
      "P 258",
      "P 263",
      "P 265",
      "P 266",
      "P 274",
      "P 275",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 305",
      "P 308",
      "P 327",
      "P 328",
      "P 330",
      "P 331",
      "P 336",
      "P 340",
      "P 353",
      "P 355",
      "P 357",
      "P 362",
      "P 363",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 373",
      "P 383"
    ]
  },
  {
    "name": "POMODI",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 228",
      "P 231",
      "P 236",
      "P 240",
      "P 242",
      "P 243",
      "P 247",
      "P 251",
      "P 253",
      "P 254",
      "P 258",
      "P 263",
      "P 265",
      "P 266",
      "P 274",
      "P 275",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 305",
      "P 308",
      "P 327",
      "P 328",
      "P 330",
      "P 331",
      "P 336",
      "P 340",
      "P 353",
      "P 355",
      "P 357",
      "P 362",
      "P 363",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 373",
      "P 383"
    ]
  },
  {
    "name": "CALON",
    "trainerClass": "Roughneck",
    "pokemon": [
      "P 216",
      "P 219",
      "P 222",
      "P 226",
      "P 232",
      "P 235",
      "P 237",
      "P 244",
      "P 245",
      "P 246",
      "P 252",
      "P 267",
      "P 271",
      "P 277",
      "P 280",
      "P 296",
      "P 304",
      "P 306",
      "P 311",
      "P 314",
      "P 317",
      "P 319",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 334",
      "P 344",
      "P 347",
      "P 351",
      "P 378"
    ]
  },
  {
    "name": "OBERON",
    "trainerClass": "Roughneck",
    "pokemon": [
      "P 216",
      "P 219",
      "P 222",
      "P 226",
      "P 232",
      "P 235",
      "P 237",
      "P 244",
      "P 245",
      "P 246",
      "P 252",
      "P 267",
      "P 271",
      "P 277",
      "P 280",
      "P 296",
      "P 304",
      "P 306",
      "P 311",
      "P 314",
      "P 317",
      "P 319",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 334",
      "P 344",
      "P 347",
      "P 351",
      "P 378"
    ]
  },
  {
    "name": "TRITON",
    "trainerClass": "Roughneck",
    "pokemon": [
      "P 216",
      "P 219",
      "P 222",
      "P 226",
      "P 232",
      "P 235",
      "P 237",
      "P 244",
      "P 245",
      "P 246",
      "P 252",
      "P 267",
      "P 271",
      "P 277",
      "P 280",
      "P 296",
      "P 304",
      "P 306",
      "P 311",
      "P 314",
      "P 317",
      "P 319",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 334",
      "P 344",
      "P 347",
      "P 351",
      "P 378"
    ]
  },
  {
    "name": "JACOB",
    "trainerClass": "Biker",
    "pokemon": [
      "P 235",
      "P 244",
      "P 252",
      "P 255",
      "P 259",
      "P 260",
      "P 267",
      "P 271",
      "P 280",
      "P 289",
      "P 294",
      "P 299",
      "P 306",
      "P 311",
      "P 317",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 339",
      "P 344",
      "P 350",
      "P 378"
    ]
  },
  {
    "name": "JOACHIM",
    "trainerClass": "Biker",
    "pokemon": [
      "P 235",
      "P 244",
      "P 252",
      "P 255",
      "P 259",
      "P 260",
      "P 267",
      "P 271",
      "P 280",
      "P 289",
      "P 294",
      "P 299",
      "P 306",
      "P 311",
      "P 317",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 339",
      "P 344",
      "P 350",
      "P 378"
    ]
  },
  {
    "name": "XAVIER",
    "trainerClass": "Biker",
    "pokemon": [
      "P 235",
      "P 244",
      "P 252",
      "P 255",
      "P 259",
      "P 260",
      "P 267",
      "P 271",
      "P 280",
      "P 289",
      "P 294",
      "P 299",
      "P 306",
      "P 311",
      "P 317",
      "P 321",
      "P 323",
      "P 325",
      "P 326",
      "P 339",
      "P 344",
      "P 350",
      "P 378"
    ]
  },
  {
    "name": "CHELSIE",
    "trainerClass": "Baker",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "COL",
    "trainerClass": "Baker",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "MARIS",
    "trainerClass": "Baker",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "BRANT",
    "trainerClass": "Harlequin",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "EGIL",
    "trainerClass": "Harlequin",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "SURUNE",
    "trainerClass": "Harlequin",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "CEYLON",
    "trainerClass": "Maid",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "CYANEA",
    "trainerClass": "Maid",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "MINERVA",
    "trainerClass": "Maid",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "BOGEY",
    "trainerClass": "Painter",
    "pokemon": [
      "P 408",
      "P 442",
      "P 469",
      "P 484",
      "P 485",
      "P 505",
      "P 511",
      "P 513",
      "P 524",
      "P 534",
      "P 537",
      "P 555"
    ]
  },
  {
    "name": "DALI",
    "trainerClass": "Painter",
    "pokemon": [
      "P 408",
      "P 442",
      "P 469",
      "P 484",
      "P 485",
      "P 505",
      "P 511",
      "P 513",
      "P 524",
      "P 534",
      "P 537",
      "P 555"
    ]
  },
  {
    "name": "IRON",
    "trainerClass": "Painter",
    "pokemon": [
      "P 408",
      "P 442",
      "P 469",
      "P 484",
      "P 485",
      "P 505",
      "P 511",
      "P 513",
      "P 524",
      "P 534",
      "P 537",
      "P 555"
    ]
  },
  {
    "name": "MARCH",
    "trainerClass": "Nursery Aide",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398"
    ]
  },
  {
    "name": "HAZEL",
    "trainerClass": "Nursery Aide",
    "pokemon": [
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521"
    ]
  },
  {
    "name": "POLKA",
    "trainerClass": "Nursery Aide",
    "pokemon": [
      "P 444",
      "P 451",
      "P 512",
      "P 542",
      "P 547",
      "P 552",
      "P 554",
      "P 556",
      "P 557"
    ]
  },
  {
    "name": "ANTOIN",
    "trainerClass": "Worker (Ice)",
    "pokemon": [
      "P 404",
      "P 415",
      "P 430",
      "P 443",
      "P 456",
      "P 498",
      "P 521",
      "P 527",
      "P 530",
      "P 531",
      "P 532",
      "P 538"
    ]
  },
  {
    "name": "REY",
    "trainerClass": "Worker (Ice)",
    "pokemon": [
      "P 404",
      "P 415",
      "P 430",
      "P 443",
      "P 456",
      "P 498",
      "P 521",
      "P 527",
      "P 530",
      "P 531",
      "P 532",
      "P 538"
    ]
  },
  {
    "name": "EARWIN",
    "trainerClass": "Worker",
    "pokemon": [
      "P 392",
      "P 393",
      "P 399",
      "P 400",
      "P 402",
      "P 411",
      "P 418",
      "P 435",
      "P 437",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 465",
      "P 470",
      "P 482",
      "P 484",
      "P 490",
      "P 493",
      "P 495",
      "P 496",
      "P 497",
      "P 499",
      "P 504",
      "P 512",
      "P 523",
      "P 524",
      "P 529",
      "P 531",
      "P 535",
      "P 551",
      "P 553",
      "P 556"
    ]
  },
  {
    "name": "LAMONT",
    "trainerClass": "Worker",
    "pokemon": [
      "P 392",
      "P 393",
      "P 399",
      "P 400",
      "P 402",
      "P 411",
      "P 418",
      "P 435",
      "P 437",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 465",
      "P 470",
      "P 482",
      "P 484",
      "P 490",
      "P 493",
      "P 495",
      "P 496",
      "P 497",
      "P 499",
      "P 504",
      "P 512",
      "P 523",
      "P 524",
      "P 529",
      "P 531",
      "P 535",
      "P 551",
      "P 553",
      "P 556"
    ]
  },
  {
    "name": "AMHED",
    "trainerClass": "Cyclist (M)",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "HAMID",
    "trainerClass": "Cyclist (M)",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "MINNOW",
    "trainerClass": "Cyclist (F)",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "OREN",
    "trainerClass": "Cyclist (F)",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "BOBJIRO",
    "trainerClass": "Policeman",
    "pokemon": [
      "P 391",
      "P 394",
      "P 395",
      "P 397",
      "P 401",
      "P 407",
      "P 408",
      "P 409",
      "P 412",
      "P 420",
      "P 421",
      "P 436",
      "P 446",
      "P 447",
      "P 452",
      "P 455",
      "P 462",
      "P 466",
      "P 471"
    ]
  },
  {
    "name": "BOBYOSI",
    "trainerClass": "Policeman",
    "pokemon": [
      "P 391",
      "P 394",
      "P 395",
      "P 397",
      "P 401",
      "P 407",
      "P 408",
      "P 409",
      "P 412",
      "P 420",
      "P 421",
      "P 436",
      "P 446",
      "P 447",
      "P 452",
      "P 455",
      "P 462",
      "P 466",
      "P 471"
    ]
  },
  {
    "name": "VADIM",
    "trainerClass": "Clerk (M)",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "YURI",
    "trainerClass": "Clerk (M)",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "MOHAIR",
    "trainerClass": "Clerk (F)",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "VELOUR",
    "trainerClass": "Clerk (F)",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "KETMON",
    "trainerClass": "Janitor",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "NIDA",
    "trainerClass": "Janitor",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "CAMERON",
    "trainerClass": "Depot Agent",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "JACKIE",
    "trainerClass": "Depot Agent",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "ADENINE",
    "trainerClass": "Doctor",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "FRANK",
    "trainerClass": "Doctor",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "THYMINE",
    "trainerClass": "Doctor",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "KIKURI",
    "trainerClass": "Nurse",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "KUSHINA",
    "trainerClass": "Nurse",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "TOMATOE",
    "trainerClass": "Nurse",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "DANIIL",
    "trainerClass": "Pokemon Breeder (M)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "FEDOR",
    "trainerClass": "Pokemon Breeder (M)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "KATHY",
    "trainerClass": "Pokemon Breeder (F)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "SUE",
    "trainerClass": "Pokemon Breeder (F)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "ASHLEY",
    "trainerClass": "Socialite",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "JOICE",
    "trainerClass": "Socialite",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "BOYCE",
    "trainerClass": "Gentleman",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "DOVER",
    "trainerClass": "Gentleman",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "FLORIAN",
    "trainerClass": "Pilot",
    "pokemon": [
      "P 667",
      "P 674",
      "P 676",
      "P 677",
      "P 679",
      "P 682",
      "P 708",
      "P 715",
      "P 723",
      "P 726",
      "P 727",
      "P 729"
    ]
  },
  {
    "name": "PHYL",
    "trainerClass": "Pilot",
    "pokemon": [
      "P 667",
      "P 674",
      "P 676",
      "P 677",
      "P 679",
      "P 682",
      "P 708",
      "P 715",
      "P 723",
      "P 726",
      "P 727",
      "P 729"
    ]
  },
  {
    "name": "FAUST",
    "trainerClass": "Clerk (Executive)",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "ULFGANG",
    "trainerClass": "Clerk (Executive)",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "CHARIS",
    "trainerClass": "Scientist (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "LOTTE",
    "trainerClass": "Scientist (F)",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "THERESE",
    "trainerClass": "Scientist (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "SPACEY",
    "trainerClass": "Scientist (M)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "SHAN",
    "trainerClass": "Scientist (M)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "STUBS",
    "trainerClass": "Scientist (M)",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "BOLDBAT",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "KHAAN",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "SOLONGO",
    "trainerClass": "Psychic (M)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "LONGO",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "SAMBALA",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "ZAYA",
    "trainerClass": "Psychic (F)",
    "pokemon": [
      "P 751",
      "P 754",
      "P 755",
      "P 780",
      "P 784",
      "P 785",
      "P 788",
      "P 792",
      "P 795",
      "P 798",
      "P 799",
      "P 803",
      "P 804",
      "P 814",
      "P 819",
      "P 824",
      "P 834",
      "P 835",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 864",
      "P 868",
      "P 875",
      "P 905"
    ]
  },
  {
    "name": "ENPI",
    "trainerClass": "Black Belt",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "HARIMAO",
    "trainerClass": "Black Belt",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "UNSU",
    "trainerClass": "Black Belt",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "ACES",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "FLUSH",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "QUEENIE",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "P 735",
      "P 738",
      "P 741",
      "P 744",
      "P 745",
      "P 747",
      "P 751",
      "P 757",
      "P 758",
      "P 759",
      "P 762",
      "P 770",
      "P 771",
      "P 782",
      "P 786",
      "P 796",
      "P 797",
      "P 802",
      "P 805",
      "P 812",
      "P 816",
      "P 821",
      "P 822",
      "P 828",
      "P 829",
      "P 831",
      "P 835",
      "P 838",
      "P 839",
      "P 844",
      "P 845",
      "P 847",
      "P 859",
      "P 863",
      "P 864",
      "P 867",
      "P 872",
      "P 874",
      "P 876",
      "P 879",
      "P 884",
      "P 896",
      "P 899",
      "P 900",
      "P 905"
    ]
  },
  {
    "name": "MOUSE",
    "trainerClass": "Pokemon Ranger (M)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "SKYBLUE",
    "trainerClass": "Pokemon Ranger (M)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "SMOKEY",
    "trainerClass": "Pokemon Ranger (M)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "IVY",
    "trainerClass": "Pokemon Ranger (F)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "PAULA",
    "trainerClass": "Pokemon Ranger (F)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "TERRAN",
    "trainerClass": "Pokemon Ranger (F)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "GWEN",
    "trainerClass": "Ace Trainer (F)",
    "pokemon": [
      "P 823",
      "P 824",
      "P 826",
      "P 828",
      "P 829",
      "P 830",
      "P 835",
      "P 836",
      "P 839",
      "P 840",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 873",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 897",
      "P 899",
      "P 900",
      "P 901",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "MOOI",
    "trainerClass": "Ace Trainer (F)",
    "pokemon": [
      "P 736",
      "P 737",
      "P 739",
      "P 740",
      "P 742",
      "P 744",
      "P 745",
      "P 746",
      "P 751",
      "P 752",
      "P 759",
      "P 766",
      "P 767",
      "P 768",
      "P 771",
      "P 776",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 809",
      "P 815",
      "P 816",
      "P 819"
    ]
  },
  {
    "name": "PALM",
    "trainerClass": "Ace Trainer (F)",
    "pokemon": [
      "P 309",
      "P 326",
      "P 418",
      "P 447",
      "P 554",
      "P 578",
      "P 617",
      "P 671",
      "P 681",
      "P 718",
      "P 752",
      "P 767",
      "P 789",
      "P 791",
      "P 796",
      "P 890",
      "P 900",
      "P 976"
    ]
  },
  {
    "name": "DYLAN",
    "trainerClass": "Ace Trainer (M)",
    "pokemon": [
      "P 736",
      "P 737",
      "P 739",
      "P 740",
      "P 742",
      "P 744",
      "P 745",
      "P 746",
      "P 751",
      "P 752",
      "P 759",
      "P 766",
      "P 767",
      "P 768",
      "P 771",
      "P 776",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 809",
      "P 815",
      "P 816",
      "P 819"
    ]
  },
  {
    "name": "FARLEY",
    "trainerClass": "Ace Trainer (M)",
    "pokemon": [
      "P 823",
      "P 824",
      "P 826",
      "P 828",
      "P 829",
      "P 830",
      "P 835",
      "P 836",
      "P 839",
      "P 840",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 873",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 897",
      "P 899",
      "P 900",
      "P 901",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "REIGEL",
    "trainerClass": "Ace Trainer (M)",
    "pokemon": [
      "P 309",
      "P 326",
      "P 418",
      "P 447",
      "P 554",
      "P 578",
      "P 617",
      "P 671",
      "P 681",
      "P 718",
      "P 752",
      "P 767",
      "P 789",
      "P 791",
      "P 796",
      "P 890",
      "P 900",
      "P 976"
    ]
  },
  {
    "name": "COLOMBO",
    "trainerClass": "Veteran (M)",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "DONTA",
    "trainerClass": "Veteran (M)",
    "pokemon": [
      "P 823",
      "P 824",
      "P 826",
      "P 828",
      "P 829",
      "P 830",
      "P 835",
      "P 836",
      "P 839",
      "P 840",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 873",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 897",
      "P 899",
      "P 900",
      "P 901",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "LERON",
    "trainerClass": "Veteran (M)",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "PONTA",
    "trainerClass": "Veteran (M)",
    "pokemon": [
      "P 823",
      "P 824",
      "P 826",
      "P 828",
      "P 829",
      "P 830",
      "P 835",
      "P 836",
      "P 839",
      "P 840",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 873",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 897",
      "P 899",
      "P 900",
      "P 901",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "GINGER",
    "trainerClass": "Veteran (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "HECATE",
    "trainerClass": "Veteran (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "JEUNE",
    "trainerClass": "Veteran (F)",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "RISHA",
    "trainerClass": "Veteran (F)",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "CEDRIC",
    "trainerClass": "Backpacker (M)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "FELTON",
    "trainerClass": "Backpacker (M)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "SIMONE",
    "trainerClass": "Backpacker (F)",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 224",
      "P 225",
      "P 226",
      "P 227",
      "P 228",
      "P 229",
      "P 230",
      "P 231",
      "P 232",
      "P 233",
      "P 234",
      "P 235",
      "P 236",
      "P 237",
      "P 238",
      "P 239",
      "P 240",
      "P 241",
      "P 242",
      "P 243",
      "P 244",
      "P 245",
      "P 246",
      "P 247",
      "P 248",
      "P 249",
      "P 250",
      "P 251",
      "P 252",
      "P 253",
      "P 254",
      "P 255",
      "P 256",
      "P 257",
      "P 258",
      "P 259",
      "P 260",
      "P 261",
      "P 262",
      "P 263",
      "P 264",
      "P 265",
      "P 266",
      "P 267",
      "P 268",
      "P 269",
      "P 270",
      "P 271",
      "P 272",
      "P 273",
      "P 274",
      "P 275",
      "P 276",
      "P 277",
      "P 278",
      "P 279",
      "P 280",
      "P 281",
      "P 282",
      "P 283",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 288",
      "P 289",
      "P 290",
      "P 291",
      "P 292",
      "P 293",
      "P 294",
      "P 295",
      "P 296"
    ]
  },
  {
    "name": "WALD",
    "trainerClass": "Backpacker (F)",
    "pokemon": [
      "P 297",
      "P 298",
      "P 299",
      "P 300",
      "P 301",
      "P 302",
      "P 303",
      "P 304",
      "P 305",
      "P 306",
      "P 307",
      "P 308",
      "P 309",
      "P 310",
      "P 311",
      "P 312",
      "P 313",
      "P 314",
      "P 315",
      "P 316",
      "P 317",
      "P 318",
      "P 319",
      "P 320",
      "P 321",
      "P 322",
      "P 323",
      "P 324",
      "P 325",
      "P 326",
      "P 327",
      "P 328",
      "P 329",
      "P 330",
      "P 331",
      "P 332",
      "P 333",
      "P 334",
      "P 335",
      "P 336",
      "P 337",
      "P 338",
      "P 339",
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 347",
      "P 348",
      "P 349",
      "P 350",
      "P 351",
      "P 352",
      "P 353",
      "P 354",
      "P 355",
      "P 356",
      "P 357",
      "P 358",
      "P 359",
      "P 360",
      "P 361",
      "P 362",
      "P 363",
      "P 364",
      "P 365",
      "P 366",
      "P 367",
      "P 368",
      "P 369",
      "P 370",
      "P 371",
      "P 372",
      "P 373",
      "P 374",
      "P 375",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 383"
    ]
  },
  {
    "name": "GONYAN",
    "trainerClass": "Waiter",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "HASAN",
    "trainerClass": "Waiter",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "AMBER",
    "trainerClass": "Waitress",
    "pokemon": [
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 399",
      "P 400",
      "P 401",
      "P 402",
      "P 403",
      "P 404",
      "P 405",
      "P 406",
      "P 407",
      "P 408",
      "P 409",
      "P 410",
      "P 411",
      "P 412",
      "P 413",
      "P 414",
      "P 415",
      "P 416",
      "P 417",
      "P 418",
      "P 419",
      "P 420",
      "P 421",
      "P 422",
      "P 423",
      "P 424",
      "P 425",
      "P 426",
      "P 427",
      "P 428",
      "P 429",
      "P 430",
      "P 431",
      "P 432",
      "P 433",
      "P 434",
      "P 435",
      "P 436",
      "P 437",
      "P 438",
      "P 439",
      "P 440",
      "P 441",
      "P 442",
      "P 443",
      "P 444",
      "P 445",
      "P 446",
      "P 447",
      "P 448",
      "P 449",
      "P 450",
      "P 451",
      "P 452",
      "P 453",
      "P 454",
      "P 455",
      "P 456",
      "P 457",
      "P 458",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 463",
      "P 464",
      "P 465",
      "P 466",
      "P 467",
      "P 468",
      "P 469",
      "P 470",
      "P 471"
    ]
  },
  {
    "name": "ROE",
    "trainerClass": "Waitress",
    "pokemon": [
      "P 472",
      "P 473",
      "P 474",
      "P 475",
      "P 476",
      "P 477",
      "P 478",
      "P 479",
      "P 480",
      "P 481",
      "P 482",
      "P 483",
      "P 484",
      "P 485",
      "P 486",
      "P 487",
      "P 488",
      "P 489",
      "P 490",
      "P 491",
      "P 492",
      "P 493",
      "P 494",
      "P 495",
      "P 496",
      "P 497",
      "P 498",
      "P 499",
      "P 500",
      "P 501",
      "P 502",
      "P 503",
      "P 504",
      "P 505",
      "P 506",
      "P 507",
      "P 508",
      "P 509",
      "P 510",
      "P 511",
      "P 512",
      "P 513",
      "P 514",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 522",
      "P 523",
      "P 524",
      "P 525",
      "P 526",
      "P 527",
      "P 528",
      "P 529",
      "P 530",
      "P 531",
      "P 532",
      "P 533",
      "P 534",
      "P 535",
      "P 536",
      "P 537",
      "P 538",
      "P 539",
      "P 540",
      "P 541",
      "P 542",
      "P 543",
      "P 544",
      "P 545",
      "P 546",
      "P 547",
      "P 548",
      "P 549",
      "P 550",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 558"
    ]
  },
  {
    "name": "JORGE",
    "trainerClass": "Hiker",
    "pokemon": [
      "P 217",
      "P 218",
      "P 224",
      "P 225",
      "P 227",
      "P 236",
      "P 243",
      "P 260",
      "P 262",
      "P 282",
      "P 283",
      "P 295",
      "P 307",
      "P 309",
      "P 320",
      "P 321",
      "P 322",
      "P 324",
      "P 337",
      "P 348",
      "P 356",
      "P 360",
      "P 381",
      "P 392",
      "P 393",
      "P 399",
      "P 400",
      "P 402",
      "P 411",
      "P 418",
      "P 435",
      "P 437",
      "P 457",
      "P 458",
      "P 470",
      "P 482",
      "P 484",
      "P 495",
      "P 496",
      "P 497",
      "P 499",
      "P 512",
      "P 523",
      "P 531",
      "P 535",
      "P 556",
      "P 567",
      "P 568",
      "P 574",
      "P 575",
      "P 577",
      "P 586",
      "P 593",
      "P 610",
      "P 612",
      "P 632",
      "P 633",
      "P 645",
      "P 657",
      "P 659",
      "P 670",
      "P 671",
      "P 672",
      "P 674",
      "P 687",
      "P 698",
      "P 706",
      "P 710",
      "P 731",
      "P 742",
      "P 743",
      "P 749",
      "P 750",
      "P 752",
      "P 761",
      "P 768",
      "P 785",
      "P 787",
      "P 807",
      "P 808",
      "P 820",
      "P 832",
      "P 834",
      "P 845",
      "P 846",
      "P 847",
      "P 849",
      "P 862",
      "P 873",
      "P 881",
      "P 885",
      "P 906"
    ]
  },
  {
    "name": "KEMUEL",
    "trainerClass": "Hiker",
    "pokemon": [
      "P 262",
      "P 284",
      "P 285",
      "P 286",
      "P 287",
      "P 290",
      "P 315",
      "P 318",
      "P 329",
      "P 349",
      "P 354",
      "P 360",
      "P 376",
      "P 378",
      "P 437",
      "P 459",
      "P 460",
      "P 461",
      "P 462",
      "P 465",
      "P 490",
      "P 493",
      "P 504",
      "P 524",
      "P 529",
      "P 535",
      "P 551",
      "P 553",
      "P 612",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 640",
      "P 665",
      "P 668",
      "P 679",
      "P 699",
      "P 704",
      "P 710",
      "P 726",
      "P 728",
      "P 787",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 815",
      "P 840",
      "P 843",
      "P 854",
      "P 874",
      "P 879",
      "P 885",
      "P 901",
      "P 903"
    ]
  },
  {
    "name": "FIRD",
    "trainerClass": "Fisherman",
    "pokemon": [
      "P 561",
      "P 564",
      "P 567",
      "P 570",
      "P 573",
      "P 577",
      "P 581",
      "P 586",
      "P 590",
      "P 593",
      "P 601",
      "P 613",
      "P 624",
      "P 638",
      "P 640",
      "P 645",
      "P 646",
      "P 651",
      "P 658",
      "P 678",
      "P 686",
      "P 690",
      "P 705",
      "P 707",
      "P 713",
      "P 715",
      "P 717",
      "P 719",
      "P 736",
      "P 739",
      "P 742",
      "P 745",
      "P 748",
      "P 752",
      "P 756",
      "P 761",
      "P 765",
      "P 768",
      "P 776",
      "P 788",
      "P 799",
      "P 813",
      "P 815",
      "P 820",
      "P 821",
      "P 826",
      "P 833",
      "P 853",
      "P 861",
      "P 865",
      "P 880",
      "P 882",
      "P 888",
      "P 890",
      "P 892",
      "P 894"
    ]
  },
  {
    "name": "HUMFREY",
    "trainerClass": "Fisherman",
    "pokemon": [
      "P 211",
      "P 214",
      "P 217",
      "P 220",
      "P 223",
      "P 227",
      "P 231",
      "P 236",
      "P 240",
      "P 243",
      "P 251",
      "P 263",
      "P 274",
      "P 288",
      "P 290",
      "P 295",
      "P 296",
      "P 301",
      "P 308",
      "P 328",
      "P 336",
      "P 340",
      "P 355",
      "P 357",
      "P 363",
      "P 365",
      "P 367",
      "P 369",
      "P 386",
      "P 389",
      "P 392",
      "P 395",
      "P 398",
      "P 402",
      "P 406",
      "P 411",
      "P 415",
      "P 418",
      "P 426",
      "P 438",
      "P 449",
      "P 463",
      "P 465",
      "P 470",
      "P 471",
      "P 476",
      "P 483",
      "P 503",
      "P 511",
      "P 515",
      "P 530",
      "P 532",
      "P 538",
      "P 540",
      "P 542",
      "P 544"
    ]
  },
  {
    "name": "HILARY",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "P 243",
      "P 251",
      "P 288",
      "P 295",
      "P 340",
      "P 357",
      "P 367",
      "P 369",
      "P 426",
      "P 463",
      "P 468",
      "P 470",
      "P 516",
      "P 532",
      "P 542",
      "P 570",
      "P 581",
      "P 586",
      "P 590",
      "P 593",
      "P 601",
      "P 613",
      "P 614",
      "P 638",
      "P 640",
      "P 645",
      "P 678",
      "P 686",
      "P 691",
      "P 705",
      "P 707",
      "P 717",
      "P 745",
      "P 765",
      "P 766",
      "P 775",
      "P 776",
      "P 788",
      "P 799",
      "P 813",
      "P 820",
      "P 825",
      "P 861",
      "P 865",
      "P 892",
      "P 894"
    ]
  },
  {
    "name": "VANNA",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "P 243",
      "P 251",
      "P 288",
      "P 295",
      "P 340",
      "P 357",
      "P 367",
      "P 369",
      "P 426",
      "P 463",
      "P 468",
      "P 470",
      "P 516",
      "P 532",
      "P 542",
      "P 570",
      "P 581",
      "P 586",
      "P 590",
      "P 593",
      "P 601",
      "P 613",
      "P 614",
      "P 638",
      "P 640",
      "P 645",
      "P 678",
      "P 686",
      "P 691",
      "P 705",
      "P 707",
      "P 717",
      "P 745",
      "P 765",
      "P 766",
      "P 775",
      "P 776",
      "P 788",
      "P 799",
      "P 813",
      "P 820",
      "P 825",
      "P 861",
      "P 865",
      "P 892",
      "P 894"
    ]
  },
  {
    "name": "GANYMED",
    "trainerClass": "Roughneck",
    "pokemon": [
      "P 618",
      "P 637",
      "P 647",
      "P 706",
      "P 710",
      "P 713",
      "P 761",
      "P 827",
      "P 832",
      "P 833",
      "P 849",
      "P 880"
    ]
  },
  {
    "name": "PROTEUS",
    "trainerClass": "Roughneck",
    "pokemon": [
      "P 618",
      "P 637",
      "P 647",
      "P 706",
      "P 710",
      "P 713",
      "P 761",
      "P 827",
      "P 832",
      "P 833",
      "P 849",
      "P 880"
    ]
  },
  {
    "name": "PETRO",
    "trainerClass": "Biker",
    "pokemon": [
      "P 219",
      "P 267",
      "P 291",
      "P 310",
      "P 323",
      "P 332",
      "P 336",
      "P 365",
      "P 368",
      "P 372",
      "P 373",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 394",
      "P 442",
      "P 466",
      "P 485",
      "P 498",
      "P 507",
      "P 511",
      "P 540",
      "P 543",
      "P 547",
      "P 548",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 569",
      "P 617",
      "P 641",
      "P 660",
      "P 673",
      "P 682",
      "P 686",
      "P 715",
      "P 718",
      "P 722",
      "P 723",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 744",
      "P 792",
      "P 816",
      "P 835",
      "P 848",
      "P 857",
      "P 861",
      "P 890",
      "P 893",
      "P 897",
      "P 898",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "PHILIPO",
    "trainerClass": "Biker",
    "pokemon": [
      "P 219",
      "P 267",
      "P 291",
      "P 310",
      "P 323",
      "P 332",
      "P 336",
      "P 365",
      "P 368",
      "P 372",
      "P 373",
      "P 376",
      "P 377",
      "P 378",
      "P 379",
      "P 380",
      "P 381",
      "P 382",
      "P 394",
      "P 442",
      "P 466",
      "P 485",
      "P 498",
      "P 507",
      "P 511",
      "P 540",
      "P 543",
      "P 547",
      "P 548",
      "P 551",
      "P 552",
      "P 553",
      "P 554",
      "P 555",
      "P 556",
      "P 557",
      "P 569",
      "P 617",
      "P 641",
      "P 660",
      "P 673",
      "P 682",
      "P 686",
      "P 715",
      "P 718",
      "P 722",
      "P 723",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 744",
      "P 792",
      "P 816",
      "P 835",
      "P 848",
      "P 857",
      "P 861",
      "P 890",
      "P 893",
      "P 897",
      "P 898",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907"
    ]
  },
  {
    "name": "JUDY",
    "trainerClass": "Baker",
    "pokemon": [
      "P 212",
      "P 213",
      "P 248",
      "P 249",
      "P 252",
      "P 256",
      "P 335",
      "P 361",
      "P 374",
      "P 375",
      "P 423",
      "P 424",
      "P 427",
      "P 431",
      "P 472",
      "P 510",
      "P 536",
      "P 598",
      "P 599",
      "P 602",
      "P 606",
      "P 685",
      "P 695",
      "P 711",
      "P 725",
      "P 738",
      "P 773",
      "P 774",
      "P 777",
      "P 781",
      "P 831",
      "P 860",
      "P 886"
    ]
  },
  {
    "name": "VESPERA",
    "trainerClass": "Baker",
    "pokemon": [
      "P 212",
      "P 213",
      "P 248",
      "P 249",
      "P 252",
      "P 256",
      "P 335",
      "P 361",
      "P 374",
      "P 375",
      "P 423",
      "P 424",
      "P 427",
      "P 431",
      "P 472",
      "P 510",
      "P 536",
      "P 598",
      "P 599",
      "P 602",
      "P 606",
      "P 685",
      "P 695",
      "P 711",
      "P 725",
      "P 738",
      "P 773",
      "P 774",
      "P 777",
      "P 781",
      "P 831",
      "P 860",
      "P 886"
    ]
  },
  {
    "name": "ARAMIS",
    "trainerClass": "Harlequin",
    "pokemon": [
      "P 252",
      "P 274",
      "P 310",
      "P 378",
      "P 400",
      "P 402",
      "P 445",
      "P 454",
      "P 470",
      "P 494",
      "P 525",
      "P 583",
      "P 587",
      "P 609",
      "P 785",
      "P 787",
      "P 788",
      "P 811",
      "P 835",
      "P 843",
      "P 844",
      "P 847",
      "P 860",
      "P 873",
      "P 875",
      "P 885"
    ]
  },
  {
    "name": "ATHOS",
    "trainerClass": "Harlequin",
    "pokemon": [
      "P 252",
      "P 274",
      "P 310",
      "P 378",
      "P 400",
      "P 402",
      "P 445",
      "P 454",
      "P 470",
      "P 494",
      "P 525",
      "P 583",
      "P 587",
      "P 609",
      "P 785",
      "P 787",
      "P 788",
      "P 811",
      "P 835",
      "P 843",
      "P 844",
      "P 847",
      "P 860",
      "P 873",
      "P 875",
      "P 885"
    ]
  },
  {
    "name": "ANGUILE",
    "trainerClass": "Maid",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748"
    ]
  },
  {
    "name": "FESAN",
    "trainerClass": "Maid",
    "pokemon": [
      "P 209",
      "P 210",
      "P 211",
      "P 212",
      "P 213",
      "P 214",
      "P 215",
      "P 216",
      "P 217",
      "P 218",
      "P 219",
      "P 220",
      "P 221",
      "P 222",
      "P 223",
      "P 384",
      "P 385",
      "P 386",
      "P 387",
      "P 388",
      "P 389",
      "P 390",
      "P 391",
      "P 392",
      "P 393",
      "P 394",
      "P 395",
      "P 396",
      "P 397",
      "P 398",
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748"
    ]
  },
  {
    "name": "HACIKAN",
    "trainerClass": "Painter",
    "pokemon": [
      "P 233",
      "P 267",
      "P 294",
      "P 309",
      "P 310",
      "P 330",
      "P 336",
      "P 338",
      "P 349",
      "P 359",
      "P 362",
      "P 380",
      "P 408",
      "P 442",
      "P 469",
      "P 484",
      "P 485",
      "P 505",
      "P 511",
      "P 513",
      "P 524",
      "P 534",
      "P 537",
      "P 555",
      "P 583",
      "P 617",
      "P 644",
      "P 659",
      "P 660",
      "P 680",
      "P 686",
      "P 688",
      "P 699",
      "P 709",
      "P 712",
      "P 730",
      "P 758",
      "P 792",
      "P 819",
      "P 834",
      "P 835",
      "P 855",
      "P 861",
      "P 863",
      "P 874",
      "P 884",
      "P 887",
      "P 905"
    ]
  },
  {
    "name": "RIKKYU",
    "trainerClass": "Painter",
    "pokemon": [
      "P 233",
      "P 267",
      "P 294",
      "P 309",
      "P 310",
      "P 330",
      "P 336",
      "P 338",
      "P 349",
      "P 359",
      "P 362",
      "P 380",
      "P 408",
      "P 442",
      "P 469",
      "P 484",
      "P 485",
      "P 505",
      "P 511",
      "P 513",
      "P 524",
      "P 534",
      "P 537",
      "P 555",
      "P 583",
      "P 617",
      "P 644",
      "P 659",
      "P 660",
      "P 680",
      "P 686",
      "P 688",
      "P 699",
      "P 709",
      "P 712",
      "P 730",
      "P 758",
      "P 792",
      "P 819",
      "P 834",
      "P 835",
      "P 855",
      "P 861",
      "P 863",
      "P 874",
      "P 884",
      "P 887",
      "P 905"
    ]
  },
  {
    "name": "CHACHI",
    "trainerClass": "Nursery Aide",
    "pokemon": [
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871"
    ]
  },
  {
    "name": "EVELYN",
    "trainerClass": "Nursery Aide",
    "pokemon": [
      "P 340",
      "P 341",
      "P 342",
      "P 343",
      "P 344",
      "P 345",
      "P 346",
      "P 515",
      "P 516",
      "P 517",
      "P 518",
      "P 519",
      "P 520",
      "P 521",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871"
    ]
  },
  {
    "name": "ROMAN",
    "trainerClass": "Worker (Ice)",
    "pokemon": [
      "P 240",
      "P 255",
      "P 346",
      "P 352",
      "P 355",
      "P 356",
      "P 363",
      "P 430",
      "P 456",
      "P 521",
      "P 527",
      "P 530",
      "P 531",
      "P 538",
      "P 579",
      "P 605",
      "P 618",
      "P 631",
      "P 696",
      "P 702",
      "P 705",
      "P 706",
      "P 713",
      "P 754",
      "P 780",
      "P 793",
      "P 806",
      "P 871",
      "P 877",
      "P 880",
      "P 881",
      "P 888"
    ]
  },
  {
    "name": "VALERY",
    "trainerClass": "Worker (Ice)",
    "pokemon": [
      "P 240",
      "P 255",
      "P 346",
      "P 352",
      "P 355",
      "P 356",
      "P 363",
      "P 430",
      "P 456",
      "P 521",
      "P 527",
      "P 530",
      "P 531",
      "P 538",
      "P 579",
      "P 605",
      "P 618",
      "P 631",
      "P 696",
      "P 702",
      "P 705",
      "P 706",
      "P 713",
      "P 754",
      "P 780",
      "P 793",
      "P 806",
      "P 871",
      "P 877",
      "P 880",
      "P 881",
      "P 888"
    ]
  },
  {
    "name": "HAYES",
    "trainerClass": "Worker",
    "pokemon": [
      "P 218",
      "P 272",
      "P 315",
      "P 320",
      "P 348",
      "P 378",
      "P 381",
      "P 484",
      "P 493",
      "P 495",
      "P 523",
      "P 553",
      "P 593",
      "P 634",
      "P 637",
      "P 668",
      "P 670",
      "P 679",
      "P 698",
      "P 728",
      "P 749",
      "P 812",
      "P 840",
      "P 845",
      "P 873",
      "P 903",
      "P 915",
      "P 927",
      "P 979"
    ]
  },
  {
    "name": "QUINN",
    "trainerClass": "Worker",
    "pokemon": [
      "P 218",
      "P 272",
      "P 315",
      "P 320",
      "P 348",
      "P 378",
      "P 381",
      "P 484",
      "P 493",
      "P 495",
      "P 523",
      "P 553",
      "P 593",
      "P 634",
      "P 668",
      "P 670",
      "P 698",
      "P 728",
      "P 749",
      "P 840",
      "P 845",
      "P 873",
      "P 903"
    ]
  },
  {
    "name": "DANTE",
    "trainerClass": "Cyclist (M)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "MARION",
    "trainerClass": "Cyclist (M)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "BIRGIT",
    "trainerClass": "Cyclist (F)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "MARGIT",
    "trainerClass": "Cyclist (F)",
    "pokemon": [
      "P 559",
      "P 560",
      "P 561",
      "P 562",
      "P 563",
      "P 564",
      "P 565",
      "P 566",
      "P 567",
      "P 568",
      "P 569",
      "P 570",
      "P 571",
      "P 572",
      "P 573",
      "P 574",
      "P 575",
      "P 576",
      "P 577",
      "P 578",
      "P 579",
      "P 580",
      "P 581",
      "P 582",
      "P 583",
      "P 584",
      "P 585",
      "P 586",
      "P 587",
      "P 588",
      "P 589",
      "P 590",
      "P 591",
      "P 592",
      "P 593",
      "P 594",
      "P 595",
      "P 596",
      "P 597",
      "P 598",
      "P 599",
      "P 600",
      "P 601",
      "P 602",
      "P 603",
      "P 604",
      "P 605",
      "P 606",
      "P 607",
      "P 608",
      "P 609",
      "P 610",
      "P 611",
      "P 612",
      "P 613",
      "P 614",
      "P 615",
      "P 616",
      "P 617",
      "P 618",
      "P 619",
      "P 620",
      "P 621",
      "P 622",
      "P 623",
      "P 624",
      "P 625",
      "P 626",
      "P 627",
      "P 628",
      "P 629",
      "P 630",
      "P 631",
      "P 632",
      "P 633",
      "P 634",
      "P 635",
      "P 636",
      "P 637",
      "P 638",
      "P 639",
      "P 640",
      "P 641",
      "P 642",
      "P 643",
      "P 644",
      "P 645",
      "P 646"
    ]
  },
  {
    "name": "BANK",
    "trainerClass": "Clerk (M)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "ELWIN",
    "trainerClass": "Clerk (M)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "BOBEMON",
    "trainerClass": "Policeman",
    "pokemon": [
      "P 209",
      "P 238",
      "P 240",
      "P 246",
      "P 251",
      "P 267",
      "P 272",
      "P 281",
      "P 316",
      "P 326",
      "P 344",
      "P 350",
      "P 361",
      "P 368",
      "P 377",
      "P 431",
      "P 484",
      "P 544",
      "P 593",
      "P 598",
      "P 601",
      "P 606",
      "P 613",
      "P 617",
      "P 634",
      "P 637",
      "P 658",
      "P 690",
      "P 700",
      "P 718",
      "P 734",
      "P 737",
      "P 740",
      "P 743",
      "P 749",
      "P 752",
      "P 753",
      "P 757",
      "P 759",
      "P 768",
      "P 772",
      "P 776",
      "P 781",
      "P 784",
      "P 789",
      "P 791",
      "P 796",
      "P 797",
      "P 809",
      "P 840",
      "P 843",
      "P 851",
      "P 864",
      "P 893",
      "P 894"
    ]
  },
  {
    "name": "BOBNORI",
    "trainerClass": "Policeman",
    "pokemon": [
      "P 209",
      "P 238",
      "P 240",
      "P 246",
      "P 251",
      "P 267",
      "P 272",
      "P 281",
      "P 316",
      "P 326",
      "P 344",
      "P 350",
      "P 361",
      "P 368",
      "P 377",
      "P 431",
      "P 484",
      "P 544",
      "P 593",
      "P 598",
      "P 601",
      "P 606",
      "P 613",
      "P 617",
      "P 634",
      "P 637",
      "P 658",
      "P 690",
      "P 700",
      "P 718",
      "P 734",
      "P 737",
      "P 740",
      "P 743",
      "P 749",
      "P 752",
      "P 753",
      "P 757",
      "P 759",
      "P 768",
      "P 772",
      "P 776",
      "P 781",
      "P 784",
      "P 789",
      "P 791",
      "P 796",
      "P 797",
      "P 809",
      "P 840",
      "P 843",
      "P 851",
      "P 864",
      "P 893",
      "P 894"
    ]
  },
  {
    "name": "ERIC",
    "trainerClass": "Janitor",
    "pokemon": [
      "P 212",
      "P 232",
      "P 237",
      "P 250",
      "P 270",
      "P 275",
      "P 281",
      "P 282",
      "P 301",
      "P 315",
      "P 335",
      "P 340",
      "P 341",
      "P 346",
      "P 373",
      "P 426",
      "P 427",
      "P 465",
      "P 485",
      "P 487",
      "P 507",
      "P 508",
      "P 512",
      "P 552",
      "P 560",
      "P 562",
      "P 563",
      "P 570",
      "P 581",
      "P 586",
      "P 590",
      "P 605",
      "P 628",
      "P 631",
      "P 639",
      "P 694",
      "P 745",
      "P 754",
      "P 755",
      "P 760",
      "P 775",
      "P 780",
      "P 806",
      "P 835",
      "P 853",
      "P 871",
      "P 872",
      "P 877",
      "P 892",
      "P 898",
      "P 949",
      "P 953",
      "P 954",
      "P 966",
      "P 969",
      "P 970",
      "P 971",
      "P 974",
      "P 982"
    ]
  },
  {
    "name": "OSCAR",
    "trainerClass": "Janitor",
    "pokemon": [
      "P 212",
      "P 232",
      "P 237",
      "P 250",
      "P 270",
      "P 275",
      "P 281",
      "P 282",
      "P 301",
      "P 315",
      "P 335",
      "P 340",
      "P 341",
      "P 346",
      "P 373",
      "P 426",
      "P 427",
      "P 465",
      "P 485",
      "P 487",
      "P 507",
      "P 508",
      "P 512",
      "P 552",
      "P 560",
      "P 562",
      "P 563",
      "P 570",
      "P 581",
      "P 586",
      "P 590",
      "P 605",
      "P 628",
      "P 631",
      "P 639",
      "P 694",
      "P 745",
      "P 754",
      "P 755",
      "P 760",
      "P 775",
      "P 780",
      "P 806",
      "P 835",
      "P 853",
      "P 871",
      "P 872",
      "P 877",
      "P 892",
      "P 898",
      "P 949",
      "P 953",
      "P 954",
      "P 966",
      "P 969",
      "P 970",
      "P 971",
      "P 974",
      "P 982"
    ]
  },
  {
    "name": "ISADORE",
    "trainerClass": "Depot Agent",
    "pokemon": [
      "P 239",
      "P 241",
      "P 250",
      "P 261",
      "P 293",
      "P 338",
      "P 341",
      "P 347",
      "P 370",
      "P 414",
      "P 416",
      "P 425",
      "P 436",
      "P 468",
      "P 513",
      "P 516",
      "P 522",
      "P 545",
      "P 581",
      "P 591",
      "P 600",
      "P 611",
      "P 643",
      "P 688",
      "P 691",
      "P 697",
      "P 720",
      "P 764",
      "P 766",
      "P 775",
      "P 786",
      "P 818",
      "P 863",
      "P 866",
      "P 872",
      "P 895"
    ]
  },
  {
    "name": "RAMSES",
    "trainerClass": "Depot Agent",
    "pokemon": [
      "P 239",
      "P 241",
      "P 250",
      "P 261",
      "P 293",
      "P 338",
      "P 341",
      "P 347",
      "P 370",
      "P 414",
      "P 416",
      "P 425",
      "P 436",
      "P 468",
      "P 513",
      "P 516",
      "P 522",
      "P 545",
      "P 581",
      "P 591",
      "P 600",
      "P 611",
      "P 643",
      "P 688",
      "P 691",
      "P 697",
      "P 720",
      "P 764",
      "P 766",
      "P 775",
      "P 786",
      "P 818",
      "P 863",
      "P 866",
      "P 872",
      "P 895"
    ]
  },
  {
    "name": "ANETTE",
    "trainerClass": "Clerk (F)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "ANORA",
    "trainerClass": "Clerk (F)",
    "pokemon": [
      "P 647",
      "P 648",
      "P 649",
      "P 650",
      "P 651",
      "P 652",
      "P 653",
      "P 654",
      "P 655",
      "P 656",
      "P 657",
      "P 658",
      "P 659",
      "P 660",
      "P 661",
      "P 662",
      "P 663",
      "P 664",
      "P 665",
      "P 666",
      "P 667",
      "P 668",
      "P 669",
      "P 670",
      "P 671",
      "P 672",
      "P 673",
      "P 674",
      "P 675",
      "P 676",
      "P 677",
      "P 678",
      "P 679",
      "P 680",
      "P 681",
      "P 682",
      "P 683",
      "P 684",
      "P 685",
      "P 686",
      "P 687",
      "P 688",
      "P 689",
      "P 690",
      "P 691",
      "P 692",
      "P 693",
      "P 694",
      "P 695",
      "P 696",
      "P 697",
      "P 698",
      "P 699",
      "P 700",
      "P 701",
      "P 702",
      "P 703",
      "P 704",
      "P 705",
      "P 706",
      "P 707",
      "P 708",
      "P 709",
      "P 710",
      "P 711",
      "P 712",
      "P 713",
      "P 714",
      "P 715",
      "P 716",
      "P 717",
      "P 718",
      "P 719",
      "P 720",
      "P 721",
      "P 722",
      "P 723",
      "P 724",
      "P 725",
      "P 726",
      "P 727",
      "P 728",
      "P 729",
      "P 730",
      "P 731",
      "P 732",
      "P 733"
    ]
  },
  {
    "name": "DWIGHT",
    "trainerClass": "Doctor",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "LEVANT",
    "trainerClass": "Doctor",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "PANARAT",
    "trainerClass": "Nurse",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "SAISUNE",
    "trainerClass": "Nurse",
    "pokemon": [
      "P 734",
      "P 735",
      "P 736",
      "P 737",
      "P 738",
      "P 739",
      "P 740",
      "P 741",
      "P 742",
      "P 743",
      "P 744",
      "P 745",
      "P 746",
      "P 747",
      "P 748",
      "P 749",
      "P 750",
      "P 751",
      "P 752",
      "P 753",
      "P 754",
      "P 755",
      "P 756",
      "P 757",
      "P 758",
      "P 759",
      "P 760",
      "P 761",
      "P 762",
      "P 763",
      "P 764",
      "P 765",
      "P 766",
      "P 767",
      "P 768",
      "P 769",
      "P 770",
      "P 771",
      "P 772",
      "P 773",
      "P 774",
      "P 775",
      "P 776",
      "P 777",
      "P 778",
      "P 779",
      "P 780",
      "P 781",
      "P 782",
      "P 783",
      "P 784",
      "P 785",
      "P 786",
      "P 787",
      "P 788",
      "P 789",
      "P 790",
      "P 791",
      "P 792",
      "P 793",
      "P 794",
      "P 795",
      "P 796",
      "P 797",
      "P 798",
      "P 799",
      "P 800",
      "P 801",
      "P 802",
      "P 803",
      "P 804",
      "P 805",
      "P 806",
      "P 807",
      "P 808",
      "P 809",
      "P 810",
      "P 811",
      "P 812",
      "P 813",
      "P 814",
      "P 815",
      "P 816",
      "P 817",
      "P 818",
      "P 819",
      "P 820",
      "P 821"
    ]
  },
  {
    "name": "EOIN",
    "trainerClass": "Pokemon Breeder (M)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "MANFORD",
    "trainerClass": "Pokemon Breeder (M)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "JANET",
    "trainerClass": "Pokemon Breeder (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "SHAWNA",
    "trainerClass": "Pokemon Breeder (F)",
    "pokemon": [
      "P 822",
      "P 823",
      "P 824",
      "P 825",
      "P 826",
      "P 827",
      "P 828",
      "P 829",
      "P 830",
      "P 831",
      "P 832",
      "P 833",
      "P 834",
      "P 835",
      "P 836",
      "P 837",
      "P 838",
      "P 839",
      "P 840",
      "P 841",
      "P 842",
      "P 843",
      "P 844",
      "P 845",
      "P 846",
      "P 847",
      "P 848",
      "P 849",
      "P 850",
      "P 851",
      "P 852",
      "P 853",
      "P 854",
      "P 855",
      "P 856",
      "P 857",
      "P 858",
      "P 859",
      "P 860",
      "P 861",
      "P 862",
      "P 863",
      "P 864",
      "P 865",
      "P 866",
      "P 867",
      "P 868",
      "P 869",
      "P 870",
      "P 871",
      "P 872",
      "P 873",
      "P 874",
      "P 875",
      "P 876",
      "P 877",
      "P 878",
      "P 879",
      "P 880",
      "P 881",
      "P 882",
      "P 883",
      "P 884",
      "P 885",
      "P 886",
      "P 887",
      "P 888",
      "P 889",
      "P 890",
      "P 891",
      "P 892",
      "P 893",
      "P 894",
      "P 895",
      "P 896",
      "P 897",
      "P 898",
      "P 899",
      "P 900",
      "P 901",
      "P 902",
      "P 903",
      "P 904",
      "P 905",
      "P 906",
      "P 907",
      "P 908"
    ]
  },
  {
    "name": "APARNA",
    "trainerClass": "Socialite",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "SATY",
    "trainerClass": "Socialite",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "CAMUS",
    "trainerClass": "Gentleman",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "KAVAN",
    "trainerClass": "Gentleman",
    "pokemon": [
      "P 909",
      "P 910",
      "P 911",
      "P 912",
      "P 913",
      "P 914",
      "P 915",
      "P 916",
      "P 917",
      "P 918",
      "P 919",
      "P 920",
      "P 921",
      "P 922",
      "P 923",
      "P 924",
      "P 925",
      "P 926",
      "P 927",
      "P 928",
      "P 929",
      "P 930",
      "P 931",
      "P 932",
      "P 933",
      "P 934",
      "P 935",
      "P 936",
      "P 937",
      "P 938",
      "P 939",
      "P 940",
      "P 941",
      "P 942",
      "P 943",
      "P 944",
      "P 945",
      "P 946",
      "P 947",
      "P 948",
      "P 949",
      "P 950",
      "P 951",
      "P 952",
      "P 953",
      "P 954",
      "P 955",
      "P 956",
      "P 957",
      "P 958",
      "P 959",
      "P 960",
      "P 961",
      "P 962",
      "P 963",
      "P 964",
      "P 965",
      "P 966",
      "P 967",
      "P 968",
      "P 969",
      "P 970",
      "P 971",
      "P 972",
      "P 973",
      "P 974",
      "P 975",
      "P 976",
      "P 977",
      "P 978",
      "P 979",
      "P 980",
      "P 981",
      "P 982",
      "P 983",
      "P 984",
      "P 985",
      "P 986",
      "P 987",
      "P 988"
    ]
  },
  {
    "name": "ARTEMAS",
    "trainerClass": "Pilot",
    "pokemon": [
      "P 210",
      "P 234",
      "P 238",
      "P 242",
      "P 247",
      "P 276",
      "P 294",
      "P 317",
      "P 324",
      "P 326",
      "P 327",
      "P 329",
      "P 332",
      "P 358",
      "P 365",
      "P 373",
      "P 376",
      "P 377",
      "P 379",
      "P 385",
      "P 409",
      "P 413",
      "P 417",
      "P 422",
      "P 451",
      "P 469",
      "P 492",
      "P 499",
      "P 501",
      "P 502",
      "P 504",
      "P 507",
      "P 533",
      "P 540",
      "P 548",
      "P 551",
      "P 552",
      "P 554",
      "P 560",
      "P 584",
      "P 588",
      "P 592",
      "P 597",
      "P 626",
      "P 644",
      "P 667",
      "P 674",
      "P 676",
      "P 677",
      "P 679",
      "P 682",
      "P 708",
      "P 715",
      "P 723",
      "P 726",
      "P 727",
      "P 729",
      "P 735",
      "P 759",
      "P 763",
      "P 767",
      "P 772",
      "P 801",
      "P 819",
      "P 842",
      "P 849",
      "P 851",
      "P 852",
      "P 854",
      "P 857",
      "P 883",
      "P 890",
      "P 898",
      "P 901",
      "P 902",
      "P 904",
      "P 909",
      "P 910",
      "P 911",
      "P 921",
      "P 922",
      "P 929",
      "P 930",
      "P 931",
      "P 941",
      "P 942",
      "P 949",
      "P 950",
      "P 951",
      "P 961",
      "P 962",
      "P 969",
      "P 970",
      "P 971",
      "P 981",
      "P 982"
    ]
  },
  {
    "name": "CHAND",
    "trainerClass": "Pilot",
    "pokemon": [
      "P 210",
      "P 234",
      "P 238",
      "P 242",
      "P 247",
      "P 276",
      "P 294",
      "P 317",
      "P 324",
      "P 326",
      "P 327",
      "P 329",
      "P 332",
      "P 358",
      "P 365",
      "P 373",
      "P 376",
      "P 377",
      "P 379",
      "P 385",
      "P 409",
      "P 413",
      "P 417",
      "P 422",
      "P 451",
      "P 469",
      "P 492",
      "P 499",
      "P 501",
      "P 502",
      "P 504",
      "P 507",
      "P 533",
      "P 540",
      "P 548",
      "P 551",
      "P 552",
      "P 554",
      "P 560",
      "P 584",
      "P 588",
      "P 592",
      "P 597",
      "P 626",
      "P 644",
      "P 667",
      "P 674",
      "P 676",
      "P 677",
      "P 679",
      "P 682",
      "P 708",
      "P 715",
      "P 723",
      "P 726",
      "P 727",
      "P 729",
      "P 735",
      "P 759",
      "P 763",
      "P 767",
      "P 772",
      "P 801",
      "P 819",
      "P 842",
      "P 849",
      "P 851",
      "P 852",
      "P 854",
      "P 857",
      "P 883",
      "P 890",
      "P 898",
      "P 901",
      "P 902",
      "P 904",
      "P 909",
      "P 910",
      "P 911",
      "P 921",
      "P 922",
      "P 929",
      "P 930",
      "P 931",
      "P 941",
      "P 942",
      "P 949",
      "P 950",
      "P 951",
      "P 961",
      "P 962",
      "P 969",
      "P 970",
      "P 971",
      "P 981",
      "P 982"
    ]
  }
];

export const POKEMON_BW = [
  {
    "entry": 281,
    "name": "P 281",
    "species": "Abomasnow",
    "instance": "1",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Frost Breath",
    "move2": "Icy Wind",
    "move3": "Leech Seed",
    "move4": "Ingrain",
    "speed": 80
  },
  {
    "entry": 456,
    "name": "P 456",
    "species": "Abomasnow",
    "instance": "2",
    "nature": "Lonely",
    "item": "Miracle Seed",
    "move1": "Wood Hammer",
    "move2": "Brick Break",
    "move3": "Double Team",
    "move4": "Blizzard",
    "speed": 80
  },
  {
    "entry": 631,
    "name": "P 631",
    "species": "Abomasnow",
    "instance": "3",
    "nature": "Quiet",
    "item": "Focus Sash",
    "move1": "Blizzard",
    "move2": "Wood Hammer",
    "move3": "Focus Blast",
    "move4": "Ice Shard",
    "speed": 72
  },
  {
    "entry": 806,
    "name": "P 806",
    "species": "Abomasnow",
    "instance": "4",
    "nature": "Quiet",
    "item": "Occa Berry",
    "move1": "Blizzard",
    "move2": "Focus Blast",
    "move3": "Protect",
    "move4": "Ice Shard",
    "speed": 72
  },
  {
    "entry": 235,
    "name": "P 235",
    "species": "Absol",
    "instance": "1",
    "nature": "Careful",
    "item": "Sitrus Berry",
    "move1": "Payback",
    "move2": "Mean Look",
    "move3": "Hone Claws",
    "move4": "Baton Pass",
    "speed": 95
  },
  {
    "entry": 410,
    "name": "P 410",
    "species": "Absol",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Sucker Punch",
    "move2": "Magic Coat",
    "move3": "Psycho Cut",
    "move4": "Taunt",
    "speed": 95
  },
  {
    "entry": 585,
    "name": "P 585",
    "species": "Absol",
    "instance": "3",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "Night Slash",
    "move2": "Zen Headbutt",
    "move3": "Sucker Punch",
    "move4": "Superpower",
    "speed": 139
  },
  {
    "entry": 760,
    "name": "P 760",
    "species": "Absol",
    "instance": "4",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Substitute",
    "move2": "Swagger",
    "move3": "Punishment",
    "move4": "Will-O-Wisp",
    "speed": 139
  },
  {
    "entry": 292,
    "name": "P 292",
    "species": "Accelgor",
    "instance": "1",
    "nature": "Hasty",
    "item": "Focus Sash",
    "move1": "Encore",
    "move2": "Bug Buzz",
    "move3": "Giga Drain",
    "move4": "Me First",
    "speed": 216
  },
  {
    "entry": 467,
    "name": "P 467",
    "species": "Accelgor",
    "instance": "2",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Energy Ball",
    "move2": "Sludge Bomb",
    "move3": "Bug Buzz",
    "move4": "Endure",
    "speed": 197
  },
  {
    "entry": 642,
    "name": "P 642",
    "species": "Accelgor",
    "instance": "3",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "U-turn",
    "move2": "Bug Buzz",
    "move3": "Focus Blast",
    "move4": "Final Gambit",
    "speed": 216
  },
  {
    "entry": 817,
    "name": "P 817",
    "species": "Accelgor",
    "instance": "4",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Bug Buzz",
    "move2": "Encore",
    "move3": "Focus Blast",
    "move4": "Protect",
    "speed": 216
  },
  {
    "entry": 329,
    "name": "P 329",
    "species": "Aerodactyl",
    "instance": "1",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Rock Slide",
    "move2": "",
    "move3": "",
    "move4": "",
    "speed": 200
  },
  {
    "entry": 504,
    "name": "P 504",
    "species": "Aerodactyl",
    "instance": "2",
    "nature": "Naive",
    "item": "Passho Berry",
    "move1": "Crunch",
    "move2": "Rock Slide",
    "move3": "Roost",
    "move4": "Sky Drop",
    "speed": 200
  },
  {
    "entry": 679,
    "name": "P 679",
    "species": "Aerodactyl",
    "instance": "3",
    "nature": "Jolly",
    "item": "Rock Gem",
    "move1": "Taunt",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Crunch",
    "speed": 200
  },
  {
    "entry": 854,
    "name": "P 854",
    "species": "Aerodactyl",
    "instance": "4",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Stone Edge",
    "move2": "Aerial Ace",
    "move3": "Earthquake",
    "move4": "Crunch",
    "speed": 200
  },
  {
    "entry": 354,
    "name": "P 354",
    "species": "Aggron",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Sash",
    "move1": "Protect",
    "move2": "Roar",
    "move3": "Stealth Rock",
    "move4": "Metal Burst",
    "speed": 70
  },
  {
    "entry": 529,
    "name": "P 529",
    "species": "Aggron",
    "instance": "2",
    "nature": "Brave",
    "item": "King's Rock",
    "move1": "Thunder Wave",
    "move2": "Iron Head",
    "move3": "Fling",
    "move4": "Stomp",
    "speed": 63
  },
  {
    "entry": 704,
    "name": "P 704",
    "species": "Aggron",
    "instance": "3",
    "nature": "Adamant",
    "item": "Steel Gem",
    "move1": "Iron Tail",
    "move2": "Dragon Rush",
    "move3": "Avalanche",
    "move4": "Aerial Ace",
    "speed": 70
  },
  {
    "entry": 879,
    "name": "P 879",
    "species": "Aggron",
    "instance": "4",
    "nature": "Brave",
    "item": "Focus Sash",
    "move1": "Metal Burst",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Shadow Claw",
    "speed": 63
  },
  {
    "entry": 273,
    "name": "P 273",
    "species": "Alakazam",
    "instance": "1",
    "nature": "Timid",
    "item": "TwistedSpoon",
    "move1": "Energy Ball",
    "move2": "Psychic",
    "move3": "Telekinesis",
    "move4": "Guard Split",
    "speed": 189
  },
  {
    "entry": 448,
    "name": "P 448",
    "species": "Alakazam",
    "instance": "2",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Psych Up",
    "move2": "Encore",
    "move3": "Protect",
    "move4": "Psychic",
    "speed": 189
  },
  {
    "entry": 623,
    "name": "P 623",
    "species": "Alakazam",
    "instance": "3",
    "nature": "Timid",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Focus Blast",
    "move3": "Signal Beam",
    "move4": "Grass Knot",
    "speed": 189
  },
  {
    "entry": 798,
    "name": "P 798",
    "species": "Alakazam",
    "instance": "4",
    "nature": "Timid",
    "item": "Choice Specs",
    "move1": "Psychic",
    "move2": "Focus Blast",
    "move3": "Disable",
    "move4": "Trick",
    "speed": 189
  },
  {
    "entry": 276,
    "name": "P 276",
    "species": "Altaria",
    "instance": "1",
    "nature": "Calm",
    "item": "Pecha Berry",
    "move1": "Sing",
    "move2": "Cotton Guard",
    "move3": "Echoed Voice",
    "move4": "Roost",
    "speed": 100
  },
  {
    "entry": 451,
    "name": "P 451",
    "species": "Altaria",
    "instance": "2",
    "nature": "Lonely",
    "item": "Yache Berry",
    "move1": "Dragon Claw",
    "move2": "Pluck",
    "move3": "Mist",
    "move4": "Hone Claws",
    "speed": 100
  },
  {
    "entry": 626,
    "name": "P 626",
    "species": "Altaria",
    "instance": "3",
    "nature": "Jolly",
    "item": "Power Herb",
    "move1": "Dragon Dance",
    "move2": "Dragon Rush",
    "move3": "Sky Attack",
    "move4": "Earthquake",
    "speed": 145
  },
  {
    "entry": 801,
    "name": "P 801",
    "species": "Altaria",
    "instance": "4",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Cotton Guard",
    "move2": "Roost",
    "move3": "Flamethrower",
    "move4": "Dragon Pulse",
    "speed": 100
  },
  {
    "entry": 258,
    "name": "P 258",
    "species": "Ambipom",
    "instance": "1",
    "nature": "Naive",
    "item": "King's Rock",
    "move1": "Fake Out",
    "move2": "Fling",
    "move3": "Thief",
    "move4": "U-turn",
    "speed": 183
  },
  {
    "entry": 433,
    "name": "P 433",
    "species": "Ambipom",
    "instance": "2",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Grass Knot",
    "move2": "Thunderbolt",
    "move3": "Nasty Plot",
    "move4": "Counter",
    "speed": 183
  },
  {
    "entry": 608,
    "name": "P 608",
    "species": "Ambipom",
    "instance": "3",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Fake Out",
    "move2": "Double Hit",
    "move3": "Payback",
    "move4": "Brick Break",
    "speed": 183
  },
  {
    "entry": 783,
    "name": "P 783",
    "species": "Ambipom",
    "instance": "4",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Fling",
    "move2": "Taunt",
    "move3": "Return",
    "move4": "Payback",
    "speed": 183
  },
  {
    "entry": 300,
    "name": "P 300",
    "species": "Ampharos",
    "instance": "1",
    "nature": "Mild",
    "item": "Shuca Berry",
    "move1": "Power Gem",
    "move2": "Thunder Wave",
    "move3": "Discharge",
    "move4": "Charge Beam",
    "speed": 75
  },
  {
    "entry": 475,
    "name": "P 475",
    "species": "Ampharos",
    "instance": "2",
    "nature": "Brave",
    "item": "Lum Berry",
    "move1": "Brick Break",
    "move2": "ThunderPunch",
    "move3": "Screech",
    "move4": "Odor Sleuth",
    "speed": 67
  },
  {
    "entry": 650,
    "name": "P 650",
    "species": "Ampharos",
    "instance": "3",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Thunder Wave",
    "move2": "Charge Beam",
    "move3": "Hyper Beam",
    "move4": "Rest",
    "speed": 75
  },
  {
    "entry": 825,
    "name": "P 825",
    "species": "Ampharos",
    "instance": "4",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Thunder",
    "move2": "Focus Blast",
    "move3": "Signal Beam",
    "move4": "Power Gem",
    "speed": 67
  },
  {
    "entry": 375,
    "name": "P 375",
    "species": "Arcanine",
    "instance": "1",
    "nature": "Modest",
    "item": "Charcoal",
    "move1": "Flamethrower",
    "move2": "SolarBeam",
    "move3": "Incinerate",
    "move4": "Sunny Day",
    "speed": 147
  },
  {
    "entry": 550,
    "name": "P 550",
    "species": "Arcanine",
    "instance": "2",
    "nature": "Naughty",
    "item": "Fire Gem",
    "move1": "ExtremeSpeed",
    "move2": "Crunch",
    "move3": "Overheat",
    "move4": "Roar",
    "speed": 147
  },
  {
    "entry": 725,
    "name": "P 725",
    "species": "Arcanine",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Sunny Day",
    "move3": "SolarBeam",
    "move4": "Dragon Pulse",
    "speed": 161
  },
  {
    "entry": 900,
    "name": "P 900",
    "species": "Arcanine",
    "instance": "4",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Close Combat",
    "move2": "Flare Blitz",
    "move3": "Crunch",
    "move4": "ExtremeSpeed",
    "speed": 161
  },
  {
    "entry": 376,
    "name": "P 376",
    "species": "Archeops",
    "instance": "1",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Quick Attack",
    "move2": "Acrobatics",
    "move3": "Crunch",
    "move4": "U-turn",
    "speed": 178
  },
  {
    "entry": 551,
    "name": "P 551",
    "species": "Archeops",
    "instance": "2",
    "nature": "Mild",
    "item": "Enigma Berry",
    "move1": "Earthquake",
    "move2": "Earth Power",
    "move3": "Endeavor",
    "move4": "AncientPower",
    "speed": 162
  },
  {
    "entry": 726,
    "name": "P 726",
    "species": "Archeops",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Aerial Ace",
    "move2": "Earthquake",
    "move3": "Head Smash",
    "move4": "U-turn",
    "speed": 178
  },
  {
    "entry": 901,
    "name": "P 901",
    "species": "Archeops",
    "instance": "4",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Protect",
    "speed": 178
  },
  {
    "entry": 285,
    "name": "P 285",
    "species": "Armaldo",
    "instance": "1",
    "nature": "Brave",
    "item": "Chesto Berry",
    "move1": "X-Scissor",
    "move2": "Rock Blast",
    "move3": "Rest",
    "move4": "Curse",
    "speed": 58
  },
  {
    "entry": 460,
    "name": "P 460",
    "species": "Armaldo",
    "instance": "2",
    "nature": "Hasty",
    "item": "Razor Fang",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "X-Scissor",
    "move4": "Rock Polish",
    "speed": 106
  },
  {
    "entry": 635,
    "name": "P 635",
    "species": "Armaldo",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "X-Scissor",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Iron Defense",
    "speed": 65
  },
  {
    "entry": 810,
    "name": "P 810",
    "species": "Armaldo",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Superpower",
    "move2": "Stone Edge",
    "move3": "Earthquake",
    "move4": "X-Scissor",
    "speed": 65
  },
  {
    "entry": 909,
    "name": "P 909",
    "species": "Articuno",
    "instance": "1",
    "nature": "Modest",
    "item": "Icy Rock",
    "move1": "Hail",
    "move2": "Blizzard",
    "move3": "Fly",
    "move4": "Roost",
    "speed": 105
  },
  {
    "entry": 929,
    "name": "P 929",
    "species": "Articuno",
    "instance": "2",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "Sheer Cold",
    "move2": "Mind Reader",
    "move3": "Ice Shard",
    "move4": "Ice Beam",
    "speed": 105
  },
  {
    "entry": 949,
    "name": "P 949",
    "species": "Articuno",
    "instance": "3",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Blizzard",
    "move2": "Reflect",
    "move3": "Protect",
    "move4": "U-turn",
    "speed": 150
  },
  {
    "entry": 969,
    "name": "P 969",
    "species": "Articuno",
    "instance": "4",
    "nature": "Modest",
    "item": "Ice Gem",
    "move1": "Tailwind",
    "move2": "Blizzard",
    "move3": "Sky Drop",
    "move4": "Protect",
    "speed": 137
  },
  {
    "entry": 287,
    "name": "P 287",
    "species": "Bastiodon",
    "instance": "1",
    "nature": "Careful",
    "item": "Enigma Berry",
    "move1": "Iron Head",
    "move2": "Taunt",
    "move3": "Wide Guard",
    "move4": "Metal Burst",
    "speed": 50
  },
  {
    "entry": 462,
    "name": "P 462",
    "species": "Bastiodon",
    "instance": "2",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Roar",
    "move2": "Rest",
    "move3": "Block",
    "move4": "Iron Defense",
    "speed": 50
  },
  {
    "entry": 637,
    "name": "P 637",
    "species": "Bastiodon",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Stone Edge",
    "move2": "Fissure",
    "move3": "Double Team",
    "move4": "Iron Defense",
    "speed": 50
  },
  {
    "entry": 812,
    "name": "P 812",
    "species": "Bastiodon",
    "instance": "4",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Metal Burst",
    "move2": "Rock Slide",
    "move3": "Wide Guard",
    "move4": "Curse",
    "speed": 45
  },
  {
    "entry": 352,
    "name": "P 352",
    "species": "Beartic",
    "instance": "1",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Shadow Claw",
    "move2": "Stone Edge",
    "move3": "Avalanche",
    "move4": "Bulk Up",
    "speed": 63
  },
  {
    "entry": 527,
    "name": "P 527",
    "species": "Beartic",
    "instance": "2",
    "nature": "Rash",
    "item": "NeverMeltIce",
    "move1": "Hail",
    "move2": "Icy Wind",
    "move3": "Grass Knot",
    "move4": "Blizzard",
    "speed": 70
  },
  {
    "entry": 702,
    "name": "P 702",
    "species": "Beartic",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Swords Dance",
    "move2": "Avalanche",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed": 70
  },
  {
    "entry": 877,
    "name": "P 877",
    "species": "Beartic",
    "instance": "4",
    "nature": "Jolly",
    "item": "Lax Incense",
    "move1": "Icy Wind",
    "move2": "Icicle Crash",
    "move3": "Rock Slide",
    "move4": "Brick Break",
    "speed": 112
  },
  {
    "entry": 280,
    "name": "P 280",
    "species": "Bisharp",
    "instance": "1",
    "nature": "Lax",
    "item": "Sitrus Berry",
    "move1": "Night Slash",
    "move2": "Metal Claw",
    "move3": "Taunt",
    "move4": "Metal Burst",
    "speed": 90
  },
  {
    "entry": 455,
    "name": "P 455",
    "species": "Bisharp",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Aerial Ace",
    "move2": "Low Sweep",
    "move3": "Iron Head",
    "move4": "Scary Face",
    "speed": 90
  },
  {
    "entry": 630,
    "name": "P 630",
    "species": "Bisharp",
    "instance": "3",
    "nature": "Jolly",
    "item": "Chople Berry",
    "move1": "Iron Head",
    "move2": "Night Slash",
    "move3": "Low Sweep",
    "move4": "Sucker Punch",
    "speed": 134
  },
  {
    "entry": 805,
    "name": "P 805",
    "species": "Bisharp",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Taunt",
    "move2": "Sucker Punch",
    "move3": "Rock Smash",
    "move4": "Iron Head",
    "speed": 90
  },
  {
    "entry": 211,
    "name": "P 211",
    "species": "Blastoise",
    "instance": "1",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Aqua Ring",
    "move2": "Rock Slide",
    "move3": "Aqua Tail",
    "move4": "Iron Defense",
    "speed": 88
  },
  {
    "entry": 386,
    "name": "P 386",
    "species": "Blastoise",
    "instance": "2",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Mist",
    "move4": "Focus Blast",
    "speed": 88
  },
  {
    "entry": 561,
    "name": "P 561",
    "species": "Blastoise",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Fake Out",
    "move2": "Earthquake",
    "move3": "Aqua Tail",
    "move4": "Avalanche",
    "speed": 98
  },
  {
    "entry": 736,
    "name": "P 736",
    "species": "Blastoise",
    "instance": "4",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Yawn",
    "move2": "Waterfall",
    "move3": "Focus Punch",
    "move4": "Rock Slide",
    "speed": 98
  },
  {
    "entry": 216,
    "name": "P 216",
    "species": "Blaziken",
    "instance": "1",
    "nature": "Naughty",
    "item": "Salac Berry",
    "move1": "Hi Jump Kick",
    "move2": "Counter",
    "move3": "Flamethrower",
    "move4": "Will-O-Wisp",
    "speed": 121
  },
  {
    "entry": 391,
    "name": "P 391",
    "species": "Blaziken",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Blaze Kick",
    "move2": "Flame Charge",
    "move3": "Endure",
    "move4": "Reversal",
    "speed": 121
  },
  {
    "entry": 566,
    "name": "P 566",
    "species": "Blaziken",
    "instance": "3",
    "nature": "Hardy",
    "item": "Choice Band",
    "move1": "Flare Blitz",
    "move2": "Shadow Claw",
    "move3": "ThunderPunch",
    "move4": "Earthquake",
    "speed": 132
  },
  {
    "entry": 741,
    "name": "P 741",
    "species": "Blaziken",
    "instance": "4",
    "nature": "Hardy",
    "item": "Shuca Berry",
    "move1": "Flame Charge",
    "move2": "Flare Blitz",
    "move3": "ThunderPunch",
    "move4": "Low Kick",
    "speed": 132
  },
  {
    "entry": 368,
    "name": "P 368",
    "species": "Blissey",
    "instance": "1",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Attract",
    "move2": "Thunder Wave",
    "move3": "Heal Pulse",
    "move4": "Aromatherapy",
    "speed": 75
  },
  {
    "entry": 543,
    "name": "P 543",
    "species": "Blissey",
    "instance": "2",
    "nature": "Modest",
    "item": "Custap Berry",
    "move1": "Charge Beam",
    "move2": "Shadow Ball",
    "move3": "Grass Knot",
    "move4": "Thunder Wave",
    "speed": 75
  },
  {
    "entry": 718,
    "name": "P 718",
    "species": "Blissey",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Thunderbolt",
    "move2": "Ice Beam",
    "move3": "Counter",
    "move4": "Calm Mind",
    "speed": 75
  },
  {
    "entry": 893,
    "name": "P 893",
    "species": "Blissey",
    "instance": "4",
    "nature": "Bold",
    "item": "Chople Berry",
    "move1": "Toxic",
    "move2": "Minimize",
    "move3": "Mud Bomb",
    "move4": "Softboiled",
    "speed": 75
  },
  {
    "entry": 353,
    "name": "P 353",
    "species": "Bouffalant",
    "instance": "1",
    "nature": "Adamant",
    "item": "Silk Scarf",
    "move1": "Head Charge",
    "move2": "Pursuit",
    "move3": "Scary Face",
    "move4": "Aerial Ace",
    "speed": 75
  },
  {
    "entry": 528,
    "name": "P 528",
    "species": "Bouffalant",
    "instance": "2",
    "nature": "Brave",
    "item": "Chople Berry",
    "move1": "Pursuit",
    "move2": "Revenge",
    "move3": "Retaliate",
    "move4": "Swagger",
    "speed": 67
  },
  {
    "entry": 703,
    "name": "P 703",
    "species": "Bouffalant",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Swords Dance",
    "move2": "Earthquake",
    "move3": "Head Charge",
    "move4": "Payback",
    "speed": 75
  },
  {
    "entry": 878,
    "name": "P 878",
    "species": "Bouffalant",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Earthquake",
    "move2": "Head Charge",
    "move3": "Payback",
    "move4": "Protect",
    "speed": 75
  },
  {
    "entry": 327,
    "name": "P 327",
    "species": "Braviary",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Rock Slide",
    "move2": "Air Slash",
    "move3": "Tailwind",
    "move4": "Sky Drop",
    "speed": 100
  },
  {
    "entry": 502,
    "name": "P 502",
    "species": "Braviary",
    "instance": "2",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Thrash",
    "move2": "Bulk Up",
    "move3": "Superpower",
    "move4": "Pluck",
    "speed": 132
  },
  {
    "entry": 677,
    "name": "P 677",
    "species": "Braviary",
    "instance": "3",
    "nature": "Adamant",
    "item": "Flying Gem",
    "move1": "Brave Bird",
    "move2": "Return",
    "move3": "U-turn",
    "move4": "Rock Slide",
    "speed": 132
  },
  {
    "entry": 852,
    "name": "P 852",
    "species": "Braviary",
    "instance": "4",
    "nature": "Adamant",
    "item": "Wacan Berry",
    "move1": "Brave Bird",
    "move2": "Tailwind",
    "move3": "Superpower",
    "move4": "Giga Impact",
    "speed": 132
  },
  {
    "entry": 232,
    "name": "P 232",
    "species": "Breloom",
    "instance": "1",
    "nature": "Brave",
    "item": "Black Belt",
    "move1": "Fake Tears",
    "move2": "Helping Hand",
    "move3": "Mach Punch",
    "move4": "Stun Spore",
    "speed": 81
  },
  {
    "entry": 407,
    "name": "P 407",
    "species": "Breloom",
    "instance": "2",
    "nature": "Jolly",
    "item": "Toxic Orb",
    "move1": "Substitute",
    "move2": "Seed Bomb",
    "move3": "Wake-Up Slap",
    "move4": "Spore",
    "speed": 134
  },
  {
    "entry": 582,
    "name": "P 582",
    "species": "Breloom",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Spore",
    "move2": "Focus Punch",
    "move3": "Rock Slide",
    "move4": "Seed Bomb",
    "speed": 134
  },
  {
    "entry": 757,
    "name": "P 757",
    "species": "Breloom",
    "instance": "4",
    "nature": "Careful",
    "item": "Toxic Orb",
    "move1": "Protect",
    "move2": "Leech Seed",
    "move3": "Substitute",
    "move4": "Focus Punch",
    "speed": 90
  },
  {
    "entry": 310,
    "name": "P 310",
    "species": "Bronzong",
    "instance": "1",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Hypnosis",
    "move2": "Rain Dance",
    "move3": "Gyro Ball",
    "move4": "Trick Room",
    "speed": 53
  },
  {
    "entry": 485,
    "name": "P 485",
    "species": "Bronzong",
    "instance": "2",
    "nature": "Quiet",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Light Screen",
    "move3": "Charge Beam",
    "move4": "Grass Knot",
    "speed": 47
  },
  {
    "entry": 660,
    "name": "P 660",
    "species": "Bronzong",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Iron Head",
    "move2": "Zen Headbutt",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 53
  },
  {
    "entry": 835,
    "name": "P 835",
    "species": "Bronzong",
    "instance": "4",
    "nature": "Brave",
    "item": "Lum Berry",
    "move1": "Safeguard",
    "move2": "Rock Slide",
    "move3": "Zen Headbutt",
    "move4": "Trick Room",
    "speed": 47
  },
  {
    "entry": 290,
    "name": "P 290",
    "species": "Carracosta",
    "instance": "1",
    "nature": "Naughty",
    "item": "Sitrus Berry",
    "move1": "Aqua Tail",
    "move2": "Rock Slide",
    "move3": "Shell Smash",
    "move4": "Iron Defense",
    "speed": 52
  },
  {
    "entry": 465,
    "name": "P 465",
    "species": "Carracosta",
    "instance": "2",
    "nature": "Rash",
    "item": "Wide Lens",
    "move1": "Rock Slide",
    "move2": "Swagger",
    "move3": "Blizzard",
    "move4": "Hydro Pump",
    "speed": 52
  },
  {
    "entry": 640,
    "name": "P 640",
    "species": "Carracosta",
    "instance": "3",
    "nature": "Adamant",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Waterfall",
    "move3": "Rock Slide",
    "move4": "Earthquake",
    "speed": 84
  },
  {
    "entry": 815,
    "name": "P 815",
    "species": "Carracosta",
    "instance": "4",
    "nature": "Adamant",
    "item": "Rindo Berry",
    "move1": "Waterfall",
    "move2": "Rock Slide",
    "move3": "Aqua Jet",
    "move4": "Earthquake",
    "speed": 84
  },
  {
    "entry": 339,
    "name": "P 339",
    "species": "Chandelure",
    "instance": "1",
    "nature": "Modest",
    "item": "Spell Tag",
    "move1": "Flamethrower",
    "move2": "Confuse Ray",
    "move3": "Will-O-Wisp",
    "move4": "Hex",
    "speed": 121
  },
  {
    "entry": 514,
    "name": "P 514",
    "species": "Chandelure",
    "instance": "2",
    "nature": "Timid",
    "item": "Chesto Berry",
    "move1": "Energy Ball",
    "move2": "Rest",
    "move3": "Heat Wave",
    "move4": "Will-O-Wisp",
    "speed": 145
  },
  {
    "entry": 689,
    "name": "P 689",
    "species": "Chandelure",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Shadow Ball",
    "move3": "Protect",
    "move4": "Will-O-Wisp",
    "speed": 100
  },
  {
    "entry": 864,
    "name": "P 864",
    "species": "Chandelure",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Calm Mind",
    "move2": "Will-O-Wisp",
    "move3": "Shadow Ball",
    "move4": "Heat Wave",
    "speed": 100
  },
  {
    "entry": 210,
    "name": "P 210",
    "species": "Charizard",
    "instance": "1",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Dragon Claw",
    "move2": "Flame Charge",
    "move3": "Belly Drum",
    "move4": "Substitute",
    "speed": 141
  },
  {
    "entry": 385,
    "name": "P 385",
    "species": "Charizard",
    "instance": "2",
    "nature": "Adamant",
    "item": "Charti Berry",
    "move1": "Dragon Claw",
    "move2": "Shadow Claw",
    "move3": "Rock Slide",
    "move4": "Dragon Dance",
    "speed": 152
  },
  {
    "entry": 560,
    "name": "P 560",
    "species": "Charizard",
    "instance": "3",
    "nature": "Mild",
    "item": "Choice Scarf",
    "move1": "Heat Wave",
    "move2": "Rock Slide",
    "move3": "Air Slash",
    "move4": "Crunch",
    "speed": 141
  },
  {
    "entry": 735,
    "name": "P 735",
    "species": "Charizard",
    "instance": "4",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Belly Drum",
    "move2": "Substitute",
    "move3": "Fire Punch",
    "move4": "Earthquake",
    "speed": 141
  },
  {
    "entry": 309,
    "name": "P 309",
    "species": "Claydol",
    "instance": "1",
    "nature": "Calm",
    "item": "Absorb Bulb",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Protect",
    "move4": "Calm Mind",
    "speed": 95
  },
  {
    "entry": 484,
    "name": "P 484",
    "species": "Claydol",
    "instance": "2",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Sandstorm",
    "move2": "Toxic",
    "move3": "Cosmic Power",
    "move4": "Explosion",
    "speed": 95
  },
  {
    "entry": 659,
    "name": "P 659",
    "species": "Claydol",
    "instance": "3",
    "nature": "Modest",
    "item": "Ground Gem",
    "move1": "Earth Power",
    "move2": "Psychic",
    "move3": "Ally Switch",
    "move4": "Ice Beam",
    "speed": 95
  },
  {
    "entry": 834,
    "name": "P 834",
    "species": "Claydol",
    "instance": "4",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Earthquake",
    "move2": "Zen Headbutt",
    "move3": "Rock Slide",
    "move4": "Explosion",
    "speed": 95
  },
  {
    "entry": 918,
    "name": "P 918",
    "species": "Cobalion",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Focus Blast",
    "move2": "Flash Cannon",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed": 128
  },
  {
    "entry": 938,
    "name": "P 938",
    "species": "Cobalion",
    "instance": "2",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Metal Burst",
    "move2": "Sacred Sword",
    "move3": "Quick Attack",
    "move4": "Iron Head",
    "speed": 115
  },
  {
    "entry": 958,
    "name": "P 958",
    "species": "Cobalion",
    "instance": "3",
    "nature": "Jolly",
    "item": "Lax Incense",
    "move1": "Swagger",
    "move2": "Substitute",
    "move3": "Psych Up",
    "move4": "Iron Head",
    "speed": 176
  },
  {
    "entry": 978,
    "name": "P 978",
    "species": "Cobalion",
    "instance": "4",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Iron Head",
    "move2": "Close Combat",
    "move3": "Quick Guard",
    "move4": "Protect",
    "speed": 176
  },
  {
    "entry": 259,
    "name": "P 259",
    "species": "Cofagrigus",
    "instance": "1",
    "nature": "Sassy",
    "item": "Chesto Berry",
    "move1": "Night Shade",
    "move2": "Will-O-Wisp",
    "move3": "Mean Look",
    "move4": "Rest",
    "speed": 45
  },
  {
    "entry": 434,
    "name": "P 434",
    "species": "Cofagrigus",
    "instance": "2",
    "nature": "Quiet",
    "item": "Spell Tag",
    "move1": "Shadow Ball",
    "move2": "Energy Ball",
    "move3": "Will-O-Wisp",
    "move4": "Nasty Plot",
    "speed": 45
  },
  {
    "entry": 609,
    "name": "P 609",
    "species": "Cofagrigus",
    "instance": "3",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Will-O-Wisp",
    "move2": "Shadow Ball",
    "move3": "Destiny Bond",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 784,
    "name": "P 784",
    "species": "Cofagrigus",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Will-O-Wisp",
    "move2": "Toxic",
    "move3": "Hex",
    "move4": "Calm Mind",
    "speed": 50
  },
  {
    "entry": 319,
    "name": "P 319",
    "species": "Conkeldurr",
    "instance": "1",
    "nature": "Bold",
    "item": "Black Belt",
    "move1": "Rock Slide",
    "move2": "Force Palm",
    "move3": "SmellingSalt",
    "move4": "Bulk Up",
    "speed": 65
  },
  {
    "entry": 494,
    "name": "P 494",
    "species": "Conkeldurr",
    "instance": "2",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Mach Punch",
    "move2": "Hammer Arm",
    "move3": "Bulk Up",
    "move4": "Fling",
    "speed": 29
  },
  {
    "entry": 669,
    "name": "P 669",
    "species": "Conkeldurr",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Bulk Up",
    "move2": "Drain Punch",
    "move3": "Payback",
    "move4": "Stone Edge",
    "speed": 65
  },
  {
    "entry": 844,
    "name": "P 844",
    "species": "Conkeldurr",
    "instance": "4",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Fling",
    "move2": "Rock Slide",
    "move3": "Superpower",
    "move4": "Mach Punch",
    "speed": 29
  },
  {
    "entry": 284,
    "name": "P 284",
    "species": "Cradily",
    "instance": "1",
    "nature": "Bold",
    "item": "Charti Berry",
    "move1": "Stealth Rock",
    "move2": "Gastro Acid",
    "move3": "Stockpile",
    "move4": "Swallow",
    "speed": 63
  },
  {
    "entry": 459,
    "name": "P 459",
    "species": "Cradily",
    "instance": "2",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Confuse Ray",
    "move2": "Energy Ball",
    "move3": "Stone Edge",
    "move4": "Earthquake",
    "speed": 56
  },
  {
    "entry": 634,
    "name": "P 634",
    "species": "Cradily",
    "instance": "3",
    "nature": "Relaxed",
    "item": "Leftovers",
    "move1": "Sandstorm",
    "move2": "Toxic",
    "move3": "Protect",
    "move4": "Earthquake",
    "speed": 56
  },
  {
    "entry": 809,
    "name": "P 809",
    "species": "Cradily",
    "instance": "4",
    "nature": "Sassy",
    "item": "Big Root",
    "move1": "Stockpile",
    "move2": "Protect",
    "move3": "Ingrain",
    "move4": "Giga Drain",
    "speed": 56
  },
  {
    "entry": 926,
    "name": "P 926",
    "species": "Cresselia",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Calm Mind",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Rest",
    "speed": 105
  },
  {
    "entry": 946,
    "name": "P 946",
    "species": "Cresselia",
    "instance": "2",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Double Team",
    "move2": "Moonlight",
    "move3": "Toxic",
    "move4": "Protect",
    "speed": 105
  },
  {
    "entry": 966,
    "name": "P 966",
    "species": "Cresselia",
    "instance": "3",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "Icy Wind",
    "move2": "Safeguard",
    "move3": "Helping Hand",
    "move4": "Swagger",
    "speed": 105
  },
  {
    "entry": 986,
    "name": "P 986",
    "species": "Cresselia",
    "instance": "4",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Substitute",
    "move3": "Toxic",
    "move4": "Trick Room",
    "speed": 105
  },
  {
    "entry": 358,
    "name": "P 358",
    "species": "Crobat",
    "instance": "1",
    "nature": "Jolly",
    "item": "Charti Berry",
    "move1": "Cross Poison",
    "move2": "X-Scissor",
    "move3": "Hypnosis",
    "move4": "U-turn",
    "speed": 200
  },
  {
    "entry": 533,
    "name": "P 533",
    "species": "Crobat",
    "instance": "2",
    "nature": "Timid",
    "item": "Sharp Beak",
    "move1": "Air Slash",
    "move2": "Shadow Ball",
    "move3": "Confuse Ray",
    "move4": "Nasty Plot",
    "speed": 200
  },
  {
    "entry": 708,
    "name": "P 708",
    "species": "Crobat",
    "instance": "3",
    "nature": "Jolly",
    "item": "Razor Claw",
    "move1": "Cross Poison",
    "move2": "Brave Bird",
    "move3": "Zen Headbutt",
    "move4": "X-Scissor",
    "speed": 200
  },
  {
    "entry": 883,
    "name": "P 883",
    "species": "Crobat",
    "instance": "4",
    "nature": "Jolly",
    "item": "Wide Lens",
    "move1": "Hypnosis",
    "move2": "Aerial Ace",
    "move3": "Cross Poison",
    "move4": "Taunt",
    "speed": 200
  },
  {
    "entry": 268,
    "name": "P 268",
    "species": "Cryogonal",
    "instance": "1",
    "nature": "Timid",
    "item": "Charti Berry",
    "move1": "Icy Wind",
    "move2": "Ice Beam",
    "move3": "Confuse Ray",
    "move4": "Light Screen",
    "speed": 172
  },
  {
    "entry": 443,
    "name": "P 443",
    "species": "Cryogonal",
    "instance": "2",
    "nature": "Hasty",
    "item": "Occa Berry",
    "move1": "Ice Shard",
    "move2": "Slash",
    "move3": "Poison Jab",
    "move4": "Haze",
    "speed": 172
  },
  {
    "entry": 618,
    "name": "P 618",
    "species": "Cryogonal",
    "instance": "3",
    "nature": "Timid",
    "item": "Occa Berry",
    "move1": "Icy Wind",
    "move2": "Flash Cannon",
    "move3": "Blizzard",
    "move4": "Sheer Cold",
    "speed": 172
  },
  {
    "entry": 793,
    "name": "P 793",
    "species": "Cryogonal",
    "instance": "4",
    "nature": "Naive",
    "item": "Focus Sash",
    "move1": "Hail",
    "move2": "Icy Wind",
    "move3": "Blizzard",
    "move4": "Explosion",
    "speed": 172
  },
  {
    "entry": 257,
    "name": "P 257",
    "species": "Darmanitan",
    "instance": "1",
    "nature": "Hasty",
    "item": "Passho Berry",
    "move1": "Fire Punch",
    "move2": "Encore",
    "move3": "Belly Drum",
    "move4": "Brick Break",
    "speed": 161
  },
  {
    "entry": 432,
    "name": "P 432",
    "species": "Darmanitan",
    "instance": "2",
    "nature": "Naughty",
    "item": "Life Orb",
    "move1": "Focus Energy",
    "move2": "Hammer Arm",
    "move3": "Flare Blitz",
    "move4": "Swagger",
    "speed": 136
  },
  {
    "entry": 607,
    "name": "P 607",
    "species": "Darmanitan",
    "instance": "3",
    "nature": "Jolly",
    "item": "Liechi Berry",
    "move1": "Flame Charge",
    "move2": "Earthquake",
    "move3": "Flare Blitz",
    "move4": "Brick Break",
    "speed": 161
  },
  {
    "entry": 782,
    "name": "P 782",
    "species": "Darmanitan",
    "instance": "4",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Belly Drum",
    "move2": "Earthquake",
    "move3": "Fire Punch",
    "move4": "Yawn",
    "speed": 115
  },
  {
    "entry": 240,
    "name": "P 240",
    "species": "Dewgong",
    "instance": "1",
    "nature": "Mild",
    "item": "Icy Rock",
    "move1": "Icy Wind",
    "move2": "Toxic",
    "move3": "Rest",
    "move4": "Hail",
    "speed": 90
  },
  {
    "entry": 415,
    "name": "P 415",
    "species": "Dewgong",
    "instance": "2",
    "nature": "Rash",
    "item": "NeverMeltIce",
    "move1": "Ice Shard",
    "move2": "Signal Beam",
    "move3": "Ice Beam",
    "move4": "Encore",
    "speed": 122
  },
  {
    "entry": 590,
    "name": "P 590",
    "species": "Dewgong",
    "instance": "3",
    "nature": "Mild",
    "item": "Quick Claw",
    "move1": "Fake Out",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Aqua Jet",
    "speed": 90
  },
  {
    "entry": 765,
    "name": "P 765",
    "species": "Dewgong",
    "instance": "4",
    "nature": "Bold",
    "item": "Salac Berry",
    "move1": "Rain Dance",
    "move2": "Rest",
    "move3": "Surf",
    "move4": "Stockpile",
    "speed": 90
  },
  {
    "entry": 307,
    "name": "P 307",
    "species": "Donphan",
    "instance": "1",
    "nature": "Brave",
    "item": "Metronome",
    "move1": "Earthquake",
    "move2": "Scary Face",
    "move3": "Rollout",
    "move4": "Defense Curl",
    "speed": 63
  },
  {
    "entry": 482,
    "name": "P 482",
    "species": "Donphan",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Endeavor",
    "move2": "Flail",
    "move3": "Roar",
    "move4": "Giga Impact",
    "speed": 70
  },
  {
    "entry": 657,
    "name": "P 657",
    "species": "Donphan",
    "instance": "3",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "Gyro Ball",
    "move3": "Fire Fang",
    "move4": "Thunder Fang",
    "speed": 63
  },
  {
    "entry": 832,
    "name": "P 832",
    "species": "Donphan",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Seed Bomb",
    "move4": "Fissure",
    "speed": 70
  },
  {
    "entry": 377,
    "name": "P 377",
    "species": "Dragonite",
    "instance": "1",
    "nature": "Impish",
    "item": "Custap Berry",
    "move1": "Toxic",
    "move2": "Thunder Wave",
    "move3": "Roost",
    "move4": "Rock Slide",
    "speed": 100
  },
  {
    "entry": 552,
    "name": "P 552",
    "species": "Dragonite",
    "instance": "2",
    "nature": "Mild",
    "item": "Salac Berry",
    "move1": "Dragon Rush",
    "move2": "Ice Beam",
    "move3": "Thunderbolt",
    "move4": "Safeguard",
    "speed": 132
  },
  {
    "entry": 727,
    "name": "P 727",
    "species": "Dragonite",
    "instance": "3",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Outrage",
    "move2": "Earthquake",
    "move3": "Giga Impact",
    "move4": "Superpower",
    "speed": 100
  },
  {
    "entry": 902,
    "name": "P 902",
    "species": "Dragonite",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Superpower",
    "move2": "Earthquake",
    "move3": "ThunderPunch",
    "move4": "Fire Punch",
    "speed": 100
  },
  {
    "entry": 311,
    "name": "P 311",
    "species": "Drapion",
    "instance": "1",
    "nature": "Bold",
    "item": "Scope Lens",
    "move1": "Night Slash",
    "move2": "Taunt",
    "move3": "Toxic Spikes",
    "move4": "X-Scissor",
    "speed": 115
  },
  {
    "entry": 486,
    "name": "P 486",
    "species": "Drapion",
    "instance": "2",
    "nature": "Naive",
    "item": "Dark Gem",
    "move1": "Cross Poison",
    "move2": "Crunch",
    "move3": "Scary Face",
    "move4": "Screech",
    "speed": 161
  },
  {
    "entry": 661,
    "name": "P 661",
    "species": "Drapion",
    "instance": "3",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "Cross Poison",
    "move2": "Night Slash",
    "move3": "Fire Fang",
    "move4": "Earthquake",
    "speed": 161
  },
  {
    "entry": 836,
    "name": "P 836",
    "species": "Drapion",
    "instance": "4",
    "nature": "Careful",
    "item": "Razor Claw",
    "move1": "Cross Poison",
    "move2": "Night Slash",
    "move3": "Earthquake",
    "move4": "Swords Dance",
    "speed": 115
  },
  {
    "entry": 294,
    "name": "P 294",
    "species": "Drifblim",
    "instance": "1",
    "nature": "Bold",
    "item": "Salac Berry",
    "move1": "Calm Mind",
    "move2": "Stockpile",
    "move3": "Memento",
    "move4": "Baton Pass",
    "speed": 100
  },
  {
    "entry": 469,
    "name": "P 469",
    "species": "Drifblim",
    "instance": "2",
    "nature": "Mild",
    "item": "Cell Battery",
    "move1": "Hex",
    "move2": "Thunderbolt",
    "move3": "Dream Eater",
    "move4": "Hypnosis",
    "speed": 132
  },
  {
    "entry": 644,
    "name": "P 644",
    "species": "Drifblim",
    "instance": "3",
    "nature": "Timid",
    "item": "Wise Glasses",
    "move1": "Shadow Ball",
    "move2": "Thunderbolt",
    "move3": "Icy Wind",
    "move4": "Destiny Bond",
    "speed": 145
  },
  {
    "entry": 819,
    "name": "P 819",
    "species": "Drifblim",
    "instance": "4",
    "nature": "Bold",
    "item": "Custap Berry",
    "move1": "Shadow Ball",
    "move2": "Thunderbolt",
    "move3": "Hypnosis",
    "move4": "Destiny Bond",
    "speed": 132
  },
  {
    "entry": 269,
    "name": "P 269",
    "species": "Druddigon",
    "instance": "1",
    "nature": "Bold",
    "item": "Chople Berry",
    "move1": "Crunch",
    "move2": "Scary Face",
    "move3": "Glare",
    "move4": "Dragon Tail",
    "speed": 68
  },
  {
    "entry": 444,
    "name": "P 444",
    "species": "Druddigon",
    "instance": "2",
    "nature": "Lonely",
    "item": "Scope Lens",
    "move1": "Dragon Claw",
    "move2": "Night Slash",
    "move3": "Slash",
    "move4": "Hone Claws",
    "speed": 68
  },
  {
    "entry": 619,
    "name": "P 619",
    "species": "Druddigon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Crunch",
    "move2": "Dragon Claw",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 68
  },
  {
    "entry": 794,
    "name": "P 794",
    "species": "Druddigon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Outrage",
    "move2": "Earthquake",
    "move3": "Superpower",
    "move4": "Dragon Tail",
    "speed": 68
  },
  {
    "entry": 224,
    "name": "P 224",
    "species": "Dugtrio",
    "instance": "1",
    "nature": "Hasty",
    "item": "Focus Sash",
    "move1": "Reversal",
    "move2": "Attract",
    "move3": "Dig",
    "move4": "Protect",
    "speed": 189
  },
  {
    "entry": 399,
    "name": "P 399",
    "species": "Dugtrio",
    "instance": "2",
    "nature": "Lonely",
    "item": "Choice Band",
    "move1": "Protect",
    "move2": "Final Gambit",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 172
  },
  {
    "entry": 574,
    "name": "P 574",
    "species": "Dugtrio",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Reversal",
    "move4": "Aerial Ace",
    "speed": 189
  },
  {
    "entry": 749,
    "name": "P 749",
    "species": "Dugtrio",
    "instance": "4",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Toxic",
    "move2": "Dig",
    "move3": "Substitute",
    "move4": "Sandstorm",
    "speed": 189
  },
  {
    "entry": 261,
    "name": "P 261",
    "species": "Durant",
    "instance": "1",
    "nature": "Naive",
    "item": "Sitrus Berry",
    "move1": "Crunch",
    "move2": "Dig",
    "move3": "Bug Bite",
    "move4": "Metal Sound",
    "speed": 165
  },
  {
    "entry": 436,
    "name": "P 436",
    "species": "Durant",
    "instance": "2",
    "nature": "Impish",
    "item": "Power Herb",
    "move1": "Dig",
    "move2": "Iron Defense",
    "move3": "Agility",
    "move4": "Baton Pass",
    "speed": 161
  },
  {
    "entry": 611,
    "name": "P 611",
    "species": "Durant",
    "instance": "3",
    "nature": "Jolly",
    "item": "Occa Berry",
    "move1": "X-Scissor",
    "move2": "Iron Head",
    "move3": "Rock Slide",
    "move4": "Shadow Claw",
    "speed": 177
  },
  {
    "entry": 786,
    "name": "P 786",
    "species": "Durant",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Entrainment",
    "move2": "X-Scissor",
    "move3": "Iron Head",
    "move4": "Protect",
    "speed": 177
  },
  {
    "entry": 350,
    "name": "P 350",
    "species": "Dusknoir",
    "instance": "1",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Disable",
    "move2": "Will-O-Wisp",
    "move3": "Pain Split",
    "move4": "Mean Look",
    "speed": 65
  },
  {
    "entry": 525,
    "name": "P 525",
    "species": "Dusknoir",
    "instance": "2",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Shadow Sneak",
    "move2": "Fire Punch",
    "move3": "Fling",
    "move4": "Trick Room",
    "speed": 29
  },
  {
    "entry": 700,
    "name": "P 700",
    "species": "Dusknoir",
    "instance": "3",
    "nature": "Sassy",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Will-O-Wisp",
    "move3": "Protect",
    "move4": "Double Team",
    "speed": 58
  },
  {
    "entry": 875,
    "name": "P 875",
    "species": "Dusknoir",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Lum Berry",
    "move1": "Shadow Sneak",
    "move2": "Pain Split",
    "move3": "Destiny Bond",
    "move4": "Trick Room",
    "speed": 58
  },
  {
    "entry": 364,
    "name": "P 364",
    "species": "Eelektross",
    "instance": "1",
    "nature": "Quiet",
    "item": "Magnet",
    "move1": "Discharge",
    "move2": "Gastro Acid",
    "move3": "Thunderbolt",
    "move4": "Thunder Wave",
    "speed": 63
  },
  {
    "entry": 539,
    "name": "P 539",
    "species": "Eelektross",
    "instance": "2",
    "nature": "Naughty",
    "item": "Expert Belt",
    "move1": "Crunch",
    "move2": "Wild Charge",
    "move3": "Brick Break",
    "move4": "Coil",
    "speed": 70
  },
  {
    "entry": 714,
    "name": "P 714",
    "species": "Eelektross",
    "instance": "3",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Brick Break",
    "move2": "U-turn",
    "move3": "Grass Knot",
    "move4": "Wild Charge",
    "speed": 63
  },
  {
    "entry": 889,
    "name": "P 889",
    "species": "Eelektross",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Charge Beam",
    "move2": "Grass Knot",
    "move3": "Flamethrower",
    "move4": "Protect",
    "speed": 70
  },
  {
    "entry": 370,
    "name": "P 370",
    "species": "Electivire",
    "instance": "1",
    "nature": "Naughty",
    "item": "Expert Belt",
    "move1": "Low Kick",
    "move2": "Dig",
    "move3": "Rock Slide",
    "move4": "Screech",
    "speed": 136
  },
  {
    "entry": 545,
    "name": "P 545",
    "species": "Electivire",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Fire Punch",
    "move2": "Electro Ball",
    "move3": "Ice Punch",
    "move4": "Protect",
    "speed": 136
  },
  {
    "entry": 720,
    "name": "P 720",
    "species": "Electivire",
    "instance": "3",
    "nature": "Modest",
    "item": "Air Balloon",
    "move1": "Thunderbolt",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Signal Beam",
    "speed": 147
  },
  {
    "entry": 895,
    "name": "P 895",
    "species": "Electivire",
    "instance": "4",
    "nature": "Jolly",
    "item": "Shuca Berry",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Earthquake",
    "speed": 161
  },
  {
    "entry": 250,
    "name": "P 250",
    "species": "Electrode",
    "instance": "1",
    "nature": "Calm",
    "item": "Shuca Berry",
    "move1": "Swagger",
    "move2": "Light Screen",
    "move3": "Charge Beam",
    "move4": "Thunder Wave",
    "speed": 160
  },
  {
    "entry": 425,
    "name": "P 425",
    "species": "Electrode",
    "instance": "2",
    "nature": "Hasty",
    "item": "Focus Sash",
    "move1": "Electro Ball",
    "move2": "Taunt",
    "move3": "Protect",
    "move4": "Explosion",
    "speed": 176
  },
  {
    "entry": 600,
    "name": "P 600",
    "species": "Electrode",
    "instance": "3",
    "nature": "Timid",
    "item": "Air Balloon",
    "move1": "Thunderbolt",
    "move2": "Mirror Coat",
    "move3": "Signal Beam",
    "move4": "Protect",
    "speed": 211
  },
  {
    "entry": 775,
    "name": "P 775",
    "species": "Electrode",
    "instance": "4",
    "nature": "Timid",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Thunder",
    "move3": "Taunt",
    "move4": "Light Screen",
    "speed": 211
  },
  {
    "entry": 222,
    "name": "P 222",
    "species": "Emboar",
    "instance": "1",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Gyro Ball",
    "move2": "Curse",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed": 85
  },
  {
    "entry": 397,
    "name": "P 397",
    "species": "Emboar",
    "instance": "2",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Yawn",
    "move2": "Wild Charge",
    "move3": "Bulldoze",
    "move4": "Heat Crash",
    "speed": 76
  },
  {
    "entry": 572,
    "name": "P 572",
    "species": "Emboar",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Flare Blitz",
    "move2": "Brick Break",
    "move3": "Flame Charge",
    "move4": "Earthquake",
    "speed": 85
  },
  {
    "entry": 747,
    "name": "P 747",
    "species": "Emboar",
    "instance": "4",
    "nature": "Timid",
    "item": "Salac Berry",
    "move1": "Substitute",
    "move2": "Flamethrower",
    "move3": "Focus Blast",
    "move4": "Scald",
    "speed": 128
  },
  {
    "entry": 220,
    "name": "P 220",
    "species": "Empoleon",
    "instance": "1",
    "nature": "Lax",
    "item": "Sitrus Berry",
    "move1": "Yawn",
    "move2": "Swords Dance",
    "move3": "Aqua Jet",
    "move4": "Metal Claw",
    "speed": 80
  },
  {
    "entry": 395,
    "name": "P 395",
    "species": "Empoleon",
    "instance": "2",
    "nature": "Lonely",
    "item": "Muscle Band",
    "move1": "Drill Peck",
    "move2": "Aqua Jet",
    "move3": "Metal Claw",
    "move4": "FeatherDance",
    "speed": 80
  },
  {
    "entry": 570,
    "name": "P 570",
    "species": "Empoleon",
    "instance": "3",
    "nature": "Quiet",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Icy Wind",
    "speed": 72
  },
  {
    "entry": 745,
    "name": "P 745",
    "species": "Empoleon",
    "instance": "4",
    "nature": "Calm",
    "item": "Petaya Berry",
    "move1": "Surf",
    "move2": "Substitute",
    "move3": "Blizzard",
    "move4": "Whirlpool",
    "speed": 80
  },
  {
    "entry": 913,
    "name": "P 913",
    "species": "Entei",
    "instance": "1",
    "nature": "Lonely",
    "item": "Focus Sash",
    "move1": "Overheat",
    "move2": "Flame Charge",
    "move3": "Fire Fang",
    "move4": "Stone Edge",
    "speed": 152
  },
  {
    "entry": 933,
    "name": "P 933",
    "species": "Entei",
    "instance": "2",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Calm Mind",
    "move2": "Will-O-Wisp",
    "move3": "Flamethrower",
    "move4": "Rest",
    "speed": 120
  },
  {
    "entry": 953,
    "name": "P 953",
    "species": "Entei",
    "instance": "3",
    "nature": "Timid",
    "item": "Choice Scarf",
    "move1": "Eruption",
    "move2": "Heat Wave",
    "move3": "Extrasensory",
    "move4": "SolarBeam",
    "speed": 167
  },
  {
    "entry": 973,
    "name": "P 973",
    "species": "Entei",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Overheat",
    "move2": "Double-Edge",
    "move3": "Stone Edge",
    "move4": "Protect",
    "speed": 120
  },
  {
    "entry": 291,
    "name": "P 291",
    "species": "Escavalier",
    "instance": "1",
    "nature": "Brave",
    "item": "Liechi Berry",
    "move1": "Megahorn",
    "move2": "Quick Guard",
    "move3": "Swords Dance",
    "move4": "Reversal",
    "speed": 36
  },
  {
    "entry": 466,
    "name": "P 466",
    "species": "Escavalier",
    "instance": "2",
    "nature": "Naughty",
    "item": "Quick Claw",
    "move1": "Pursuit",
    "move2": "Counter",
    "move3": "X-Scissor",
    "move4": "Swords Dance",
    "speed": 40
  },
  {
    "entry": 641,
    "name": "P 641",
    "species": "Escavalier",
    "instance": "3",
    "nature": "Brave",
    "item": "Life Orb",
    "move1": "Megahorn",
    "move2": "Iron Defense",
    "move3": "Poison Jab",
    "move4": "Iron Head",
    "speed": 36
  },
  {
    "entry": 816,
    "name": "P 816",
    "species": "Escavalier",
    "instance": "4",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Megahorn",
    "move2": "Iron Head",
    "move3": "Swagger",
    "move4": "Reversal",
    "speed": 40
  },
  {
    "entry": 343,
    "name": "P 343",
    "species": "Espeon",
    "instance": "1",
    "nature": "Naive",
    "item": "Focus Sash",
    "move1": "Yawn",
    "move2": "Dream Eater",
    "move3": "Calm Mind",
    "move4": "Protect",
    "speed": 178
  },
  {
    "entry": 518,
    "name": "P 518",
    "species": "Espeon",
    "instance": "2",
    "nature": "Timid",
    "item": "Kasib Berry",
    "move1": "Psyshock",
    "move2": "Grass Knot",
    "move3": "Telekinesis",
    "move4": "Charm",
    "speed": 178
  },
  {
    "entry": 693,
    "name": "P 693",
    "species": "Espeon",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Hyper Beam",
    "move4": "Grass Knot",
    "speed": 162
  },
  {
    "entry": 868,
    "name": "P 868",
    "species": "Espeon",
    "instance": "4",
    "nature": "Timid",
    "item": "Psychic Gem",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Morning Sun",
    "speed": 178
  },
  {
    "entry": 320,
    "name": "P 320",
    "species": "Excadrill",
    "instance": "1",
    "nature": "Naughty",
    "item": "Soft Sand",
    "move1": "Hone Claws",
    "move2": "Rock Slide",
    "move3": "Drill Run",
    "move4": "Iron Defense",
    "speed": 108
  },
  {
    "entry": 495,
    "name": "P 495",
    "species": "Excadrill",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Dig",
    "move2": "Metal Sound",
    "move3": "Metal Claw",
    "move4": "Swords Dance",
    "speed": 108
  },
  {
    "entry": 670,
    "name": "P 670",
    "species": "Excadrill",
    "instance": "3",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Sandstorm",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Poison Jab",
    "speed": 108
  },
  {
    "entry": 845,
    "name": "P 845",
    "species": "Excadrill",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Poison Jab",
    "move4": "Rock Slide",
    "speed": 108
  },
  {
    "entry": 335,
    "name": "P 335",
    "species": "Exeggutor",
    "instance": "1",
    "nature": "Mild",
    "item": "Petaya Berry",
    "move1": "Psyshock",
    "move2": "Grass Knot",
    "move3": "Light Screen",
    "move4": "Synthesis",
    "speed": 96
  },
  {
    "entry": 510,
    "name": "P 510",
    "species": "Exeggutor",
    "instance": "2",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Wood Hammer",
    "move2": "Curse",
    "move3": "Egg Bomb",
    "move4": "Synthesis",
    "speed": 86
  },
  {
    "entry": 685,
    "name": "P 685",
    "species": "Exeggutor",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Leaf Storm",
    "move2": "Psychic",
    "move3": "Sludge Bomb",
    "move4": "AncientPower",
    "speed": 75
  },
  {
    "entry": 860,
    "name": "P 860",
    "species": "Exeggutor",
    "instance": "4",
    "nature": "Brave",
    "item": "Lum Berry",
    "move1": "Wood Hammer",
    "move2": "Zen Headbutt",
    "move3": "Explosion",
    "move4": "Trick Room",
    "speed": 67
  },
  {
    "entry": 253,
    "name": "P 253",
    "species": "Exploud",
    "instance": "1",
    "nature": "Mild",
    "item": "Chople Berry",
    "move1": "Fire Blast",
    "move2": "Roar",
    "move3": "Uproar",
    "move4": "Hyper Voice",
    "speed": 88
  },
  {
    "entry": 428,
    "name": "P 428",
    "species": "Exploud",
    "instance": "2",
    "nature": "Lonely",
    "item": "Chople Berry",
    "move1": "Crunch",
    "move2": "Fake Tears",
    "move3": "Ice Beam",
    "move4": "Giga Impact",
    "speed": 88
  },
  {
    "entry": 603,
    "name": "P 603",
    "species": "Exploud",
    "instance": "3",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Earthquake",
    "move2": "Brick Break",
    "move3": "Ice Punch",
    "move4": "Crunch",
    "speed": 88
  },
  {
    "entry": 778,
    "name": "P 778",
    "species": "Exploud",
    "instance": "4",
    "nature": "Timid",
    "item": "Life Orb",
    "move1": "Icy Wind",
    "move2": "Hyper Voice",
    "move3": "Focus Blast",
    "move4": "Shadow Ball",
    "speed": 132
  },
  {
    "entry": 214,
    "name": "P 214",
    "species": "Feraligatr",
    "instance": "1",
    "nature": "Careful",
    "item": "Lax Incense",
    "move1": "Screech",
    "move2": "Aqua Jet",
    "move3": "Earthquake",
    "move4": "Block",
    "speed": 98
  },
  {
    "entry": 389,
    "name": "P 389",
    "species": "Feraligatr",
    "instance": "2",
    "nature": "Adamant",
    "item": "Liechi Berry",
    "move1": "Superpower",
    "move2": "Aqua Tail",
    "move3": "Ice Fang",
    "move4": "Dragon Dance",
    "speed": 119
  },
  {
    "entry": 564,
    "name": "P 564",
    "species": "Feraligatr",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Aqua Jet",
    "move2": "Waterfall",
    "move3": "Earthquake",
    "move4": "Ice Punch",
    "speed": 98
  },
  {
    "entry": 739,
    "name": "P 739",
    "species": "Feraligatr",
    "instance": "4",
    "nature": "Adamant",
    "item": "Liechi Berry",
    "move1": "Dragon Dance",
    "move2": "Waterfall",
    "move3": "Crunch",
    "move4": "Substitute",
    "speed": 130
  },
  {
    "entry": 272,
    "name": "P 272",
    "species": "Ferrothorn",
    "instance": "1",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Iron Head",
    "move2": "Thunder Wave",
    "move3": "Sandstorm",
    "move4": "Ingrain",
    "speed": 40
  },
  {
    "entry": 447,
    "name": "P 447",
    "species": "Ferrothorn",
    "instance": "2",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Rest",
    "move2": "Payback",
    "move3": "Gyro Ball",
    "move4": "Curse",
    "speed": 40
  },
  {
    "entry": 622,
    "name": "P 622",
    "species": "Ferrothorn",
    "instance": "3",
    "nature": "Brave",
    "item": "Custap Berry",
    "move1": "Protect",
    "move2": "Payback",
    "move3": "Explosion",
    "move4": "Gyro Ball",
    "speed": 36
  },
  {
    "entry": 797,
    "name": "P 797",
    "species": "Ferrothorn",
    "instance": "4",
    "nature": "Sassy",
    "item": "Leftovers",
    "move1": "Curse",
    "move2": "Rock Smash",
    "move3": "Gyro Ball",
    "move4": "Ingrain",
    "speed": 36
  },
  {
    "entry": 342,
    "name": "P 342",
    "species": "Flareon",
    "instance": "1",
    "nature": "Naughty",
    "item": "Focus Sash",
    "move1": "Dig",
    "move2": "Flail",
    "move3": "Work Up",
    "move4": "Fire Blast",
    "speed": 85
  },
  {
    "entry": 517,
    "name": "P 517",
    "species": "Flareon",
    "instance": "2",
    "nature": "Impish",
    "item": "Charcoal",
    "move1": "Will-O-Wisp",
    "move2": "Charm",
    "move3": "Flame Charge",
    "move4": "Protect",
    "speed": 85
  },
  {
    "entry": 692,
    "name": "P 692",
    "species": "Flareon",
    "instance": "3",
    "nature": "Brave",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Return",
    "move3": "Will-O-Wisp",
    "move4": "Overheat",
    "speed": 76
  },
  {
    "entry": 867,
    "name": "P 867",
    "species": "Flareon",
    "instance": "4",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Bite",
    "move2": "Superpower",
    "move3": "Giga Impact",
    "move4": "Fire Fang",
    "speed": 85
  },
  {
    "entry": 288,
    "name": "P 288",
    "species": "Floatzel",
    "instance": "1",
    "nature": "Naive",
    "item": "Binding Band",
    "move1": "Aqua Tail",
    "move2": "Protect",
    "move3": "Pursuit",
    "move4": "Whirlpool",
    "speed": 183
  },
  {
    "entry": 463,
    "name": "P 463",
    "species": "Floatzel",
    "instance": "2",
    "nature": "Hasty",
    "item": "Flame Orb",
    "move1": "Aqua Jet",
    "move2": "Switcheroo",
    "move3": "Pursuit",
    "move4": "Crunch",
    "speed": 183
  },
  {
    "entry": 638,
    "name": "P 638",
    "species": "Floatzel",
    "instance": "3",
    "nature": "Hasty",
    "item": "Damp Rock",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Focus Blast",
    "move4": "Rain Dance",
    "speed": 183
  },
  {
    "entry": 813,
    "name": "P 813",
    "species": "Floatzel",
    "instance": "4",
    "nature": "Hasty",
    "item": "Life Orb",
    "move1": "Waterfall",
    "move2": "Aqua Jet",
    "move3": "Low Kick",
    "move4": "Protect",
    "speed": 183
  },
  {
    "entry": 337,
    "name": "P 337",
    "species": "Flygon",
    "instance": "1",
    "nature": "Naive",
    "item": "Liechi Berry",
    "move1": "Earthquake",
    "move2": "Dragon Claw",
    "move3": "Endure",
    "move4": "Fire Blast",
    "speed": 167
  },
  {
    "entry": 512,
    "name": "P 512",
    "species": "Flygon",
    "instance": "2",
    "nature": "Naive",
    "item": "Haban Berry",
    "move1": "Swagger",
    "move2": "Quick Attack",
    "move3": "Rock Slide",
    "move4": "U-turn",
    "speed": 167
  },
  {
    "entry": 687,
    "name": "P 687",
    "species": "Flygon",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Earth Power",
    "move3": "Flamethrower",
    "move4": "Giga Drain",
    "speed": 167
  },
  {
    "entry": 862,
    "name": "P 862",
    "species": "Flygon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Outrage",
    "move3": "Crunch",
    "move4": "Stone Edge",
    "speed": 152
  },
  {
    "entry": 233,
    "name": "P 233",
    "species": "Forretress",
    "instance": "1",
    "nature": "Impish",
    "item": "Occa Berry",
    "move1": "Spikes",
    "move2": "Struggle Bug",
    "move3": "Stealth Rock",
    "move4": "Iron Defense",
    "speed": 60
  },
  {
    "entry": 408,
    "name": "P 408",
    "species": "Forretress",
    "instance": "2",
    "nature": "Naughty",
    "item": "Sitrus Berry",
    "move1": "Spikes",
    "move2": "Earthquake",
    "move3": "Magnet Rise",
    "move4": "Gyro Ball",
    "speed": 60
  },
  {
    "entry": 583,
    "name": "P 583",
    "species": "Forretress",
    "instance": "3",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Gyro Ball",
    "move2": "Earthquake",
    "move3": "Bug Bite",
    "move4": "Explosion",
    "speed": 27
  },
  {
    "entry": 758,
    "name": "P 758",
    "species": "Forretress",
    "instance": "4",
    "nature": "Careful",
    "item": "Custap Berry",
    "move1": "Toxic Spikes",
    "move2": "Stealth Rock",
    "move3": "Spikes",
    "move4": "Explosion",
    "speed": 60
  },
  {
    "entry": 255,
    "name": "P 255",
    "species": "Froslass",
    "instance": "1",
    "nature": "Timid",
    "item": "Icy Rock",
    "move1": "Hail",
    "move2": "Ice Beam",
    "move3": "Ominous Wind",
    "move4": "Thunderbolt",
    "speed": 178
  },
  {
    "entry": 430,
    "name": "P 430",
    "species": "Froslass",
    "instance": "2",
    "nature": "Lonely",
    "item": "Ice Gem",
    "move1": "Ice Shard",
    "move2": "Thunder Wave",
    "move3": "Hex",
    "move4": "Taunt",
    "speed": 162
  },
  {
    "entry": 605,
    "name": "P 605",
    "species": "Froslass",
    "instance": "3",
    "nature": "Timid",
    "item": "Icy Rock",
    "move1": "Hail",
    "move2": "Blizzard",
    "move3": "Ice Shard",
    "move4": "Shadow Ball",
    "speed": 178
  },
  {
    "entry": 780,
    "name": "P 780",
    "species": "Froslass",
    "instance": "4",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Blizzard",
    "move2": "Icy Wind",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed": 178
  },
  {
    "entry": 334,
    "name": "P 334",
    "species": "Gallade",
    "instance": "1",
    "nature": "Hasty",
    "item": "Expert Belt",
    "move1": "Shadow Sneak",
    "move2": "Brick Break",
    "move3": "Psycho Cut",
    "move4": "Swords Dance",
    "speed": 145
  },
  {
    "entry": 509,
    "name": "P 509",
    "species": "Gallade",
    "instance": "2",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "Psycho Cut",
    "move2": "Leaf Blade",
    "move3": "Slash",
    "move4": "Protect",
    "speed": 145
  },
  {
    "entry": 684,
    "name": "P 684",
    "species": "Gallade",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Psycho Cut",
    "move2": "Stone Edge",
    "move3": "Night Slash",
    "move4": "X-Scissor",
    "speed": 100
  },
  {
    "entry": 859,
    "name": "P 859",
    "species": "Gallade",
    "instance": "4",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Psycho Cut",
    "move2": "Close Combat",
    "move3": "Heal Pulse",
    "move4": "Ally Switch",
    "speed": 145
  },
  {
    "entry": 381,
    "name": "P 381",
    "species": "Garchomp",
    "instance": "1",
    "nature": "Jolly",
    "item": "Lax Incense",
    "move1": "Earthquake",
    "move2": "Protect",
    "move3": "Sandstorm",
    "move4": "Sand Tomb",
    "speed": 169
  },
  {
    "entry": 556,
    "name": "P 556",
    "species": "Garchomp",
    "instance": "2",
    "nature": "Hasty",
    "item": "Razor Fang",
    "move1": "Fire Blast",
    "move2": "Incinerate",
    "move3": "Surf",
    "move4": "Scary Face",
    "speed": 169
  },
  {
    "entry": 731,
    "name": "P 731",
    "species": "Garchomp",
    "instance": "3",
    "nature": "Adamant",
    "item": "Choice Scarf",
    "move1": "Outrage",
    "move2": "Earthquake",
    "move3": "Fire Fang",
    "move4": "Crunch",
    "speed": 154
  },
  {
    "entry": 906,
    "name": "P 906",
    "species": "Garchomp",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Swords Dance",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Dragon Claw",
    "speed": 169
  },
  {
    "entry": 333,
    "name": "P 333",
    "species": "Gardevoir",
    "instance": "1",
    "nature": "Naive",
    "item": "Wide Lens",
    "move1": "Hypnosis",
    "move2": "Calm Mind",
    "move3": "Imprison",
    "move4": "Taunt",
    "speed": 133
  },
  {
    "entry": 508,
    "name": "P 508",
    "species": "Gardevoir",
    "instance": "2",
    "nature": "Naive",
    "item": "Lum Berry",
    "move1": "Stored Power",
    "move2": "Thunderbolt",
    "move3": "Calm Mind",
    "move4": "Ally Switch",
    "speed": 145
  },
  {
    "entry": 683,
    "name": "P 683",
    "species": "Gardevoir",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Charge Beam",
    "move3": "Energy Ball",
    "move4": "Focus Blast",
    "speed": 100
  },
  {
    "entry": 858,
    "name": "P 858",
    "species": "Gardevoir",
    "instance": "4",
    "nature": "Timid",
    "item": "Psychic Gem",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed": 145
  },
  {
    "entry": 243,
    "name": "P 243",
    "species": "Gastrodon",
    "instance": "1",
    "nature": "Gentle",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Sludge Bomb",
    "move3": "Muddy Water",
    "move4": "Counter",
    "speed": 59
  },
  {
    "entry": 418,
    "name": "P 418",
    "species": "Gastrodon",
    "instance": "2",
    "nature": "Careful",
    "item": "Rindo Berry",
    "move1": "Waterfall",
    "move2": "Amnesia",
    "move3": "Curse",
    "move4": "Yawn",
    "speed": 59
  },
  {
    "entry": 593,
    "name": "P 593",
    "species": "Gastrodon",
    "instance": "3",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Sandstorm",
    "move2": "Earth Power",
    "move3": "Surf",
    "move4": "Recover",
    "speed": 53
  },
  {
    "entry": 768,
    "name": "P 768",
    "species": "Gastrodon",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Amnesia",
    "move2": "Curse",
    "move3": "Earthquake",
    "move4": "Waterfall",
    "speed": 59
  },
  {
    "entry": 299,
    "name": "P 299",
    "species": "Gengar",
    "instance": "1",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Shadow Ball",
    "move2": "Dream Eater",
    "move3": "Nightmare",
    "move4": "Hypnosis",
    "speed": 178
  },
  {
    "entry": 474,
    "name": "P 474",
    "species": "Gengar",
    "instance": "2",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Sucker Punch",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Will-O-Wisp",
    "speed": 178
  },
  {
    "entry": 649,
    "name": "P 649",
    "species": "Gengar",
    "instance": "3",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Shadow Ball",
    "move2": "Taunt",
    "move3": "Focus Blast",
    "move4": "Counter",
    "speed": 178
  },
  {
    "entry": 824,
    "name": "P 824",
    "species": "Gengar",
    "instance": "4",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Sludge Bomb",
    "move2": "Thunderbolt",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed": 178
  },
  {
    "entry": 318,
    "name": "P 318",
    "species": "Gigalith",
    "instance": "1",
    "nature": "Naughty",
    "item": "Rawst Berry",
    "move1": "Bulldoze",
    "move2": "Rock Blast",
    "move3": "Gravity",
    "move4": "Curse",
    "speed": 45
  },
  {
    "entry": 493,
    "name": "P 493",
    "species": "Gigalith",
    "instance": "2",
    "nature": "Naughty",
    "item": "Hard Stone",
    "move1": "Iron Defense",
    "move2": "Sandstorm",
    "move3": "Lock-On",
    "move4": "Rock Blast",
    "speed": 45
  },
  {
    "entry": 668,
    "name": "P 668",
    "species": "Gigalith",
    "instance": "3",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Stone Edge",
    "move2": "Earthquake",
    "move3": "Sandstorm",
    "move4": "Explosion",
    "speed": 45
  },
  {
    "entry": 843,
    "name": "P 843",
    "species": "Gigalith",
    "instance": "4",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Rock Slide",
    "move2": "Stealth Rock",
    "move3": "Curse",
    "move4": "Earthquake",
    "speed": 40
  },
  {
    "entry": 346,
    "name": "P 346",
    "species": "Glaceon",
    "instance": "1",
    "nature": "Rash",
    "item": "Quick Claw",
    "move1": "Ice Shard",
    "move2": "Blizzard",
    "move3": "Mirror Coat",
    "move4": "Helping Hand",
    "speed": 85
  },
  {
    "entry": 521,
    "name": "P 521",
    "species": "Glaceon",
    "instance": "2",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Frost Breath",
    "move2": "Shadow Ball",
    "move3": "Rest",
    "move4": "Barrier",
    "speed": 85
  },
  {
    "entry": 696,
    "name": "P 696",
    "species": "Glaceon",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Hail",
    "move2": "Blizzard",
    "move3": "Mirror Coat",
    "move4": "Hyper Beam",
    "speed": 85
  },
  {
    "entry": 871,
    "name": "P 871",
    "species": "Glaceon",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Blizzard",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Detect",
    "speed": 85
  },
  {
    "entry": 324,
    "name": "P 324",
    "species": "Gliscor",
    "instance": "1",
    "nature": "Naughty",
    "item": "Razor Fang",
    "move1": "Acrobatics",
    "move2": "Fling",
    "move3": "U-turn",
    "move4": "Swords Dance",
    "speed": 147
  },
  {
    "entry": 499,
    "name": "P 499",
    "species": "Gliscor",
    "instance": "2",
    "nature": "Impish",
    "item": "Liechi Berry",
    "move1": "Agility",
    "move2": "Acrobatics",
    "move3": "Swords Dance",
    "move4": "Baton Pass",
    "speed": 115
  },
  {
    "entry": 674,
    "name": "P 674",
    "species": "Gliscor",
    "instance": "3",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Aerial Ace",
    "move2": "Earthquake",
    "move3": "X-Scissor",
    "move4": "Stone Edge",
    "speed": 115
  },
  {
    "entry": 849,
    "name": "P 849",
    "species": "Gliscor",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Earthquake",
    "move2": "Acrobatics",
    "move3": "U-turn",
    "move4": "Counter",
    "speed": 161
  },
  {
    "entry": 262,
    "name": "P 262",
    "species": "Golem",
    "instance": "1",
    "nature": "Impish",
    "item": "Hard Stone",
    "move1": "Stealth Rock",
    "move2": "Curse",
    "move3": "Gyro Ball",
    "move4": "Smack Down",
    "speed": 65
  },
  {
    "entry": 437,
    "name": "P 437",
    "species": "Golem",
    "instance": "2",
    "nature": "Naughty",
    "item": "Absorb Bulb",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Bulldoze",
    "move4": "Autotomize",
    "speed": 97
  },
  {
    "entry": 612,
    "name": "P 612",
    "species": "Golem",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Explosion",
    "move4": "Autotomize",
    "speed": 106
  },
  {
    "entry": 787,
    "name": "P 787",
    "species": "Golem",
    "instance": "4",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Explosion",
    "move4": "Fling",
    "speed": 29
  },
  {
    "entry": 260,
    "name": "P 260",
    "species": "Golurk",
    "instance": "1",
    "nature": "Lonely",
    "item": "Muscle Band",
    "move1": "Shadow Punch",
    "move2": "Iron Defense",
    "move3": "Bulldoze",
    "move4": "Heavy Slam",
    "speed": 75
  },
  {
    "entry": 435,
    "name": "P 435",
    "species": "Golurk",
    "instance": "2",
    "nature": "Brave",
    "item": "Wide Lens",
    "move1": "Hammer Arm",
    "move2": "Rock Slide",
    "move3": "Curse",
    "move4": "Gyro Ball",
    "speed": 67
  },
  {
    "entry": 610,
    "name": "P 610",
    "species": "Golurk",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "DynamicPunch",
    "move2": "Shadow Punch",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 75
  },
  {
    "entry": 785,
    "name": "P 785",
    "species": "Golurk",
    "instance": "4",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Hammer Arm",
    "move2": "Earthquake",
    "move3": "Shadow Punch",
    "move4": "Fling",
    "speed": 33
  },
  {
    "entry": 278,
    "name": "P 278",
    "species": "Gothitelle",
    "instance": "1",
    "nature": "Sassy",
    "item": "Chesto Berry",
    "move1": "Fake Tears",
    "move2": "Psychic",
    "move3": "Rest",
    "move4": "Calm Mind",
    "speed": 95
  },
  {
    "entry": 453,
    "name": "P 453",
    "species": "Gothitelle",
    "instance": "2",
    "nature": "Modest",
    "item": "TwistedSpoon",
    "move1": "Psyshock",
    "move2": "Miracle Eye",
    "move3": "Mirror Coat",
    "move4": "Tickle",
    "speed": 85
  },
  {
    "entry": 628,
    "name": "P 628",
    "species": "Gothitelle",
    "instance": "3",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Charm",
    "move2": "Safeguard",
    "move3": "Psychic",
    "move4": "Charge Beam",
    "speed": 85
  },
  {
    "entry": 803,
    "name": "P 803",
    "species": "Gothitelle",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Substitute",
    "move2": "Flatter",
    "move3": "Psych Up",
    "move4": "Psychic",
    "speed": 85
  },
  {
    "entry": 228,
    "name": "P 228",
    "species": "Granbull",
    "instance": "1",
    "nature": "Naughty",
    "item": "Jaboca Berry",
    "move1": "Metronome",
    "move2": "Attract",
    "move3": "Mimic",
    "move4": "Return",
    "speed": 65
  },
  {
    "entry": 403,
    "name": "P 403",
    "species": "Granbull",
    "instance": "2",
    "nature": "Adamant",
    "item": "Silk Scarf",
    "move1": "Charm",
    "move2": "Double-Edge",
    "move3": "Payback",
    "move4": "Bulk Up",
    "speed": 65
  },
  {
    "entry": 578,
    "name": "P 578",
    "species": "Granbull",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Double-Edge",
    "move2": "Roar",
    "move3": "Crunch",
    "move4": "Sludge Bomb",
    "speed": 65
  },
  {
    "entry": 753,
    "name": "P 753",
    "species": "Granbull",
    "instance": "4",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Charm",
    "move2": "Toxic",
    "move3": "Dig",
    "move4": "Protect",
    "speed": 65
  },
  {
    "entry": 365,
    "name": "P 365",
    "species": "Gyarados",
    "instance": "1",
    "nature": "Lonely",
    "item": "Muscle Band",
    "move1": "Ice Fang",
    "move2": "Aqua Tail",
    "move3": "Thunder Wave",
    "move4": "Dragon Dance",
    "speed": 122
  },
  {
    "entry": 540,
    "name": "P 540",
    "species": "Gyarados",
    "instance": "2",
    "nature": "Naughty",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Rest",
    "move3": "Bulldoze",
    "move4": "Giga Impact",
    "speed": 133
  },
  {
    "entry": 715,
    "name": "P 715",
    "species": "Gyarados",
    "instance": "3",
    "nature": "Jolly",
    "item": "Wacan Berry",
    "move1": "Dragon Dance",
    "move2": "Waterfall",
    "move3": "Stone Edge",
    "move4": "Earthquake",
    "speed": 146
  },
  {
    "entry": 890,
    "name": "P 890",
    "species": "Gyarados",
    "instance": "4",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Dragon Dance",
    "move2": "Aqua Tail",
    "move3": "Earthquake",
    "move4": "Rest",
    "speed": 101
  },
  {
    "entry": 237,
    "name": "P 237",
    "species": "Hariyama",
    "instance": "1",
    "nature": "Brave",
    "item": "King's Rock",
    "move1": "Feint",
    "move2": "Fake Out",
    "move3": "Smack Down",
    "move4": "Vital Throw",
    "speed": 63
  },
  {
    "entry": 412,
    "name": "P 412",
    "species": "Hariyama",
    "instance": "2",
    "nature": "Careful",
    "item": "Custap Berry",
    "move1": "Reversal",
    "move2": "Bullet Punch",
    "move3": "Protect",
    "move4": "Belly Drum",
    "speed": 70
  },
  {
    "entry": 587,
    "name": "P 587",
    "species": "Hariyama",
    "instance": "3",
    "nature": "Brave",
    "item": "Flame Orb",
    "move1": "Fake Out",
    "move2": "Close Combat",
    "move3": "Detect",
    "move4": "Earthquake",
    "speed": 63
  },
  {
    "entry": 762,
    "name": "P 762",
    "species": "Hariyama",
    "instance": "4",
    "nature": "Careful",
    "item": "Sitrus Berry",
    "move1": "Belly Drum",
    "move2": "Brick Break",
    "move3": "Ice Punch",
    "move4": "Bullet Punch",
    "speed": 70
  },
  {
    "entry": 372,
    "name": "P 372",
    "species": "Haxorus",
    "instance": "1",
    "nature": "Hasty",
    "item": "Haban Berry",
    "move1": "Dual Chop",
    "move2": "Earthquake",
    "move3": "Roar",
    "move4": "Taunt",
    "speed": 163
  },
  {
    "entry": 547,
    "name": "P 547",
    "species": "Haxorus",
    "instance": "2",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Outrage",
    "move2": "Rock Slide",
    "move3": "Counter",
    "move4": "Dragon Dance",
    "speed": 138
  },
  {
    "entry": 722,
    "name": "P 722",
    "species": "Haxorus",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Band",
    "move1": "Outrage",
    "move2": "Earthquake",
    "move3": "Dragon Claw",
    "move4": "",
    "speed": 163
  },
  {
    "entry": 897,
    "name": "P 897",
    "species": "Haxorus",
    "instance": "4",
    "nature": "Jolly",
    "item": "Yache Berry",
    "move1": "Dragon Dance",
    "move2": "Dragon Claw",
    "move3": "Dragon Tail",
    "move4": "Earthquake",
    "speed": 163
  },
  {
    "entry": 925,
    "name": "P 925",
    "species": "Heatran",
    "instance": "1",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Lava Plume",
    "move2": "Earth Power",
    "move3": "Flash Cannon",
    "move4": "Dark Pulse",
    "speed": 97
  },
  {
    "entry": 945,
    "name": "P 945",
    "species": "Heatran",
    "instance": "2",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Will-O-Wisp",
    "move3": "Flash Cannon",
    "move4": "Protect",
    "speed": 97
  },
  {
    "entry": 965,
    "name": "P 965",
    "species": "Heatran",
    "instance": "3",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Sunny Day",
    "move2": "Fire Blast",
    "move3": "SolarBeam",
    "move4": "Earth Power",
    "speed": 97
  },
  {
    "entry": 985,
    "name": "P 985",
    "species": "Heatran",
    "instance": "4",
    "nature": "Timid",
    "item": "Choice Scarf",
    "move1": "Magma Storm",
    "move2": "Earth Power",
    "move3": "Dragon Pulse",
    "move4": "Flash Cannon",
    "speed": 141
  },
  {
    "entry": 304,
    "name": "P 304",
    "species": "Heracross",
    "instance": "1",
    "nature": "Brave",
    "item": "Black Belt",
    "move1": "Aerial Ace",
    "move2": "Pursuit",
    "move3": "Swords Dance",
    "move4": "Brick Break",
    "speed": 94
  },
  {
    "entry": 479,
    "name": "P 479",
    "species": "Heracross",
    "instance": "2",
    "nature": "Naughty",
    "item": "Salac Berry",
    "move1": "Megahorn",
    "move2": "Dig",
    "move3": "Endure",
    "move4": "Reversal",
    "speed": 137
  },
  {
    "entry": 654,
    "name": "P 654",
    "species": "Heracross",
    "instance": "3",
    "nature": "Jolly",
    "item": "Coba Berry",
    "move1": "Megahorn",
    "move2": "Stone Edge",
    "move3": "Facade",
    "move4": "Shadow Claw",
    "speed": 150
  },
  {
    "entry": 829,
    "name": "P 829",
    "species": "Heracross",
    "instance": "4",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 150
  },
  {
    "entry": 348,
    "name": "P 348",
    "species": "Hippowdon",
    "instance": "1",
    "nature": "Impish",
    "item": "Soft Sand",
    "move1": "Earthquake",
    "move2": "Crunch",
    "move3": "Yawn",
    "move4": "Whirlwind",
    "speed": 67
  },
  {
    "entry": 523,
    "name": "P 523",
    "species": "Hippowdon",
    "instance": "2",
    "nature": "Lonely",
    "item": "Sitrus Berry",
    "move1": "Crunch",
    "move2": "Rock Slide",
    "move3": "Protect",
    "move4": "Curse",
    "speed": 67
  },
  {
    "entry": 698,
    "name": "P 698",
    "species": "Hippowdon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "Crunch",
    "move3": "Slack Off",
    "move4": "Yawn",
    "speed": 67
  },
  {
    "entry": 873,
    "name": "P 873",
    "species": "Hippowdon",
    "instance": "4",
    "nature": "Sassy",
    "item": "Chesto Berry",
    "move1": "Curse",
    "move2": "Rest",
    "move3": "Earthquake",
    "move4": "Crunch",
    "speed": 60
  },
  {
    "entry": 317,
    "name": "P 317",
    "species": "Honchkrow",
    "instance": "1",
    "nature": "Quiet",
    "item": "Sitrus Berry",
    "move1": "Psychic",
    "move2": "Dark Pulse",
    "move3": "Protect",
    "move4": "Nasty Plot",
    "speed": 81
  },
  {
    "entry": 492,
    "name": "P 492",
    "species": "Honchkrow",
    "instance": "2",
    "nature": "Brave",
    "item": "BlackGlasses",
    "move1": "Sucker Punch",
    "move2": "Taunt",
    "move3": "Pursuit",
    "move4": "Protect",
    "speed": 81
  },
  {
    "entry": 667,
    "name": "P 667",
    "species": "Honchkrow",
    "instance": "3",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Air Cutter",
    "move2": "Dark Pulse",
    "move3": "Snatch",
    "move4": "Shadow Ball",
    "speed": 91
  },
  {
    "entry": 842,
    "name": "P 842",
    "species": "Honchkrow",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Night Slash",
    "move2": "Drill Peck",
    "move3": "Sucker Punch",
    "move4": "Thunder Wave",
    "speed": 91
  },
  {
    "entry": 306,
    "name": "P 306",
    "species": "Houndoom",
    "instance": "1",
    "nature": "Adamant",
    "item": "Charcoal",
    "move1": "Incinerate",
    "move2": "Flame Charge",
    "move3": "Will-O-Wisp",
    "move4": "Sucker Punch",
    "speed": 147
  },
  {
    "entry": 481,
    "name": "P 481",
    "species": "Houndoom",
    "instance": "2",
    "nature": "Hasty",
    "item": "Focus Sash",
    "move1": "Counter",
    "move2": "Flame Charge",
    "move3": "Roar",
    "move4": "Protect",
    "speed": 161
  },
  {
    "entry": 656,
    "name": "P 656",
    "species": "Houndoom",
    "instance": "3",
    "nature": "Timid",
    "item": "Air Balloon",
    "move1": "Flamethrower",
    "move2": "Shadow Ball",
    "move3": "Sludge Bomb",
    "move4": "Will-O-Wisp",
    "speed": 161
  },
  {
    "entry": 831,
    "name": "P 831",
    "species": "Houndoom",
    "instance": "4",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Dark Pulse",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 161
  },
  {
    "entry": 382,
    "name": "P 382",
    "species": "Hydreigon",
    "instance": "1",
    "nature": "Rash",
    "item": "Dragon Fang",
    "move1": "Dragon Pulse",
    "move2": "Earth Power",
    "move3": "Surf",
    "move4": "Dragon Tail",
    "speed": 150
  },
  {
    "entry": 557,
    "name": "P 557",
    "species": "Hydreigon",
    "instance": "2",
    "nature": "Mild",
    "item": "Wide Lens",
    "move1": "Focus Blast",
    "move2": "Fire Blast",
    "move3": "Dragon Rush",
    "move4": "Work Up",
    "speed": 139
  },
  {
    "entry": 732,
    "name": "P 732",
    "species": "Hydreigon",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Taunt",
    "move3": "Earth Power",
    "move4": "Flamethrower",
    "speed": 165
  },
  {
    "entry": 907,
    "name": "P 907",
    "species": "Hydreigon",
    "instance": "4",
    "nature": "Jolly",
    "item": "Dragon Gem",
    "move1": "Dragon Rush",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Dragon Tail",
    "speed": 165
  },
  {
    "entry": 219,
    "name": "P 219",
    "species": "Infernape",
    "instance": "1",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Fake Out",
    "move2": "Encore",
    "move3": "Fling",
    "move4": "Acrobatics",
    "speed": 176
  },
  {
    "entry": 394,
    "name": "P 394",
    "species": "Infernape",
    "instance": "2",
    "nature": "Mild",
    "item": "Charcoal",
    "move1": "Heat Wave",
    "move2": "Will-O-Wisp",
    "move3": "Grass Knot",
    "move4": "Calm Mind",
    "speed": 149
  },
  {
    "entry": 569,
    "name": "P 569",
    "species": "Infernape",
    "instance": "3",
    "nature": "Hasty",
    "item": "Life Orb",
    "move1": "Fake Out",
    "move2": "Close Combat",
    "move3": "Overheat",
    "move4": "Stone Edge",
    "speed": 176
  },
  {
    "entry": 744,
    "name": "P 744",
    "species": "Infernape",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Fake Out",
    "move2": "Encore",
    "move3": "Flare Blitz",
    "move4": "Close Combat",
    "speed": 176
  },
  {
    "entry": 341,
    "name": "P 341",
    "species": "Jolteon",
    "instance": "1",
    "nature": "Hasty",
    "item": "Magnet",
    "move1": "Quick Attack",
    "move2": "Thunderbolt",
    "move3": "Thunder Wave",
    "move4": "Swagger",
    "speed": 200
  },
  {
    "entry": 516,
    "name": "P 516",
    "species": "Jolteon",
    "instance": "2",
    "nature": "Timid",
    "item": "Damp Rock",
    "move1": "Thunder",
    "move2": "Protect",
    "move3": "Charm",
    "move4": "Rain Dance",
    "speed": 200
  },
  {
    "entry": 691,
    "name": "P 691",
    "species": "Jolteon",
    "instance": "3",
    "nature": "Timid",
    "item": "King's Rock",
    "move1": "Thunder",
    "move2": "Shadow Ball",
    "move3": "Rain Dance",
    "move4": "Yawn",
    "speed": 200
  },
  {
    "entry": 866,
    "name": "P 866",
    "species": "Jolteon",
    "instance": "4",
    "nature": "Timid",
    "item": "Razor Fang",
    "move1": "Thunderbolt",
    "move2": "Hyper Beam",
    "move3": "Fake Tears",
    "move4": "Signal Beam",
    "speed": 200
  },
  {
    "entry": 229,
    "name": "P 229",
    "species": "Jynx",
    "instance": "1",
    "nature": "Calm",
    "item": "Enigma Berry",
    "move1": "Captivate",
    "move2": "Mean Look",
    "move3": "Lovely Kiss",
    "move4": "Attract",
    "speed": 115
  },
  {
    "entry": 404,
    "name": "P 404",
    "species": "Jynx",
    "instance": "2",
    "nature": "Mild",
    "item": "Destiny Knot",
    "move1": "Frost Breath",
    "move2": "Fake Out",
    "move3": "Psychic",
    "move4": "Taunt",
    "speed": 147
  },
  {
    "entry": 579,
    "name": "P 579",
    "species": "Jynx",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Icy Wind",
    "move2": "Blizzard",
    "move3": "Psychic",
    "move4": "Focus Blast",
    "speed": 147
  },
  {
    "entry": 754,
    "name": "P 754",
    "species": "Jynx",
    "instance": "4",
    "nature": "Timid",
    "item": "Wide Lens",
    "move1": "Lovely Kiss",
    "move2": "Blizzard",
    "move3": "Psychic",
    "move4": "Fake Out",
    "speed": 161
  },
  {
    "entry": 265,
    "name": "P 265",
    "species": "Kangaskhan",
    "instance": "1",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Dizzy Punch",
    "move2": "Fake Out",
    "move3": "Chip Away",
    "move4": "Roar",
    "speed": 142
  },
  {
    "entry": 440,
    "name": "P 440",
    "species": "Kangaskhan",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Rock Slide",
    "move2": "Sucker Punch",
    "move3": "Endure",
    "move4": "Reversal",
    "speed": 156
  },
  {
    "entry": 615,
    "name": "P 615",
    "species": "Kangaskhan",
    "instance": "3",
    "nature": "Jolly",
    "item": "Chople Berry",
    "move1": "Fake Out",
    "move2": "Double-Edge",
    "move3": "Circle Throw",
    "move4": "Sucker Punch",
    "speed": 156
  },
  {
    "entry": 790,
    "name": "P 790",
    "species": "Kangaskhan",
    "instance": "4",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Fake Out",
    "move2": "Endeavor",
    "move3": "Return",
    "move4": "Substitute",
    "speed": 156
  },
  {
    "entry": 367,
    "name": "P 367",
    "species": "Kingdra",
    "instance": "1",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Waterfall",
    "move2": "Quash",
    "move3": "Protect",
    "move4": "Outrage",
    "speed": 126
  },
  {
    "entry": 542,
    "name": "P 542",
    "species": "Kingdra",
    "instance": "2",
    "nature": "Mild",
    "item": "Haban Berry",
    "move1": "Dragon Pulse",
    "move2": "Waterfall",
    "move3": "Ice Beam",
    "move4": "Dragon Dance",
    "speed": 105
  },
  {
    "entry": 717,
    "name": "P 717",
    "species": "Kingdra",
    "instance": "3",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Rain Dance",
    "move2": "Hydro Pump",
    "move3": "Dragon Pulse",
    "move4": "Ice Beam",
    "speed": 126
  },
  {
    "entry": 892,
    "name": "P 892",
    "species": "Kingdra",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Surf",
    "move3": "Blizzard",
    "move4": "Protect",
    "speed": 126
  },
  {
    "entry": 338,
    "name": "P 338",
    "species": "Klinklang",
    "instance": "1",
    "nature": "Impish",
    "item": "Shuca Berry",
    "move1": "Gear Grind",
    "move2": "Thunder Wave",
    "move3": "Screech",
    "move4": "Volt Switch",
    "speed": 142
  },
  {
    "entry": 513,
    "name": "P 513",
    "species": "Klinklang",
    "instance": "2",
    "nature": "Mild",
    "item": "White Herb",
    "move1": "Charge Beam",
    "move2": "Metal Sound",
    "move3": "Flash Cannon",
    "move4": "Autotomize",
    "speed": 142
  },
  {
    "entry": 688,
    "name": "P 688",
    "species": "Klinklang",
    "instance": "3",
    "nature": "Adamant",
    "item": "Occa Berry",
    "move1": "Shift Gear",
    "move2": "Gear Grind",
    "move3": "Volt Switch",
    "move4": "Giga Impact",
    "speed": 142
  },
  {
    "entry": 863,
    "name": "P 863",
    "species": "Klinklang",
    "instance": "4",
    "nature": "Modest",
    "item": "Steel Gem",
    "move1": "Flash Cannon",
    "move2": "Thunderbolt",
    "move3": "Protect",
    "move4": "Toxic",
    "speed": 142
  },
  {
    "entry": 321,
    "name": "P 321",
    "species": "Krookodile",
    "instance": "1",
    "nature": "Naughty",
    "item": "BlackGlasses",
    "move1": "Crunch",
    "move2": "Bulldoze",
    "move3": "Taunt",
    "move4": "Counter",
    "speed": 112
  },
  {
    "entry": 496,
    "name": "P 496",
    "species": "Krookodile",
    "instance": "2",
    "nature": "Naughty",
    "item": "Rock Gem",
    "move1": "Smack Down",
    "move2": "Earthquake",
    "move3": "Pursuit",
    "move4": "Embargo",
    "speed": 112
  },
  {
    "entry": 671,
    "name": "P 671",
    "species": "Krookodile",
    "instance": "3",
    "nature": "Adamant",
    "item": "Dark Gem",
    "move1": "Earthquake",
    "move2": "Crunch",
    "move3": "Stone Edge",
    "move4": "Dragon Tail",
    "speed": 112
  },
  {
    "entry": 846,
    "name": "P 846",
    "species": "Krookodile",
    "instance": "4",
    "nature": "Jolly",
    "item": "Liechi Berry",
    "move1": "Earthquake",
    "move2": "Pursuit",
    "move3": "Low Sweep",
    "move4": "Rock Slide",
    "speed": 158
  },
  {
    "entry": 927,
    "name": "P 927",
    "species": "Landorus",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Smack Down",
    "move4": "Bulldoze",
    "speed": 153
  },
  {
    "entry": 947,
    "name": "P 947",
    "species": "Landorus",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Scarf",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Outrage",
    "move4": "Brick Break",
    "speed": 153
  },
  {
    "entry": 967,
    "name": "P 967",
    "species": "Landorus",
    "instance": "3",
    "nature": "Jolly",
    "item": "Ground Gem",
    "move1": "Sandstorm",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Protect",
    "speed": 168
  },
  {
    "entry": 987,
    "name": "P 987",
    "species": "Landorus",
    "instance": "4",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Earth Power",
    "move2": "Psychic",
    "move3": "Sludge Bomb",
    "move4": "Grass Knot",
    "speed": 168
  },
  {
    "entry": 231,
    "name": "P 231",
    "species": "Lanturn",
    "instance": "1",
    "nature": "Naughty",
    "item": "Salac Berry",
    "move1": "Thunder Wave",
    "move2": "Discharge",
    "move3": "Electro Ball",
    "move4": "Agility",
    "speed": 87
  },
  {
    "entry": 406,
    "name": "P 406",
    "species": "Lanturn",
    "instance": "2",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Thunder Wave",
    "move2": "Charge Beam",
    "move3": "Stockpile",
    "move4": "Swallow",
    "speed": 87
  },
  {
    "entry": 581,
    "name": "P 581",
    "species": "Lanturn",
    "instance": "3",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Surf",
    "move2": "Discharge",
    "move3": "Thunder Wave",
    "move4": "Ice Beam",
    "speed": 87
  },
  {
    "entry": 756,
    "name": "P 756",
    "species": "Lanturn",
    "instance": "4",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Stockpile",
    "move2": "Rest",
    "move3": "Charge Beam",
    "move4": "Ice Beam",
    "speed": 87
  },
  {
    "entry": 357,
    "name": "P 357",
    "species": "Lapras",
    "instance": "1",
    "nature": "Quiet",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Thunder",
    "move3": "Ice Shard",
    "move4": "Confuse Ray",
    "speed": 72
  },
  {
    "entry": 532,
    "name": "P 532",
    "species": "Lapras",
    "instance": "2",
    "nature": "Modest",
    "item": "Mystic Water",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed": 80
  },
  {
    "entry": 707,
    "name": "P 707",
    "species": "Lapras",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Thunderbolt",
    "move4": "Psychic",
    "speed": 80
  },
  {
    "entry": 882,
    "name": "P 882",
    "species": "Lapras",
    "instance": "4",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Perish Song",
    "move2": "Rest",
    "move3": "Body Slam",
    "move4": "Block",
    "speed": 80
  },
  {
    "entry": 923,
    "name": "P 923",
    "species": "Latias",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Calm Mind",
    "move2": "Reflect Type",
    "move3": "Dragon Pulse",
    "move4": "Rest",
    "speed": 130
  },
  {
    "entry": 943,
    "name": "P 943",
    "species": "Latias",
    "instance": "2",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Thunder",
    "move3": "Psychic",
    "move4": "Protect",
    "speed": 178
  },
  {
    "entry": 963,
    "name": "P 963",
    "species": "Latias",
    "instance": "3",
    "nature": "Timid",
    "item": "Choice Specs",
    "move1": "Draco Meteor",
    "move2": "Thunderbolt",
    "move3": "Psychic",
    "move4": "Trick",
    "speed": 178
  },
  {
    "entry": 983,
    "name": "P 983",
    "species": "Latias",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Draco Meteor",
    "move2": "Earthquake",
    "move3": "Hone Claws",
    "move4": "Dragon Claw",
    "speed": 162
  },
  {
    "entry": 924,
    "name": "P 924",
    "species": "Latios",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Calm Mind",
    "move2": "Luster Purge",
    "move3": "Dragon Pulse",
    "move4": "Rest",
    "speed": 130
  },
  {
    "entry": 944,
    "name": "P 944",
    "species": "Latios",
    "instance": "2",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Thunderbolt",
    "move3": "Psychic",
    "move4": "Protect",
    "speed": 178
  },
  {
    "entry": 964,
    "name": "P 964",
    "species": "Latios",
    "instance": "3",
    "nature": "Timid",
    "item": "Choice Specs",
    "move1": "Draco Meteor",
    "move2": "Thunder",
    "move3": "Psychic",
    "move4": "Energy Ball",
    "speed": 178
  },
  {
    "entry": 984,
    "name": "P 984",
    "species": "Latios",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Draco Meteor",
    "move2": "Earthquake",
    "move3": "Dragon Dance",
    "move4": "Outrage",
    "speed": 162
  },
  {
    "entry": 345,
    "name": "P 345",
    "species": "Leafeon",
    "instance": "1",
    "nature": "Impish",
    "item": "Scope Lens",
    "move1": "X-Scissor",
    "move2": "Leaf Blade",
    "move3": "Swords Dance",
    "move4": "GrassWhistle",
    "speed": 147
  },
  {
    "entry": 520,
    "name": "P 520",
    "species": "Leafeon",
    "instance": "2",
    "nature": "Naive",
    "item": "Liechi Berry",
    "move1": "Leaf Blade",
    "move2": "Giga Impact",
    "move3": "Substitute",
    "move4": "Yawn",
    "speed": 161
  },
  {
    "entry": 695,
    "name": "P 695",
    "species": "Leafeon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Heat Rock",
    "move1": "Sunny Day",
    "move2": "Leaf Blade",
    "move3": "X-Scissor",
    "move4": "Synthesis",
    "speed": 115
  },
  {
    "entry": 870,
    "name": "P 870",
    "species": "Leafeon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Leaf Blade",
    "move2": "X-Scissor",
    "move3": "Aerial Ace",
    "move4": "Detect",
    "speed": 115
  },
  {
    "entry": 331,
    "name": "P 331",
    "species": "Lickilicky",
    "instance": "1",
    "nature": "Naive",
    "item": "Sitrus Berry",
    "move1": "Thunderbolt",
    "move2": "Ice Beam",
    "move3": "Me First",
    "move4": "Psych Up",
    "speed": 77
  },
  {
    "entry": 506,
    "name": "P 506",
    "species": "Lickilicky",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Gyro Ball",
    "move2": "Rest",
    "move3": "Curse",
    "move4": "Sleep Talk",
    "speed": 70
  },
  {
    "entry": 681,
    "name": "P 681",
    "species": "Lickilicky",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Return",
    "move2": "Gyro Ball",
    "move3": "Curse",
    "move4": "Rest",
    "speed": 70
  },
  {
    "entry": 856,
    "name": "P 856",
    "species": "Lickilicky",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Body Slam",
    "move2": "Power Whip",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 256,
    "name": "P 256",
    "species": "Lilligant",
    "instance": "1",
    "nature": "Timid",
    "item": "Persim Berry",
    "move1": "Charm",
    "move2": "Sleep Powder",
    "move3": "Petal Dance",
    "move4": "Healing Wish",
    "speed": 156
  },
  {
    "entry": 431,
    "name": "P 431",
    "species": "Lilligant",
    "instance": "2",
    "nature": "Bold",
    "item": "Big Root",
    "move1": "Ingrain",
    "move2": "Leech Seed",
    "move3": "Toxic",
    "move4": "Protect",
    "speed": 110
  },
  {
    "entry": 606,
    "name": "P 606",
    "species": "Lilligant",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Quiver Dance",
    "move2": "Energy Ball",
    "move3": "Leech Seed",
    "move4": "Protect",
    "speed": 110
  },
  {
    "entry": 781,
    "name": "P 781",
    "species": "Lilligant",
    "instance": "4",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "SolarBeam",
    "move2": "Teeter Dance",
    "move3": "Charm",
    "move4": "Leech Seed",
    "speed": 126
  },
  {
    "entry": 254,
    "name": "P 254",
    "species": "Lopunny",
    "instance": "1",
    "nature": "Naive",
    "item": "Toxic Orb",
    "move1": "Fake Out",
    "move2": "Encore",
    "move3": "Fling",
    "move4": "Dizzy Punch",
    "speed": 172
  },
  {
    "entry": 429,
    "name": "P 429",
    "species": "Lopunny",
    "instance": "2",
    "nature": "Jolly",
    "item": "Liechi Berry",
    "move1": "Charm",
    "move2": "Focus Punch",
    "move3": "Substitute",
    "move4": "ThunderPunch",
    "speed": 172
  },
  {
    "entry": 604,
    "name": "P 604",
    "species": "Lopunny",
    "instance": "3",
    "nature": "Jolly",
    "item": "Chople Berry",
    "move1": "Encore",
    "move2": "Fake Out",
    "move3": "Focus Punch",
    "move4": "Mirror Coat",
    "speed": 172
  },
  {
    "entry": 779,
    "name": "P 779",
    "species": "Lopunny",
    "instance": "4",
    "nature": "Jolly",
    "item": "Flame Orb",
    "move1": "Switcheroo",
    "move2": "Mirror Coat",
    "move3": "Protect",
    "move4": "Dig",
    "speed": 172
  },
  {
    "entry": 347,
    "name": "P 347",
    "species": "Lucario",
    "instance": "1",
    "nature": "Modest",
    "item": "Black Belt",
    "move1": "Metal Sound",
    "move2": "Dark Pulse",
    "move3": "Aura Sphere",
    "move4": "Heal Pulse",
    "speed": 142
  },
  {
    "entry": 522,
    "name": "P 522",
    "species": "Lucario",
    "instance": "2",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Close Combat",
    "move2": "Hone Claws",
    "move3": "Endure",
    "move4": "Reversal",
    "speed": 156
  },
  {
    "entry": 697,
    "name": "P 697",
    "species": "Lucario",
    "instance": "3",
    "nature": "Jolly",
    "item": "Muscle Band",
    "move1": "Close Combat",
    "move2": "Earthquake",
    "move3": "Blaze Kick",
    "move4": "Shadow Claw",
    "speed": 156
  },
  {
    "entry": 872,
    "name": "P 872",
    "species": "Lucario",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Aura Sphere",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Follow Me",
    "speed": 142
  },
  {
    "entry": 251,
    "name": "P 251",
    "species": "Ludicolo",
    "instance": "1",
    "nature": "Lax",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Toxic",
    "move3": "Giga Drain",
    "move4": "Rain Dance",
    "speed": 90
  },
  {
    "entry": 426,
    "name": "P 426",
    "species": "Ludicolo",
    "instance": "2",
    "nature": "Naughty",
    "item": "Tanga Berry",
    "move1": "Fake Out",
    "move2": "Grass Knot",
    "move3": "Surf",
    "move4": "Tickle",
    "speed": 90
  },
  {
    "entry": 601,
    "name": "P 601",
    "species": "Ludicolo",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Rain Dance",
    "move2": "Leech Seed",
    "move3": "Protect",
    "move4": "Giga Drain",
    "speed": 90
  },
  {
    "entry": 776,
    "name": "P 776",
    "species": "Ludicolo",
    "instance": "4",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Fake Out",
    "move2": "Hydro Pump",
    "move3": "Leech Seed",
    "move4": "Grass Knot",
    "speed": 122
  },
  {
    "entry": 312,
    "name": "P 312",
    "species": "Luxray",
    "instance": "1",
    "nature": "Lonely",
    "item": "Magnet",
    "move1": "Wild Charge",
    "move2": "Crunch",
    "move3": "Captivate",
    "move4": "Swagger",
    "speed": 90
  },
  {
    "entry": 487,
    "name": "P 487",
    "species": "Luxray",
    "instance": "2",
    "nature": "Careful",
    "item": "Quick Claw",
    "move1": "Charge Beam",
    "move2": "Helping Hand",
    "move3": "Discharge",
    "move4": "Roar",
    "speed": 90
  },
  {
    "entry": 662,
    "name": "P 662",
    "species": "Luxray",
    "instance": "3",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Thunder Fang",
    "move2": "Ice Fang",
    "move3": "Superpower",
    "move4": "Thunder Wave",
    "speed": 90
  },
  {
    "entry": 837,
    "name": "P 837",
    "species": "Luxray",
    "instance": "4",
    "nature": "Careful",
    "item": "Air Balloon",
    "move1": "Thunder Fang",
    "move2": "Ice Fang",
    "move3": "Light Screen",
    "move4": "Thunder Wave",
    "speed": 90
  },
  {
    "entry": 314,
    "name": "P 314",
    "species": "Machamp",
    "instance": "1",
    "nature": "Brave",
    "item": "Rawst Berry",
    "move1": "DynamicPunch",
    "move2": "Payback",
    "move3": "Foresight",
    "move4": "Wide Guard",
    "speed": 67
  },
  {
    "entry": 489,
    "name": "P 489",
    "species": "Machamp",
    "instance": "2",
    "nature": "Brave",
    "item": "Expert Belt",
    "move1": "Ice Punch",
    "move2": "Cross Chop",
    "move3": "Fire Punch",
    "move4": "Focus Energy",
    "speed": 67
  },
  {
    "entry": 664,
    "name": "P 664",
    "species": "Machamp",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "DynamicPunch",
    "move2": "Ice Punch",
    "move3": "Rock Slide",
    "move4": "Earthquake",
    "speed": 117
  },
  {
    "entry": 839,
    "name": "P 839",
    "species": "Machamp",
    "instance": "4",
    "nature": "Adamant",
    "item": "Flame Orb",
    "move1": "Protect",
    "move2": "Earthquake",
    "move3": "Close Combat",
    "move4": "Payback",
    "speed": 75
  },
  {
    "entry": 371,
    "name": "P 371",
    "species": "Magmortar",
    "instance": "1",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Flame Charge",
    "move2": "Earthquake",
    "move3": "Confuse Ray",
    "move4": "Barrier",
    "speed": 103
  },
  {
    "entry": 546,
    "name": "P 546",
    "species": "Magmortar",
    "instance": "2",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Fire Blast",
    "move2": "Flame Burst",
    "move3": "Focus Blast",
    "move4": "Taunt",
    "speed": 135
  },
  {
    "entry": 721,
    "name": "P 721",
    "species": "Magmortar",
    "instance": "3",
    "nature": "Jolly",
    "item": "Passho Berry",
    "move1": "Flare Blitz",
    "move2": "ThunderPunch",
    "move3": "Earthquake",
    "move4": "Brick Break",
    "speed": 148
  },
  {
    "entry": 896,
    "name": "P 896",
    "species": "Magmortar",
    "instance": "4",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Protect",
    "speed": 148
  },
  {
    "entry": 359,
    "name": "P 359",
    "species": "Magnezone",
    "instance": "1",
    "nature": "Rash",
    "item": "Magnet",
    "move1": "Metal Sound",
    "move2": "Flash Cannon",
    "move3": "Thunderbolt",
    "move4": "Magnet Rise",
    "speed": 80
  },
  {
    "entry": 534,
    "name": "P 534",
    "species": "Magnezone",
    "instance": "2",
    "nature": "Quiet",
    "item": "Shuca Berry",
    "move1": "Charge Beam",
    "move2": "Thunder Wave",
    "move3": "Flash Cannon",
    "move4": "Mirror Coat",
    "speed": 72
  },
  {
    "entry": 709,
    "name": "P 709",
    "species": "Magnezone",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Charge Beam",
    "move2": "Flash Cannon",
    "move3": "Magnet Rise",
    "move4": "Thunder Wave",
    "speed": 80
  },
  {
    "entry": 884,
    "name": "P 884",
    "species": "Magnezone",
    "instance": "4",
    "nature": "Modest",
    "item": "Electric Gem",
    "move1": "Thunderbolt",
    "move2": "Flash Cannon",
    "move3": "Tri Attack",
    "move4": "Volt Switch",
    "speed": 80
  },
  {
    "entry": 356,
    "name": "P 356",
    "species": "Mamoswine",
    "instance": "1",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Double Hit",
    "move2": "Earthquake",
    "move3": "Ice Shard",
    "move4": "Stealth Rock",
    "speed": 121
  },
  {
    "entry": 531,
    "name": "P 531",
    "species": "Mamoswine",
    "instance": "2",
    "nature": "Brave",
    "item": "Zoom Lens",
    "move1": "Stone Edge",
    "move2": "Bulldoze",
    "move3": "Blizzard",
    "move4": "Ice Fang",
    "speed": 90
  },
  {
    "entry": 706,
    "name": "P 706",
    "species": "Mamoswine",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Hail",
    "move2": "Earthquake",
    "move3": "Superpower",
    "move4": "Fissure",
    "speed": 100
  },
  {
    "entry": 881,
    "name": "P 881",
    "species": "Mamoswine",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Earthquake",
    "move2": "Ice Fang",
    "move3": "Double-Edge",
    "move4": "Stone Edge",
    "speed": 100
  },
  {
    "entry": 326,
    "name": "P 326",
    "species": "Mandibuzz",
    "instance": "1",
    "nature": "Calm",
    "item": "Wacan Berry",
    "move1": "Taunt",
    "move2": "Flatter",
    "move3": "Roost",
    "move4": "Toxic",
    "speed": 132
  },
  {
    "entry": 501,
    "name": "P 501",
    "species": "Mandibuzz",
    "instance": "2",
    "nature": "Mild",
    "item": "Flying Gem",
    "move1": "Dark Pulse",
    "move2": "Air Slash",
    "move3": "Shadow Ball",
    "move4": "Nasty Plot",
    "speed": 132
  },
  {
    "entry": 676,
    "name": "P 676",
    "species": "Mandibuzz",
    "instance": "3",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Nasty Plot",
    "move2": "Dark Pulse",
    "move3": "Air Slash",
    "move4": "Incinerate",
    "speed": 100
  },
  {
    "entry": 851,
    "name": "P 851",
    "species": "Mandibuzz",
    "instance": "4",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Substitute",
    "move2": "Swagger",
    "move3": "Punishment",
    "move4": "Roost",
    "speed": 100
  },
  {
    "entry": 241,
    "name": "P 241",
    "species": "Manectric",
    "instance": "1",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Crunch",
    "move2": "Odor Sleuth",
    "move3": "Quick Attack",
    "move4": "Wild Charge",
    "speed": 157
  },
  {
    "entry": 416,
    "name": "P 416",
    "species": "Manectric",
    "instance": "2",
    "nature": "Modest",
    "item": "Charcoal",
    "move1": "Flamethrower",
    "move2": "Overheat",
    "move3": "Discharge",
    "move4": "Charge",
    "speed": 157
  },
  {
    "entry": 591,
    "name": "P 591",
    "species": "Manectric",
    "instance": "3",
    "nature": "Timid",
    "item": "Air Balloon",
    "move1": "Thunderbolt",
    "move2": "Overheat",
    "move3": "Volt Switch",
    "move4": "Quick Attack",
    "speed": 172
  },
  {
    "entry": 766,
    "name": "P 766",
    "species": "Manectric",
    "instance": "4",
    "nature": "Timid",
    "item": "Choice Scarf",
    "move1": "Switcheroo",
    "move2": "Thunder",
    "move3": "Volt Switch",
    "move4": "Overheat",
    "speed": 172
  },
  {
    "entry": 225,
    "name": "P 225",
    "species": "Marowak",
    "instance": "1",
    "nature": "Careful",
    "item": "Salac Berry",
    "move1": "Substitute",
    "move2": "Detect",
    "move3": "Earthquake",
    "move4": "Swords Dance",
    "speed": 65
  },
  {
    "entry": 400,
    "name": "P 400",
    "species": "Marowak",
    "instance": "2",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Earthquake",
    "move2": "Fling",
    "move3": "Brick Break",
    "move4": "Detect",
    "speed": 29
  },
  {
    "entry": 575,
    "name": "P 575",
    "species": "Marowak",
    "instance": "3",
    "nature": "Jolly",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Low Kick",
    "move4": "Fire Punch",
    "speed": 106
  },
  {
    "entry": 750,
    "name": "P 750",
    "species": "Marowak",
    "instance": "4",
    "nature": "Jolly",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Outrage",
    "move3": "Detect",
    "move4": "Rock Slide",
    "speed": 106
  },
  {
    "entry": 226,
    "name": "P 226",
    "species": "Medicham",
    "instance": "1",
    "nature": "Impish",
    "item": "Black Belt",
    "move1": "Fake Out",
    "move2": "Hi Jump Kick",
    "move3": "Bulk Up",
    "move4": "Feint",
    "speed": 132
  },
  {
    "entry": 401,
    "name": "P 401",
    "species": "Medicham",
    "instance": "2",
    "nature": "Timid",
    "item": "TwistedSpoon",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Energy Ball",
    "move4": "Calm Mind",
    "speed": 145
  },
  {
    "entry": 576,
    "name": "P 576",
    "species": "Medicham",
    "instance": "3",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Hi Jump Kick",
    "move2": "Zen Headbutt",
    "move3": "Ice Punch",
    "move4": "Bullet Punch",
    "speed": 145
  },
  {
    "entry": 751,
    "name": "P 751",
    "species": "Medicham",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Hi Jump Kick",
    "move2": "Psycho Cut",
    "move3": "Fake Out",
    "move4": "Detect",
    "speed": 132
  },
  {
    "entry": 212,
    "name": "P 212",
    "species": "Meganium",
    "instance": "1",
    "nature": "Gentle",
    "item": "Sitrus Berry",
    "move1": "Light Screen",
    "move2": "Aromatherapy",
    "move3": "Swagger",
    "move4": "SolarBeam",
    "speed": 100
  },
  {
    "entry": 387,
    "name": "P 387",
    "species": "Meganium",
    "instance": "2",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "GrassWhistle",
    "move2": "Double Team",
    "move3": "Substitute",
    "move4": "Rest",
    "speed": 100
  },
  {
    "entry": 562,
    "name": "P 562",
    "species": "Meganium",
    "instance": "3",
    "nature": "Adamant",
    "item": "Light Clay",
    "move1": "Seed Bomb",
    "move2": "Earthquake",
    "move3": "Reflect",
    "move4": "Light Screen",
    "speed": 100
  },
  {
    "entry": 737,
    "name": "P 737",
    "species": "Meganium",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Ingrain",
    "move3": "Toxic",
    "move4": "Protect",
    "speed": 100
  },
  {
    "entry": 380,
    "name": "P 380",
    "species": "Metagross",
    "instance": "1",
    "nature": "Naive",
    "item": "Occa Berry",
    "move1": "Meteor Mash",
    "move2": "Magnet Rise",
    "move3": "Zen Headbutt",
    "move4": "Agility",
    "speed": 134
  },
  {
    "entry": 555,
    "name": "P 555",
    "species": "Metagross",
    "instance": "2",
    "nature": "Quiet",
    "item": "Occa Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Meteor Mash",
    "move4": "Magnet Rise",
    "speed": 81
  },
  {
    "entry": 730,
    "name": "P 730",
    "species": "Metagross",
    "instance": "3",
    "nature": "Adamant",
    "item": "Occa Berry",
    "move1": "Earthquake",
    "move2": "Meteor Mash",
    "move3": "Bullet Punch",
    "move4": "Explosion",
    "speed": 90
  },
  {
    "entry": 905,
    "name": "P 905",
    "species": "Metagross",
    "instance": "4",
    "nature": "Careful",
    "item": "Toxic Orb",
    "move1": "Trick",
    "move2": "Meteor Mash",
    "move3": "Protect",
    "move4": "Earthquake",
    "speed": 90
  },
  {
    "entry": 351,
    "name": "P 351",
    "species": "Mienshao",
    "instance": "1",
    "nature": "Naive",
    "item": "Salac Berry",
    "move1": "U-turn",
    "move2": "Endure",
    "move3": "Calm Mind",
    "move4": "Baton Pass",
    "speed": 172
  },
  {
    "entry": 526,
    "name": "P 526",
    "species": "Mienshao",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Fake Out",
    "move2": "Fling",
    "move3": "Acrobatics",
    "move4": "Hi Jump Kick",
    "speed": 172
  },
  {
    "entry": 701,
    "name": "P 701",
    "species": "Mienshao",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Low Kick",
    "move2": "Fake Out",
    "move3": "Hi Jump Kick",
    "move4": "U-turn",
    "speed": 172
  },
  {
    "entry": 876,
    "name": "P 876",
    "species": "Mienshao",
    "instance": "4",
    "nature": "Impish",
    "item": "Muscle Band",
    "move1": "Feint",
    "move2": "Fake Out",
    "move3": "Hi Jump Kick",
    "move4": "Wide Guard",
    "speed": 125
  },
  {
    "entry": 369,
    "name": "P 369",
    "species": "Milotic",
    "instance": "1",
    "nature": "Bold",
    "item": "Enigma Berry",
    "move1": "Surf",
    "move2": "Recover",
    "move3": "Mirror Coat",
    "move4": "Confuse Ray",
    "speed": 101
  },
  {
    "entry": 544,
    "name": "P 544",
    "species": "Milotic",
    "instance": "2",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Hydro Pump",
    "move2": "Toxic",
    "move3": "Attract",
    "move4": "Aqua Ring",
    "speed": 90
  },
  {
    "entry": 719,
    "name": "P 719",
    "species": "Milotic",
    "instance": "3",
    "nature": "Calm",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Mirror Coat",
    "move4": "Recover",
    "speed": 101
  },
  {
    "entry": 894,
    "name": "P 894",
    "species": "Milotic",
    "instance": "4",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Ice Beam",
    "move2": "Rest",
    "move3": "Sleep Talk",
    "move4": "Surf",
    "speed": 101
  },
  {
    "entry": 275,
    "name": "P 275",
    "species": "Miltank",
    "instance": "1",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Body Slam",
    "move2": "Helping Hand",
    "move3": "Milk Drink",
    "move4": "Heal Bell",
    "speed": 167
  },
  {
    "entry": 450,
    "name": "P 450",
    "species": "Miltank",
    "instance": "2",
    "nature": "Naive",
    "item": "Razor Fang",
    "move1": "Body Slam",
    "move2": "Fling",
    "move3": "Brick Break",
    "move4": "Captivate",
    "speed": 167
  },
  {
    "entry": 625,
    "name": "P 625",
    "species": "Miltank",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Dizzy Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 120
  },
  {
    "entry": 800,
    "name": "P 800",
    "species": "Miltank",
    "instance": "4",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Substitute",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Zen Headbutt",
    "speed": 167
  },
  {
    "entry": 289,
    "name": "P 289",
    "species": "Mismagius",
    "instance": "1",
    "nature": "Naive",
    "item": "Colbur Berry",
    "move1": "Taunt",
    "move2": "Protect",
    "move3": "Imprison",
    "move4": "Shadow Ball",
    "speed": 172
  },
  {
    "entry": 464,
    "name": "P 464",
    "species": "Mismagius",
    "instance": "2",
    "nature": "Timid",
    "item": "Kasib Berry",
    "move1": "Shadow Ball",
    "move2": "Wonder Room",
    "move3": "Grudge",
    "move4": "Pain Split",
    "speed": 137
  },
  {
    "entry": 639,
    "name": "P 639",
    "species": "Mismagius",
    "instance": "3",
    "nature": "Timid",
    "item": "Sitrus Berry",
    "move1": "Icy Wind",
    "move2": "Shadow Ball",
    "move3": "Thunderbolt",
    "move4": "Destiny Bond",
    "speed": 172
  },
  {
    "entry": 814,
    "name": "P 814",
    "species": "Mismagius",
    "instance": "4",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Confuse Ray",
    "move2": "Protect",
    "move3": "Perish Song",
    "move4": "Mean Look",
    "speed": 125
  },
  {
    "entry": 911,
    "name": "P 911",
    "species": "Moltres",
    "instance": "1",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Air Slash",
    "move3": "Tailwind",
    "move4": "Will-O-Wisp",
    "speed": 142
  },
  {
    "entry": 931,
    "name": "P 931",
    "species": "Moltres",
    "instance": "2",
    "nature": "Naughty",
    "item": "Power Herb",
    "move1": "Flame Charge",
    "move2": "Sky Attack",
    "move3": "Aerial Ace",
    "move4": "Fire Blast",
    "speed": 142
  },
  {
    "entry": 951,
    "name": "P 951",
    "species": "Moltres",
    "instance": "3",
    "nature": "Timid",
    "item": "Heat Rock",
    "move1": "Sunny Day",
    "move2": "SolarBeam",
    "move3": "Flamethrower",
    "move4": "Air Slash",
    "speed": 156
  },
  {
    "entry": 971,
    "name": "P 971",
    "species": "Moltres",
    "instance": "4",
    "nature": "Timid",
    "item": "Charcoal",
    "move1": "Heat Wave",
    "move2": "Incinerate",
    "move3": "Air Slash",
    "move4": "Protect",
    "speed": 156
  },
  {
    "entry": 230,
    "name": "P 230",
    "species": "Mr. Mime",
    "instance": "1",
    "nature": "Naive",
    "item": "Choice Scarf",
    "move1": "Trick",
    "move2": "Nasty Plot",
    "move3": "Barrier",
    "move4": "Baton Pass",
    "speed": 121
  },
  {
    "entry": 405,
    "name": "P 405",
    "species": "Mr. Mime",
    "instance": "2",
    "nature": "Lonely",
    "item": "Jaboca Berry",
    "move1": "Payback",
    "move2": "Wide Guard",
    "move3": "Quick Guard",
    "move4": "Power Split",
    "speed": 110
  },
  {
    "entry": 580,
    "name": "P 580",
    "species": "Mr. Mime",
    "instance": "3",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Fake Out",
    "move2": "Psychic",
    "move3": "Signal Beam",
    "move4": "Focus Blast",
    "speed": 156
  },
  {
    "entry": 755,
    "name": "P 755",
    "species": "Mr. Mime",
    "instance": "4",
    "nature": "Bold",
    "item": "Light Clay",
    "move1": "Light Screen",
    "move2": "Reflect",
    "move3": "Psychic",
    "move4": "Signal Beam",
    "speed": 110
  },
  {
    "entry": 298,
    "name": "P 298",
    "species": "Muk",
    "instance": "1",
    "nature": "Brave",
    "item": "Black Sludge",
    "move1": "Poison Jab",
    "move2": "Stockpile",
    "move3": "Swallow",
    "move4": "Memento",
    "speed": 63
  },
  {
    "entry": 473,
    "name": "P 473",
    "species": "Muk",
    "instance": "2",
    "nature": "Lonely",
    "item": "Toxic Plate",
    "move1": "Shadow Sneak",
    "move2": "Poison Jab",
    "move3": "Acid Armor",
    "move4": "Flamethrower",
    "speed": 70
  },
  {
    "entry": 648,
    "name": "P 648",
    "species": "Muk",
    "instance": "3",
    "nature": "Brave",
    "item": "Zoom Lens",
    "move1": "Gunk Shot",
    "move2": "Payback",
    "move3": "Shadow Sneak",
    "move4": "Curse",
    "speed": 63
  },
  {
    "entry": 823,
    "name": "P 823",
    "species": "Muk",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Gunk Shot",
    "move2": "Shadow Sneak",
    "move3": "Brick Break",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 270,
    "name": "P 270",
    "species": "Musharna",
    "instance": "1",
    "nature": "Mild",
    "item": "Zoom Lens",
    "move1": "Hypnosis",
    "move2": "Dream Eater",
    "move3": "Calm Mind",
    "move4": "Helping Hand",
    "speed": 49
  },
  {
    "entry": 445,
    "name": "P 445",
    "species": "Musharna",
    "instance": "2",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "Shadow Ball",
    "move2": "Energy Ball",
    "move3": "Psychic",
    "move4": "Trick Room",
    "speed": 49
  },
  {
    "entry": 620,
    "name": "P 620",
    "species": "Musharna",
    "instance": "3",
    "nature": "Modest",
    "item": "Scope Lens",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Energy Ball",
    "move4": "Yawn",
    "speed": 49
  },
  {
    "entry": 795,
    "name": "P 795",
    "species": "Musharna",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Chesto Berry",
    "move1": "Stored Power",
    "move2": "Calm Mind",
    "move3": "Shadow Ball",
    "move4": "Rest",
    "speed": 44
  },
  {
    "entry": 283,
    "name": "P 283",
    "species": "Nidoking",
    "instance": "1",
    "nature": "Naughty",
    "item": "King's Rock",
    "move1": "Bulldoze",
    "move2": "Megahorn",
    "move3": "Rock Slide",
    "move4": "Hone Claws",
    "speed": 105
  },
  {
    "entry": 458,
    "name": "P 458",
    "species": "Nidoking",
    "instance": "2",
    "nature": "Quiet",
    "item": "Black Sludge",
    "move1": "Amnesia",
    "move2": "Sludge Bomb",
    "move3": "Flamethrower",
    "move4": "Protect",
    "speed": 94
  },
  {
    "entry": 633,
    "name": "P 633",
    "species": "Nidoking",
    "instance": "3",
    "nature": "Modest",
    "item": "Black Sludge",
    "move1": "Earth Power",
    "move2": "Sludge Bomb",
    "move3": "Protect",
    "move4": "Icy Wind",
    "speed": 137
  },
  {
    "entry": 808,
    "name": "P 808",
    "species": "Nidoking",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Earthquake",
    "move2": "Poison Jab",
    "move3": "Megahorn",
    "move4": "Protect",
    "speed": 137
  },
  {
    "entry": 282,
    "name": "P 282",
    "species": "Nidoqueen",
    "instance": "1",
    "nature": "Relaxed",
    "item": "Payapa Berry",
    "move1": "Chip Away",
    "move2": "Swagger",
    "move3": "Helping Hand",
    "move4": "Flatter",
    "speed": 86
  },
  {
    "entry": 457,
    "name": "P 457",
    "species": "Nidoqueen",
    "instance": "2",
    "nature": "Mild",
    "item": "Absorb Bulb",
    "move1": "Thunderbolt",
    "move2": "Hyper Beam",
    "move3": "Earth Power",
    "move4": "Counter",
    "speed": 96
  },
  {
    "entry": 632,
    "name": "P 632",
    "species": "Nidoqueen",
    "instance": "3",
    "nature": "Modest",
    "item": "Black Sludge",
    "move1": "Sludge Bomb",
    "move2": "Earth Power",
    "move3": "Flamethrower",
    "move4": "Ice Beam",
    "speed": 96
  },
  {
    "entry": 807,
    "name": "P 807",
    "species": "Nidoqueen",
    "instance": "4",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Poison Jab",
    "move2": "Dragon Tail",
    "move3": "Bulldoze",
    "move4": "Earthquake",
    "speed": 96
  },
  {
    "entry": 313,
    "name": "P 313",
    "species": "Ninetales",
    "instance": "1",
    "nature": "Modest",
    "item": "Passho Berry",
    "move1": "Will-O-Wisp",
    "move2": "Hypnosis",
    "move3": "Extrasensory",
    "move4": "Heat Wave",
    "speed": 152
  },
  {
    "entry": 488,
    "name": "P 488",
    "species": "Ninetales",
    "instance": "2",
    "nature": "Timid",
    "item": "Fire Gem",
    "move1": "Heat Wave",
    "move2": "Roar",
    "move3": "Confuse Ray",
    "move4": "Nasty Plot",
    "speed": 167
  },
  {
    "entry": 663,
    "name": "P 663",
    "species": "Ninetales",
    "instance": "3",
    "nature": "Timid",
    "item": "Wide Lens",
    "move1": "Fire Blast",
    "move2": "Extrasensory",
    "move3": "Hypnosis",
    "move4": "Disable",
    "speed": 167
  },
  {
    "entry": 838,
    "name": "P 838",
    "species": "Ninetales",
    "instance": "4",
    "nature": "Timid",
    "item": "Passho Berry",
    "move1": "Flamethrower",
    "move2": "Extrasensory",
    "move3": "Energy Ball",
    "move4": "Calm Mind",
    "speed": 167
  },
  {
    "entry": 302,
    "name": "P 302",
    "species": "Pinsir",
    "instance": "1",
    "nature": "Naughty",
    "item": "Persim Berry",
    "move1": "Bug Bite",
    "move2": "Brick Break",
    "move3": "Thrash",
    "move4": "Swords Dance",
    "speed": 137
  },
  {
    "entry": 477,
    "name": "P 477",
    "species": "Pinsir",
    "instance": "2",
    "nature": "Lonely",
    "item": "Insect Plate",
    "move1": "Feint",
    "move2": "X-Scissor",
    "move3": "Stone Edge",
    "move4": "Bug Bite",
    "speed": 137
  },
  {
    "entry": 652,
    "name": "P 652",
    "species": "Pinsir",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "X-Scissor",
    "move2": "Superpower",
    "move3": "Stone Edge",
    "move4": "Giga Impact",
    "speed": 105
  },
  {
    "entry": 827,
    "name": "P 827",
    "species": "Pinsir",
    "instance": "4",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "X-Scissor",
    "move2": "Earthquake",
    "move3": "Close Combat",
    "move4": "Guillotine",
    "speed": 150
  },
  {
    "entry": 301,
    "name": "P 301",
    "species": "Politoed",
    "instance": "1",
    "nature": "Modest",
    "item": "Full Incense",
    "move1": "Waterfall",
    "move2": "Encore",
    "move3": "Swagger",
    "move4": "Bounce",
    "speed": 0
  },
  {
    "entry": 476,
    "name": "P 476",
    "species": "Politoed",
    "instance": "2",
    "nature": "Brave",
    "item": "Water Gem",
    "move1": "Thief",
    "move2": "Echoed Voice",
    "move3": "Refresh",
    "move4": "Hydro Pump",
    "speed": 81
  },
  {
    "entry": 651,
    "name": "P 651",
    "species": "Politoed",
    "instance": "3",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Belly Drum",
    "move4": "Rest",
    "speed": 90
  },
  {
    "entry": 826,
    "name": "P 826",
    "species": "Politoed",
    "instance": "4",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Focus Blast",
    "move4": "Hypnosis",
    "speed": 90
  },
  {
    "entry": 296,
    "name": "P 296",
    "species": "Poliwrath",
    "instance": "1",
    "nature": "Naughty",
    "item": "Sitrus Berry",
    "move1": "Ice Beam",
    "move2": "Waterfall",
    "move3": "Psychic",
    "move4": "Work Up",
    "speed": 90
  },
  {
    "entry": 471,
    "name": "P 471",
    "species": "Poliwrath",
    "instance": "2",
    "nature": "Naive",
    "item": "Shell Bell",
    "move1": "Brick Break",
    "move2": "Waterfall",
    "move3": "Hypnosis",
    "move4": "Belly Drum",
    "speed": 99
  },
  {
    "entry": 646,
    "name": "P 646",
    "species": "Poliwrath",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Waterfall",
    "move2": "Focus Punch",
    "move3": "Encore",
    "move4": "Substitute",
    "speed": 90
  },
  {
    "entry": 821,
    "name": "P 821",
    "species": "Poliwrath",
    "instance": "4",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Focus Punch",
    "move4": "Circle Throw",
    "speed": 90
  },
  {
    "entry": 330,
    "name": "P 330",
    "species": "Porygon2",
    "instance": "1",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Blizzard",
    "move2": "Magic Coat",
    "move3": "Lock-On",
    "move4": "Zap Cannon",
    "speed": 80
  },
  {
    "entry": 505,
    "name": "P 505",
    "species": "Porygon2",
    "instance": "2",
    "nature": "Calm",
    "item": "Petaya Berry",
    "move1": "Tri Attack",
    "move2": "Psychic",
    "move3": "Recycle",
    "move4": "Recover",
    "speed": 80
  },
  {
    "entry": 680,
    "name": "P 680",
    "species": "Porygon2",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Tri Attack",
    "move2": "Thunderbolt",
    "move3": "Psychic",
    "move4": "Ice Beam",
    "speed": 80
  },
  {
    "entry": 855,
    "name": "P 855",
    "species": "Porygon2",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Tri Attack",
    "move2": "Thunder Wave",
    "move3": "Shadow Ball",
    "move4": "Ice Beam",
    "speed": 80
  },
  {
    "entry": 362,
    "name": "P 362",
    "species": "Porygon-Z",
    "instance": "1",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Thunderbolt",
    "move4": "Thunder Wave",
    "speed": 142
  },
  {
    "entry": 537,
    "name": "P 537",
    "species": "Porygon-Z",
    "instance": "2",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Hyper Beam",
    "move2": "",
    "move3": "",
    "move4": "",
    "speed": 142
  },
  {
    "entry": 712,
    "name": "P 712",
    "species": "Porygon-Z",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Charge Beam",
    "speed": 110
  },
  {
    "entry": 887,
    "name": "P 887",
    "species": "Porygon-Z",
    "instance": "4",
    "nature": "Timid",
    "item": "Sitrus Berry",
    "move1": "Tri Attack",
    "move2": "Thunderbolt",
    "move3": "Shadow Ball",
    "move4": "Recover",
    "speed": 156
  },
  {
    "entry": 349,
    "name": "P 349",
    "species": "Probopass",
    "instance": "1",
    "nature": "Calm",
    "item": "Cheri Berry",
    "move1": "Smack Down",
    "move2": "Volt Switch",
    "move3": "Thunder Wave",
    "move4": "Magnet Rise",
    "speed": 60
  },
  {
    "entry": 524,
    "name": "P 524",
    "species": "Probopass",
    "instance": "2",
    "nature": "Bold",
    "item": "Sitrus Berry",
    "move1": "Block",
    "move2": "Iron Defense",
    "move3": "Flash Cannon",
    "move4": "Discharge",
    "speed": 60
  },
  {
    "entry": 699,
    "name": "P 699",
    "species": "Probopass",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Stone Edge",
    "move2": "Iron Head",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 60
  },
  {
    "entry": 874,
    "name": "P 874",
    "species": "Probopass",
    "instance": "4",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Flash Cannon",
    "move2": "Power Gem",
    "move3": "Earth Power",
    "move4": "Thunderbolt",
    "speed": 60
  },
  {
    "entry": 227,
    "name": "P 227",
    "species": "Quagsire",
    "instance": "1",
    "nature": "Impish",
    "item": "Rindo Berry",
    "move1": "Rest",
    "move2": "Sleep Talk",
    "move3": "Toxic",
    "move4": "Bulldoze",
    "speed": 55
  },
  {
    "entry": 402,
    "name": "P 402",
    "species": "Quagsire",
    "instance": "2",
    "nature": "Impish",
    "item": "Iron Ball",
    "move1": "Earthquake",
    "move2": "Stockpile",
    "move3": "Fling",
    "move4": "Swallow",
    "speed": 27
  },
  {
    "entry": 577,
    "name": "P 577",
    "species": "Quagsire",
    "instance": "3",
    "nature": "Adamant",
    "item": "Rindo Berry",
    "move1": "Earthquake",
    "move2": "Aqua Tail",
    "move3": "Ice Punch",
    "move4": "Stone Edge",
    "speed": 55
  },
  {
    "entry": 752,
    "name": "P 752",
    "species": "Quagsire",
    "instance": "4",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Curse",
    "move2": "Amnesia",
    "move3": "Earthquake",
    "move4": "Waterfall",
    "speed": 55
  },
  {
    "entry": 239,
    "name": "P 239",
    "species": "Raichu",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Encore",
    "move2": "Thief",
    "move3": "Thunder Wave",
    "move4": "Discharge",
    "speed": 152
  },
  {
    "entry": 414,
    "name": "P 414",
    "species": "Raichu",
    "instance": "2",
    "nature": "Jolly",
    "item": "Magnet",
    "move1": "Brick Break",
    "move2": "Electro Ball",
    "move3": "Fake Out",
    "move4": "Protect",
    "speed": 167
  },
  {
    "entry": 589,
    "name": "P 589",
    "species": "Raichu",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "ThunderPunch",
    "move2": "Reversal",
    "move3": "Thunder Wave",
    "move4": "Fake Out",
    "speed": 167
  },
  {
    "entry": 764,
    "name": "P 764",
    "species": "Raichu",
    "instance": "4",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Encore",
    "move2": "Magnet Rise",
    "move3": "Thunderbolt",
    "move4": "Grass Knot",
    "speed": 167
  },
  {
    "entry": 912,
    "name": "P 912",
    "species": "Raikou",
    "instance": "1",
    "nature": "Timid",
    "item": "Shuca Berry",
    "move1": "Thunderbolt",
    "move2": "Volt Switch",
    "move3": "Shadow Ball",
    "move4": "Extrasensory",
    "speed": 183
  },
  {
    "entry": 932,
    "name": "P 932",
    "species": "Raikou",
    "instance": "2",
    "nature": "Timid",
    "item": "Leftovers",
    "move1": "Charge Beam",
    "move2": "Magnet Rise",
    "move3": "Calm Mind",
    "move4": "Shadow Ball",
    "speed": 183
  },
  {
    "entry": 952,
    "name": "P 952",
    "species": "Raikou",
    "instance": "3",
    "nature": "Timid",
    "item": "Air Balloon",
    "move1": "Thunderbolt",
    "move2": "Volt Switch",
    "move3": "Shadow Ball",
    "move4": "Protect",
    "speed": 183
  },
  {
    "entry": 972,
    "name": "P 972",
    "species": "Raikou",
    "instance": "4",
    "nature": "Timid",
    "item": "Air Balloon",
    "move1": "Thunder",
    "move2": "Discharge",
    "move3": "Reflect",
    "move4": "Extrasensory",
    "speed": 183
  },
  {
    "entry": 286,
    "name": "P 286",
    "species": "Rampardos",
    "instance": "1",
    "nature": "Brave",
    "item": "Passho Berry",
    "move1": "Rock Slide",
    "move2": "Crunch",
    "move3": "Curse",
    "move4": "Protect",
    "speed": 70
  },
  {
    "entry": 461,
    "name": "P 461",
    "species": "Rampardos",
    "instance": "2",
    "nature": "Naughty",
    "item": "Sitrus Berry",
    "move1": "Head Smash",
    "move2": "Stone Edge",
    "move3": "Hammer Arm",
    "move4": "Scary Face",
    "speed": 110
  },
  {
    "entry": 636,
    "name": "P 636",
    "species": "Rampardos",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "Head Smash",
    "move2": "Earthquake",
    "move3": "Brick Break",
    "move4": "ThunderPunch",
    "speed": 121
  },
  {
    "entry": 811,
    "name": "P 811",
    "species": "Rampardos",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Head Smash",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Protect",
    "speed": 70
  },
  {
    "entry": 297,
    "name": "P 297",
    "species": "Rapidash",
    "instance": "1",
    "nature": "Naughty",
    "item": "Passho Berry",
    "move1": "Bounce",
    "move2": "Flame Charge",
    "move3": "Low Kick",
    "move4": "Charm",
    "speed": 157
  },
  {
    "entry": 472,
    "name": "P 472",
    "species": "Rapidash",
    "instance": "2",
    "nature": "Hasty",
    "item": "Heat Rock",
    "move1": "Will-O-Wisp",
    "move2": "Fire Blast",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 172
  },
  {
    "entry": 647,
    "name": "P 647",
    "species": "Rapidash",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Flare Blitz",
    "move2": "Poison Jab",
    "move3": "Iron Tail",
    "move4": "Horn Drill",
    "speed": 172
  },
  {
    "entry": 822,
    "name": "P 822",
    "species": "Rapidash",
    "instance": "4",
    "nature": "Jolly",
    "item": "Charcoal",
    "move1": "Flare Blitz",
    "move2": "Megahorn",
    "move3": "Double-Edge",
    "move4": "Protect",
    "speed": 172
  },
  {
    "entry": 916,
    "name": "P 916",
    "species": "Regice",
    "instance": "1",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Thunderbolt",
    "move2": "Ice Beam",
    "move3": "Focus Blast",
    "move4": "Toxic",
    "speed": 70
  },
  {
    "entry": 936,
    "name": "P 936",
    "species": "Regice",
    "instance": "2",
    "nature": "Timid",
    "item": "Chesto Berry",
    "move1": "Thunderbolt",
    "move2": "Icy Wind",
    "move3": "Ice Beam",
    "move4": "Rest",
    "speed": 100
  },
  {
    "entry": 956,
    "name": "P 956",
    "species": "Regice",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Charge Beam",
    "move2": "Ice Beam",
    "move3": "Amnesia",
    "move4": "Protect",
    "speed": 70
  },
  {
    "entry": 976,
    "name": "P 976",
    "species": "Regice",
    "instance": "4",
    "nature": "Impish",
    "item": "Zoom Lens",
    "move1": "Thunder",
    "move2": "Blizzard",
    "move3": "Focus Blast",
    "move4": "Thunder Wave",
    "speed": 70
  },
  {
    "entry": 928,
    "name": "P 928",
    "species": "Regigigas",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Confuse Ray",
    "move2": "Double Team",
    "move3": "Drain Punch",
    "move4": "Payback",
    "speed": 60
  },
  {
    "entry": 948,
    "name": "P 948",
    "species": "Regigigas",
    "instance": "2",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Thunder",
    "move2": "Toxic",
    "move3": "Focus Blast",
    "move4": "Confuse Ray",
    "speed": 68
  },
  {
    "entry": 968,
    "name": "P 968",
    "species": "Regigigas",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Confuse Ray",
    "move2": "Drain Punch",
    "move3": "Thunder Wave",
    "move4": "Rock Slide",
    "speed": 60
  },
  {
    "entry": 988,
    "name": "P 988",
    "species": "Regigigas",
    "instance": "4",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Wide Guard",
    "move2": "Double Team",
    "move3": "Confuse Ray",
    "move4": "Toxic",
    "speed": 60
  },
  {
    "entry": 915,
    "name": "P 915",
    "species": "Regirock",
    "instance": "1",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Sandstorm",
    "move2": "Curse",
    "move3": "Rock Slide",
    "move4": "Drain Punch",
    "speed": 70
  },
  {
    "entry": 935,
    "name": "P 935",
    "species": "Regirock",
    "instance": "2",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Stone Edge",
    "move2": "Drain Punch",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 955,
    "name": "P 955",
    "species": "Regirock",
    "instance": "3",
    "nature": "Adamant",
    "item": "Rock Gem",
    "move1": "Ice Punch",
    "move2": "Rock Slide",
    "move3": "Drain Punch",
    "move4": "Earthquake",
    "speed": 70
  },
  {
    "entry": 975,
    "name": "P 975",
    "species": "Regirock",
    "instance": "4",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Rock Polish",
    "move2": "Rock Slide",
    "move3": "Superpower",
    "move4": "Explosion",
    "speed": 112
  },
  {
    "entry": 917,
    "name": "P 917",
    "species": "Registeel",
    "instance": "1",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Curse",
    "move2": "Amnesia",
    "move3": "Iron Head",
    "move4": "Rest",
    "speed": 70
  },
  {
    "entry": 937,
    "name": "P 937",
    "species": "Registeel",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Rock Polish",
    "move2": "Earthquake",
    "move3": "Iron Head",
    "move4": "ThunderPunch",
    "speed": 112
  },
  {
    "entry": 957,
    "name": "P 957",
    "species": "Registeel",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Amnesia",
    "move2": "Iron Defense",
    "move3": "Charge Beam",
    "move4": "Flash Cannon",
    "speed": 70
  },
  {
    "entry": 977,
    "name": "P 977",
    "species": "Registeel",
    "instance": "4",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Double Team",
    "move3": "Earthquake",
    "move4": "Protect",
    "speed": 70
  },
  {
    "entry": 279,
    "name": "P 279",
    "species": "Reuniclus",
    "instance": "1",
    "nature": "Bold",
    "item": "Sitrus Berry",
    "move1": "Psychic",
    "move2": "Energy Ball",
    "move3": "Recover",
    "move4": "Wonder Room",
    "speed": 50
  },
  {
    "entry": 454,
    "name": "P 454",
    "species": "Reuniclus",
    "instance": "2",
    "nature": "Brave",
    "item": "King's Rock",
    "move1": "Rock Slide",
    "move2": "Explosion",
    "move3": "Gyro Ball",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 629,
    "name": "P 629",
    "species": "Reuniclus",
    "instance": "3",
    "nature": "Quiet",
    "item": "Colbur Berry",
    "move1": "Calm Mind",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Shadow Ball",
    "speed": 45
  },
  {
    "entry": 804,
    "name": "P 804",
    "species": "Reuniclus",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Toxic Orb",
    "move1": "Trick",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Recover",
    "speed": 45
  },
  {
    "entry": 360,
    "name": "P 360",
    "species": "Rhyperior",
    "instance": "1",
    "nature": "Brave",
    "item": "Zoom Lens",
    "move1": "Payback",
    "move2": "Rock Blast",
    "move3": "Stone Edge",
    "move4": "Protect",
    "speed": 54
  },
  {
    "entry": 535,
    "name": "P 535",
    "species": "Rhyperior",
    "instance": "2",
    "nature": "Lonely",
    "item": "Hard Stone",
    "move1": "Rock Wrecker",
    "move2": "Rock Polish",
    "move3": "",
    "move4": "",
    "speed": 92
  },
  {
    "entry": 710,
    "name": "P 710",
    "species": "Rhyperior",
    "instance": "3",
    "nature": "Impish",
    "item": "Focus Sash",
    "move1": "Horn Drill",
    "move2": "Avalanche",
    "move3": "Payback",
    "move4": "Counter",
    "speed": 60
  },
  {
    "entry": 885,
    "name": "P 885",
    "species": "Rhyperior",
    "instance": "4",
    "nature": "Brave",
    "item": "Wide Lens",
    "move1": "Rock Slide",
    "move2": "Hammer Arm",
    "move3": "Earthquake",
    "move4": "Protect",
    "speed": 54
  },
  {
    "entry": 316,
    "name": "P 316",
    "species": "Roserade",
    "instance": "1",
    "nature": "Calm",
    "item": "Big Root",
    "move1": "Toxic",
    "move2": "Leech Seed",
    "move3": "Protect",
    "move4": "Giga Drain",
    "speed": 110
  },
  {
    "entry": 491,
    "name": "P 491",
    "species": "Roserade",
    "instance": "2",
    "nature": "Modest",
    "item": "Occa Berry",
    "move1": "Weather Ball",
    "move2": "Energy Ball",
    "move3": "Natural Gift",
    "move4": "Attract",
    "speed": 142
  },
  {
    "entry": 666,
    "name": "P 666",
    "species": "Roserade",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Sludge Bomb",
    "move3": "Hyper Beam",
    "move4": "GrassWhistle",
    "speed": 156
  },
  {
    "entry": 841,
    "name": "P 841",
    "species": "Roserade",
    "instance": "4",
    "nature": "Bold",
    "item": "Black Sludge",
    "move1": "Toxic",
    "move2": "Protect",
    "move3": "Leech Seed",
    "move4": "Giga Drain",
    "speed": 110
  },
  {
    "entry": 379,
    "name": "P 379",
    "species": "Salamence",
    "instance": "1",
    "nature": "Naughty",
    "item": "Yache Berry",
    "move1": "Roost",
    "move2": "Scary Face",
    "move3": "Dragon Tail",
    "move4": "Earthquake",
    "speed": 120
  },
  {
    "entry": 554,
    "name": "P 554",
    "species": "Salamence",
    "instance": "2",
    "nature": "Lonely",
    "item": "Expert Belt",
    "move1": "Dragon Claw",
    "move2": "Zen Headbutt",
    "move3": "Rock Slide",
    "move4": "Dragon Dance",
    "speed": 141
  },
  {
    "entry": 729,
    "name": "P 729",
    "species": "Salamence",
    "instance": "3",
    "nature": "Jolly",
    "item": "Yache Berry",
    "move1": "Draco Meteor",
    "move2": "Dragon Rush",
    "move3": "Earthquake",
    "move4": "Brick Break",
    "speed": 167
  },
  {
    "entry": 904,
    "name": "P 904",
    "species": "Salamence",
    "instance": "4",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Outrage",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Zen Headbutt",
    "speed": 167
  },
  {
    "entry": 223,
    "name": "P 223",
    "species": "Samurott",
    "instance": "1",
    "nature": "Mild",
    "item": "Splash Plate",
    "move1": "Retaliate",
    "move2": "Razor Shell",
    "move3": "Assurance",
    "move4": "Encore",
    "speed": 90
  },
  {
    "entry": 398,
    "name": "P 398",
    "species": "Samurott",
    "instance": "2",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Blizzard",
    "move2": "Giga Impact",
    "move3": "Detect",
    "move4": "Hydro Pump",
    "speed": 81
  },
  {
    "entry": 573,
    "name": "P 573",
    "species": "Samurott",
    "instance": "3",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Aerial Ace",
    "move2": "Waterfall",
    "move3": "X-Scissor",
    "move4": "Aqua Jet",
    "speed": 90
  },
  {
    "entry": 748,
    "name": "P 748",
    "species": "Samurott",
    "instance": "4",
    "nature": "Modest",
    "item": "Salac Berry",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Grass Knot",
    "move4": "Protect",
    "speed": 90
  },
  {
    "entry": 245,
    "name": "P 245",
    "species": "Sawk",
    "instance": "1",
    "nature": "Naughty",
    "item": "Black Belt",
    "move1": "Low Sweep",
    "move2": "Quick Guard",
    "move3": "Retaliate",
    "move4": "Taunt",
    "speed": 137
  },
  {
    "entry": 420,
    "name": "P 420",
    "species": "Sawk",
    "instance": "2",
    "nature": "Naughty",
    "item": "Focus Sash",
    "move1": "Earthquake",
    "move2": "Payback",
    "move3": "Endure",
    "move4": "Reversal",
    "speed": 137
  },
  {
    "entry": 596,
    "name": "P 596",
    "species": "Sawk",
    "instance": "3",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Close Combat",
    "move2": "Payback",
    "move3": "Low Sweep",
    "move4": "Earthquake",
    "speed": 150
  },
  {
    "entry": 771,
    "name": "P 771",
    "species": "Sawk",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Close Combat",
    "move2": "Bulldoze",
    "move3": "Stone Edge",
    "move4": "Taunt",
    "speed": 137
  },
  {
    "entry": 215,
    "name": "P 215",
    "species": "Sceptile",
    "instance": "1",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Quick Attack",
    "move2": "Endeavor",
    "move3": "Detect",
    "move4": "Leaf Storm",
    "speed": 189
  },
  {
    "entry": 390,
    "name": "P 390",
    "species": "Sceptile",
    "instance": "2",
    "nature": "Hasty",
    "item": "Scope Lens",
    "move1": "Leaf Blade",
    "move2": "Night Slash",
    "move3": "Earthquake",
    "move4": "Swords Dance",
    "speed": 189
  },
  {
    "entry": 565,
    "name": "P 565",
    "species": "Sceptile",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Dragon Pulse",
    "move3": "Energy Ball",
    "move4": "Detect",
    "speed": 189
  },
  {
    "entry": 740,
    "name": "P 740",
    "species": "Sceptile",
    "instance": "4",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Endeavor",
    "move3": "Energy Ball",
    "move4": "Toxic",
    "speed": 140
  },
  {
    "entry": 303,
    "name": "P 303",
    "species": "Scizor",
    "instance": "1",
    "nature": "Brave",
    "item": "Occa Berry",
    "move1": "Metal Claw",
    "move2": "Night Slash",
    "move3": "Aerial Ace",
    "move4": "Swords Dance",
    "speed": 76
  },
  {
    "entry": 478,
    "name": "P 478",
    "species": "Scizor",
    "instance": "2",
    "nature": "Naughty",
    "item": "Insect Plate",
    "move1": "Bullet Punch",
    "move2": "X-Scissor",
    "move3": "Feint",
    "move4": "Agility",
    "speed": 85
  },
  {
    "entry": 653,
    "name": "P 653",
    "species": "Scizor",
    "instance": "3",
    "nature": "Brave",
    "item": "Life Orb",
    "move1": "Swords Dance",
    "move2": "Bullet Punch",
    "move3": "Reversal",
    "move4": "U-turn",
    "speed": 76
  },
  {
    "entry": 828,
    "name": "P 828",
    "species": "Scizor",
    "instance": "4",
    "nature": "Adamant",
    "item": "Occa Berry",
    "move1": "Bug Bite",
    "move2": "Aerial Ace",
    "move3": "Roost",
    "move4": "Bullet Punch",
    "speed": 85
  },
  {
    "entry": 271,
    "name": "P 271",
    "species": "Scrafty",
    "instance": "1",
    "nature": "Naughty",
    "item": "Liechi Berry",
    "move1": "Fake Out",
    "move2": "Bulk Up",
    "move3": "Focus Punch",
    "move4": "Substitute",
    "speed": 78
  },
  {
    "entry": 446,
    "name": "P 446",
    "species": "Scrafty",
    "instance": "2",
    "nature": "Jolly",
    "item": "Coba Berry",
    "move1": "Hi Jump Kick",
    "move2": "Rock Slide",
    "move3": "Taunt",
    "move4": "Dragon Dance",
    "speed": 121
  },
  {
    "entry": 621,
    "name": "P 621",
    "species": "Scrafty",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Substitute",
    "move2": "Payback",
    "move3": "Hi Jump Kick",
    "move4": "Focus Punch",
    "speed": 78
  },
  {
    "entry": 796,
    "name": "P 796",
    "species": "Scrafty",
    "instance": "4",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Bulk Up",
    "move2": "Payback",
    "move3": "Protect",
    "move4": "Drain Punch",
    "speed": 78
  },
  {
    "entry": 295,
    "name": "P 295",
    "species": "Seismitoad",
    "instance": "1",
    "nature": "Rash",
    "item": "Chesto Berry",
    "move1": "Round",
    "move2": "Rest",
    "move3": "Water Pulse",
    "move4": "Sludge Wave",
    "speed": 94
  },
  {
    "entry": 470,
    "name": "P 470",
    "species": "Seismitoad",
    "instance": "2",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Fling",
    "move2": "Rock Slide",
    "move3": "Poison Jab",
    "move4": "Earthquake",
    "speed": 42
  },
  {
    "entry": 645,
    "name": "P 645",
    "species": "Seismitoad",
    "instance": "3",
    "nature": "Timid",
    "item": "Damp Rock",
    "move1": "Rain Dance",
    "move2": "Muddy Water",
    "move3": "Earth Power",
    "move4": "Sludge Bomb",
    "speed": 138
  },
  {
    "entry": 820,
    "name": "P 820",
    "species": "Seismitoad",
    "instance": "4",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Brick Break",
    "move2": "Poison Jab",
    "move3": "Dig",
    "move4": "Payback",
    "speed": 138
  },
  {
    "entry": 221,
    "name": "P 221",
    "species": "Serperior",
    "instance": "1",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Attract",
    "move2": "Leaf Tornado",
    "move3": "Dragon Tail",
    "move4": "Gastro Acid",
    "speed": 169
  },
  {
    "entry": 396,
    "name": "P 396",
    "species": "Serperior",
    "instance": "2",
    "nature": "Sassy",
    "item": "Sitrus Berry",
    "move1": "Leaf Tornado",
    "move2": "Hidden Power",
    "move3": "Mirror Coat",
    "move4": "Captivate",
    "speed": 119
  },
  {
    "entry": 571,
    "name": "P 571",
    "species": "Serperior",
    "instance": "3",
    "nature": "Calm",
    "item": "BrightPowder",
    "move1": "Leaf Storm",
    "move2": "Substitute",
    "move3": "Hyper Beam",
    "move4": "Toxic",
    "speed": 133
  },
  {
    "entry": 746,
    "name": "P 746",
    "species": "Serperior",
    "instance": "4",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Leaf Storm",
    "move2": "",
    "move3": "",
    "move4": "",
    "speed": 165
  },
  {
    "entry": 252,
    "name": "P 252",
    "species": "Shiftry",
    "instance": "1",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Fling",
    "move2": "Razor Leaf",
    "move3": "Brick Break",
    "move4": "Swords Dance",
    "speed": 45
  },
  {
    "entry": 427,
    "name": "P 427",
    "species": "Shiftry",
    "instance": "2",
    "nature": "Rash",
    "item": "Miracle Seed",
    "move1": "Fake Out",
    "move2": "Extrasensory",
    "move3": "SolarBeam",
    "move4": "Swagger",
    "speed": 132
  },
  {
    "entry": 602,
    "name": "P 602",
    "species": "Shiftry",
    "instance": "3",
    "nature": "Hardy",
    "item": "Heat Rock",
    "move1": "Sunny Day",
    "move2": "SolarBeam",
    "move3": "Dark Pulse",
    "move4": "Explosion",
    "speed": 100
  },
  {
    "entry": 777,
    "name": "P 777",
    "species": "Shiftry",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Fake Out",
    "move2": "Sucker Punch",
    "move3": "Low Kick",
    "move4": "Protect",
    "speed": 100
  },
  {
    "entry": 315,
    "name": "P 315",
    "species": "Shuckle",
    "instance": "1",
    "nature": "Careful",
    "item": "Binding Band",
    "move1": "Power Split",
    "move2": "Encore",
    "move3": "Gastro Acid",
    "move4": "Sand Tomb",
    "speed": 25
  },
  {
    "entry": 490,
    "name": "P 490",
    "species": "Shuckle",
    "instance": "2",
    "nature": "Bold",
    "item": "Quick Claw",
    "move1": "Power Trick",
    "move2": "Encore",
    "move3": "Rock Slide",
    "move4": "Bug Bite",
    "speed": 25
  },
  {
    "entry": 665,
    "name": "P 665",
    "species": "Shuckle",
    "instance": "3",
    "nature": "Relaxed",
    "item": "Lax Incense",
    "move1": "Gyro Ball",
    "move2": "Double Team",
    "move3": "Substitute",
    "move4": "Power Trick",
    "speed": 22
  },
  {
    "entry": 840,
    "name": "P 840",
    "species": "Shuckle",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Protect",
    "move3": "Sandstorm",
    "move4": "Wrap",
    "speed": 22
  },
  {
    "entry": 234,
    "name": "P 234",
    "species": "Skarmory",
    "instance": "1",
    "nature": "Naive",
    "item": "Full Incense",
    "move1": "Spikes",
    "move2": "Stealth Rock",
    "move3": "Sky Drop",
    "move4": "Whirlwind",
    "speed": 0
  },
  {
    "entry": 409,
    "name": "P 409",
    "species": "Skarmory",
    "instance": "2",
    "nature": "Naughty",
    "item": "Cell Battery",
    "move1": "Brave Bird",
    "move2": "Steel Wing",
    "move3": "Swords Dance",
    "move4": "Roar",
    "speed": 122
  },
  {
    "entry": 584,
    "name": "P 584",
    "species": "Skarmory",
    "instance": "3",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "Brave Bird",
    "move2": "Steel Wing",
    "move3": "Night Slash",
    "move4": "Rock Slide",
    "speed": 134
  },
  {
    "entry": 759,
    "name": "P 759",
    "species": "Skarmory",
    "instance": "4",
    "nature": "Careful",
    "item": "Lum Berry",
    "move1": "Spikes",
    "move2": "Stealth Rock",
    "move3": "Whirlwind",
    "move4": "Toxic",
    "speed": 90
  },
  {
    "entry": 244,
    "name": "P 244",
    "species": "Skuntank",
    "instance": "1",
    "nature": "Naughty",
    "item": "Shuca Berry",
    "move1": "Flamethrower",
    "move2": "Night Slash",
    "move3": "Incinerate",
    "move4": "Memento",
    "speed": 136
  },
  {
    "entry": 419,
    "name": "P 419",
    "species": "Skuntank",
    "instance": "2",
    "nature": "Adamant",
    "item": "Poison Barb",
    "move1": "Pursuit",
    "move2": "Foul Play",
    "move3": "Poison Jab",
    "move4": "Taunt",
    "speed": 136
  },
  {
    "entry": 594,
    "name": "P 594",
    "species": "Skuntank",
    "instance": "3",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Taunt",
    "move2": "Sucker Punch",
    "move3": "Foul Play",
    "move4": "Poison Jab",
    "speed": 149
  },
  {
    "entry": 769,
    "name": "P 769",
    "species": "Skuntank",
    "instance": "4",
    "nature": "Brave",
    "item": "Custap Berry",
    "move1": "Night Slash",
    "move2": "Poison Jab",
    "move3": "Fire Blast",
    "move4": "Explosion",
    "speed": 93
  },
  {
    "entry": 383,
    "name": "P 383",
    "species": "Slaking",
    "instance": "1",
    "nature": "Naive",
    "item": "Chople Berry",
    "move1": "Earthquake",
    "move2": "Brick Break",
    "move3": "Rock Slide",
    "move4": "Encore",
    "speed": 167
  },
  {
    "entry": 558,
    "name": "P 558",
    "species": "Slaking",
    "instance": "2",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Retaliate",
    "move2": "Night Slash",
    "move3": "Slack Off",
    "move4": "Amnesia",
    "speed": 167
  },
  {
    "entry": 733,
    "name": "P 733",
    "species": "Slaking",
    "instance": "3",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Giga Impact",
    "move2": "Shadow Claw",
    "move3": "Hammer Arm",
    "move4": "Earthquake",
    "speed": 120
  },
  {
    "entry": 908,
    "name": "P 908",
    "species": "Slaking",
    "instance": "4",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Return",
    "move2": "Night Slash",
    "move3": "Gunk Shot",
    "move4": "Aerial Ace",
    "speed": 167
  },
  {
    "entry": 263,
    "name": "P 263",
    "species": "Slowbro",
    "instance": "1",
    "nature": "Bold",
    "item": "Sitrus Berry",
    "move1": "Yawn",
    "move2": "Psychic",
    "move3": "Calm Mind",
    "move4": "Water Pulse",
    "speed": 50
  },
  {
    "entry": 438,
    "name": "P 438",
    "species": "Slowbro",
    "instance": "2",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Flamethrower",
    "move2": "Ice Beam",
    "move3": "Slack Off",
    "move4": "Water Pulse",
    "speed": 50
  },
  {
    "entry": 613,
    "name": "P 613",
    "species": "Slowbro",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Slack Off",
    "move4": "Amnesia",
    "speed": 50
  },
  {
    "entry": 788,
    "name": "P 788",
    "species": "Slowbro",
    "instance": "4",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Blizzard",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 274,
    "name": "P 274",
    "species": "Slowking",
    "instance": "1",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Psyshock",
    "move2": "Water Pulse",
    "move3": "Trick Room",
    "move4": "Heal Pulse",
    "speed": 50
  },
  {
    "entry": 449,
    "name": "P 449",
    "species": "Slowking",
    "instance": "2",
    "nature": "Gentle",
    "item": "King's Rock",
    "move1": "Zen Headbutt",
    "move2": "Earthquake",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed": 50
  },
  {
    "entry": 624,
    "name": "P 624",
    "species": "Slowking",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Focus Blast",
    "speed": 50
  },
  {
    "entry": 799,
    "name": "P 799",
    "species": "Slowking",
    "instance": "4",
    "nature": "Quiet",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 366,
    "name": "P 366",
    "species": "Snorlax",
    "instance": "1",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Body Slam",
    "move2": "Wild Charge",
    "move3": "Counter",
    "move4": "Recycle",
    "speed": 50
  },
  {
    "entry": 541,
    "name": "P 541",
    "species": "Snorlax",
    "instance": "2",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Body Slam",
    "move2": "Protect",
    "move3": "Earthquake",
    "move4": "Belly Drum",
    "speed": 45
  },
  {
    "entry": 716,
    "name": "P 716",
    "species": "Snorlax",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Protect",
    "speed": 50
  },
  {
    "entry": 891,
    "name": "P 891",
    "species": "Snorlax",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Sitrus Berry",
    "move1": "Belly Drum",
    "move2": "Double-Edge",
    "move3": "Earthquake",
    "move4": "Crunch",
    "speed": 45
  },
  {
    "entry": 267,
    "name": "P 267",
    "species": "Spiritomb",
    "instance": "1",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Sucker Punch",
    "move2": "Pain Split",
    "move3": "Toxic",
    "move4": "Grudge",
    "speed": 55
  },
  {
    "entry": 442,
    "name": "P 442",
    "species": "Spiritomb",
    "instance": "2",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Shadow Sneak",
    "move2": "Sucker Punch",
    "move3": "Will-O-Wisp",
    "move4": "Taunt",
    "speed": 49
  },
  {
    "entry": 617,
    "name": "P 617",
    "species": "Spiritomb",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Will-O-Wisp",
    "move2": "Shadow Sneak",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed": 55
  },
  {
    "entry": 792,
    "name": "P 792",
    "species": "Spiritomb",
    "instance": "4",
    "nature": "Careful",
    "item": "Custap Berry",
    "move1": "Will-O-Wisp",
    "move2": "Sucker Punch",
    "move3": "Substitute",
    "move4": "Pain Split",
    "speed": 55
  },
  {
    "entry": 242,
    "name": "P 242",
    "species": "Staraptor",
    "instance": "1",
    "nature": "Hasty",
    "item": "Focus Sash",
    "move1": "U-turn",
    "move2": "FeatherDance",
    "move3": "Quick Attack",
    "move4": "Endeavor",
    "speed": 167
  },
  {
    "entry": 417,
    "name": "P 417",
    "species": "Staraptor",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Scarf",
    "move1": "Pursuit",
    "move2": "Close Combat",
    "move3": "Roost",
    "move4": "Final Gambit",
    "speed": 152
  },
  {
    "entry": 592,
    "name": "P 592",
    "species": "Staraptor",
    "instance": "3",
    "nature": "Mild",
    "item": "Choice Band",
    "move1": "Close Combat",
    "move2": "Brave Bird",
    "move3": "U-turn",
    "move4": "Giga Impact",
    "speed": 152
  },
  {
    "entry": 767,
    "name": "P 767",
    "species": "Staraptor",
    "instance": "4",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Brave Bird",
    "move2": "Double-Edge",
    "move3": "Roost",
    "move4": "FeatherDance",
    "speed": 167
  },
  {
    "entry": 336,
    "name": "P 336",
    "species": "Starmie",
    "instance": "1",
    "nature": "Timid",
    "item": "Sitrus Berry",
    "move1": "Psychic",
    "move2": "Cosmic Power",
    "move3": "Recover",
    "move4": "Reflect Type",
    "speed": 183
  },
  {
    "entry": 511,
    "name": "P 511",
    "species": "Starmie",
    "instance": "2",
    "nature": "Modest",
    "item": "Mystic Water",
    "move1": "Protect",
    "move2": "Psychic",
    "move3": "Hydro Pump",
    "move4": "Rapid Spin",
    "speed": 167
  },
  {
    "entry": 686,
    "name": "P 686",
    "species": "Starmie",
    "instance": "3",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Power Gem",
    "move4": "Signal Beam",
    "speed": 183
  },
  {
    "entry": 861,
    "name": "P 861",
    "species": "Starmie",
    "instance": "4",
    "nature": "Timid",
    "item": "King's Rock",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Thunderbolt",
    "move4": "Ice Beam",
    "speed": 183
  },
  {
    "entry": 322,
    "name": "P 322",
    "species": "Steelix",
    "instance": "1",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Rest",
    "move3": "Curse",
    "move4": "Stealth Rock",
    "speed": 50
  },
  {
    "entry": 497,
    "name": "P 497",
    "species": "Steelix",
    "instance": "2",
    "nature": "Impish",
    "item": "Enigma Berry",
    "move1": "Crunch",
    "move2": "Curse",
    "move3": "Gyro Ball",
    "move4": "Screech",
    "speed": 50
  },
  {
    "entry": 672,
    "name": "P 672",
    "species": "Steelix",
    "instance": "3",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Gyro Ball",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Explosion",
    "speed": 45
  },
  {
    "entry": 847,
    "name": "P 847",
    "species": "Steelix",
    "instance": "4",
    "nature": "Relaxed",
    "item": "Iron Ball",
    "move1": "Gyro Ball",
    "move2": "Payback",
    "move3": "Swagger",
    "move4": "Curse",
    "speed": 22
  },
  {
    "entry": 914,
    "name": "P 914",
    "species": "Suicune",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Calm Mind",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Rest",
    "speed": 105
  },
  {
    "entry": 934,
    "name": "P 934",
    "species": "Suicune",
    "instance": "2",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Shadow Ball",
    "move4": "Mirror Coat",
    "speed": 105
  },
  {
    "entry": 954,
    "name": "P 954",
    "species": "Suicune",
    "instance": "3",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Blizzard",
    "move3": "Calm Mind",
    "move4": "Protect",
    "speed": 105
  },
  {
    "entry": 974,
    "name": "P 974",
    "species": "Suicune",
    "instance": "4",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Icy Wind",
    "move2": "Surf",
    "move3": "Blizzard",
    "move4": "Protect",
    "speed": 150
  },
  {
    "entry": 217,
    "name": "P 217",
    "species": "Swampert",
    "instance": "1",
    "nature": "Sassy",
    "item": "Jaboca Berry",
    "move1": "Mirror Coat",
    "move2": "Counter",
    "move3": "Earthquake",
    "move4": "Roar",
    "speed": 72
  },
  {
    "entry": 392,
    "name": "P 392",
    "species": "Swampert",
    "instance": "2",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Hammer Arm",
    "move3": "Rest",
    "move4": "Curse",
    "speed": 80
  },
  {
    "entry": 567,
    "name": "P 567",
    "species": "Swampert",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "Avalanche",
    "move3": "Waterfall",
    "move4": "Stone Edge",
    "speed": 80
  },
  {
    "entry": 742,
    "name": "P 742",
    "species": "Swampert",
    "instance": "4",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Curse",
    "move2": "Rest",
    "move3": "Earthquake",
    "move4": "Waterfall",
    "speed": 80
  },
  {
    "entry": 361,
    "name": "P 361",
    "species": "Tangrowth",
    "instance": "1",
    "nature": "Bold",
    "item": "Big Root",
    "move1": "Leech Seed",
    "move2": "Ingrain",
    "move3": "Giga Drain",
    "move4": "Toxic",
    "speed": 70
  },
  {
    "entry": 536,
    "name": "P 536",
    "species": "Tangrowth",
    "instance": "2",
    "nature": "Naughty",
    "item": "Yache Berry",
    "move1": "Wring Out",
    "move2": "Tickle",
    "move3": "Power Whip",
    "move4": "Bulldoze",
    "speed": 102
  },
  {
    "entry": 711,
    "name": "P 711",
    "species": "Tangrowth",
    "instance": "3",
    "nature": "Modest",
    "item": "Heat Rock",
    "move1": "Sunny Day",
    "move2": "SolarBeam",
    "move3": "Synthesis",
    "move4": "Wring Out",
    "speed": 70
  },
  {
    "entry": 886,
    "name": "P 886",
    "species": "Tangrowth",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Power Whip",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Brick Break",
    "speed": 70
  },
  {
    "entry": 266,
    "name": "P 266",
    "species": "Tauros",
    "instance": "1",
    "nature": "Naughty",
    "item": "Liechi Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Endure",
    "move4": "Substitute",
    "speed": 162
  },
  {
    "entry": 441,
    "name": "P 441",
    "species": "Tauros",
    "instance": "2",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Zen Headbutt",
    "move2": "Wild Charge",
    "move3": "Swagger",
    "move4": "Giga Impact",
    "speed": 178
  },
  {
    "entry": 616,
    "name": "P 616",
    "species": "Tauros",
    "instance": "3",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Payback",
    "move4": "Giga Impact",
    "speed": 178
  },
  {
    "entry": 791,
    "name": "P 791",
    "species": "Tauros",
    "instance": "4",
    "nature": "Careful",
    "item": "Sitrus Berry",
    "move1": "Toxic",
    "move2": "Protect",
    "move3": "Double Team",
    "move4": "Earthquake",
    "speed": 130
  },
  {
    "entry": 328,
    "name": "P 328",
    "species": "Tentacruel",
    "instance": "1",
    "nature": "Hasty",
    "item": "Black Sludge",
    "move1": "Ice Beam",
    "move2": "Sludge Wave",
    "move3": "Hex",
    "move4": "Toxic Spikes",
    "speed": 167
  },
  {
    "entry": 503,
    "name": "P 503",
    "species": "Tentacruel",
    "instance": "2",
    "nature": "Hasty",
    "item": "Mystic Water",
    "move1": "Rapid Spin",
    "move2": "Poison Jab",
    "move3": "Waterfall",
    "move4": "Swords Dance",
    "speed": 167
  },
  {
    "entry": 678,
    "name": "P 678",
    "species": "Tentacruel",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Hydro Pump",
    "move2": "Sludge Bomb",
    "move3": "Giga Drain",
    "move4": "Mirror Coat",
    "speed": 120
  },
  {
    "entry": 853,
    "name": "P 853",
    "species": "Tentacruel",
    "instance": "4",
    "nature": "Bold",
    "item": "Black Sludge",
    "move1": "Surf",
    "move2": "Toxic",
    "move3": "Venoshock",
    "move4": "Protect",
    "speed": 120
  },
  {
    "entry": 919,
    "name": "P 919",
    "species": "Terrakion",
    "instance": "1",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Close Combat",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Aerial Ace",
    "speed": 176
  },
  {
    "entry": 939,
    "name": "P 939",
    "species": "Terrakion",
    "instance": "2",
    "nature": "Adamant",
    "item": "Choice Scarf",
    "move1": "Sacred Sword",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Aerial Ace",
    "speed": 160
  },
  {
    "entry": 959,
    "name": "P 959",
    "species": "Terrakion",
    "instance": "3",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Swords Dance",
    "move2": "Sacred Sword",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 176
  },
  {
    "entry": 979,
    "name": "P 979",
    "species": "Terrakion",
    "instance": "4",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Bulldoze",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Sacred Sword",
    "speed": 176
  },
  {
    "entry": 246,
    "name": "P 246",
    "species": "Throh",
    "instance": "1",
    "nature": "Impish",
    "item": "Payapa Berry",
    "move1": "Protect",
    "move2": "Toxic",
    "move3": "Circle Throw",
    "move4": "Wide Guard",
    "speed": 65
  },
  {
    "entry": 421,
    "name": "P 421",
    "species": "Throh",
    "instance": "2",
    "nature": "Brave",
    "item": "Expert Belt",
    "move1": "Revenge",
    "move2": "Storm Throw",
    "move3": "Protect",
    "move4": "Seismic Toss",
    "speed": 58
  },
  {
    "entry": 595,
    "name": "P 595",
    "species": "Throh",
    "instance": "3",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Earthquake",
    "move2": "Storm Throw",
    "move3": "Payback",
    "move4": "Rock Slide",
    "speed": 65
  },
  {
    "entry": 770,
    "name": "P 770",
    "species": "Throh",
    "instance": "4",
    "nature": "Brave",
    "item": "Flame Orb",
    "move1": "Protect",
    "move2": "Earthquake",
    "move3": "Storm Throw",
    "move4": "Payback",
    "speed": 58
  },
  {
    "entry": 922,
    "name": "P 922",
    "species": "Thundurus",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Thunderbolt",
    "move2": "Protect",
    "move3": "Toxic",
    "move4": "Rest",
    "speed": 131
  },
  {
    "entry": 942,
    "name": "P 942",
    "species": "Thundurus",
    "instance": "2",
    "nature": "Timid",
    "item": "Choice Band",
    "move1": "Thunderbolt",
    "move2": "Dark Pulse",
    "move3": "Focus Blast",
    "move4": "Grass Knot",
    "speed": 179
  },
  {
    "entry": 962,
    "name": "P 962",
    "species": "Thundurus",
    "instance": "3",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Wild Charge",
    "move2": "U-turn",
    "move3": "Crunch",
    "move4": "Sky Drop",
    "speed": 179
  },
  {
    "entry": 982,
    "name": "P 982",
    "species": "Thundurus",
    "instance": "4",
    "nature": "Timid",
    "item": "Magnet",
    "move1": "Discharge",
    "move2": "Focus Blast",
    "move3": "Volt Switch",
    "move4": "Taunt",
    "speed": 179
  },
  {
    "entry": 373,
    "name": "P 373",
    "species": "Togekiss",
    "instance": "1",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Encore",
    "move2": "Thunder Wave",
    "move3": "Reflect",
    "move4": "Follow Me",
    "speed": 132
  },
  {
    "entry": 548,
    "name": "P 548",
    "species": "Togekiss",
    "instance": "2",
    "nature": "Naughty",
    "item": "Liechi Berry",
    "move1": "ExtremeSpeed",
    "move2": "Aerial Ace",
    "move3": "Psych Up",
    "move4": "Brick Break",
    "speed": 132
  },
  {
    "entry": 723,
    "name": "P 723",
    "species": "Togekiss",
    "instance": "3",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Thunder Wave",
    "move2": "Air Slash",
    "move3": "Heat Wave",
    "move4": "Water Pulse",
    "speed": 132
  },
  {
    "entry": 898,
    "name": "P 898",
    "species": "Togekiss",
    "instance": "4",
    "nature": "Bold",
    "item": "Sitrus Berry",
    "move1": "Follow Me",
    "move2": "Thunder Wave",
    "move3": "Air Slash",
    "move4": "Encore",
    "speed": 100
  },
  {
    "entry": 921,
    "name": "P 921",
    "species": "Tornadus",
    "instance": "1",
    "nature": "Timid",
    "item": "Life Orb",
    "move1": "Hurricane",
    "move2": "Grass Knot",
    "move3": "Focus Blast",
    "move4": "Dark Pulse",
    "speed": 179
  },
  {
    "entry": 941,
    "name": "P 941",
    "species": "Tornadus",
    "instance": "2",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Substitute",
    "move2": "Double Team",
    "move3": "Focus Blast",
    "move4": "Hurricane",
    "speed": 131
  },
  {
    "entry": 961,
    "name": "P 961",
    "species": "Tornadus",
    "instance": "3",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Rest",
    "move2": "Air Slash",
    "move3": "Dark Pulse",
    "move4": "Focus Blast",
    "speed": 131
  },
  {
    "entry": 981,
    "name": "P 981",
    "species": "Tornadus",
    "instance": "4",
    "nature": "Timid",
    "item": "Damp Rock",
    "move1": "Hurricane",
    "move2": "Focus Blast",
    "move3": "Taunt",
    "move4": "Rain Dance",
    "speed": 179
  },
  {
    "entry": 218,
    "name": "P 218",
    "species": "Torterra",
    "instance": "1",
    "nature": "Adamant",
    "item": "Binding Band",
    "move1": "Sand Tomb",
    "move2": "Seed Bomb",
    "move3": "Curse",
    "move4": "Synthesis",
    "speed": 76
  },
  {
    "entry": 393,
    "name": "P 393",
    "species": "Torterra",
    "instance": "2",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Wood Hammer",
    "move4": "Tickle",
    "speed": 118
  },
  {
    "entry": 568,
    "name": "P 568",
    "species": "Torterra",
    "instance": "3",
    "nature": "Adamant",
    "item": "Custap Berry",
    "move1": "Earthquake",
    "move2": "Crunch",
    "move3": "Seed Bomb",
    "move4": "Iron Head",
    "speed": 76
  },
  {
    "entry": 743,
    "name": "P 743",
    "species": "Torterra",
    "instance": "4",
    "nature": "Hardy",
    "item": "Leftovers",
    "move1": "Stockpile",
    "move2": "Leech Seed",
    "move3": "Earthquake",
    "move4": "Protect",
    "speed": 76
  },
  {
    "entry": 277,
    "name": "P 277",
    "species": "Toxicroak",
    "instance": "1",
    "nature": "Lonely",
    "item": "Dark Gem",
    "move1": "Fake Out",
    "move2": "Brick Break",
    "move3": "Sucker Punch",
    "move4": "Taunt",
    "speed": 137
  },
  {
    "entry": 452,
    "name": "P 452",
    "species": "Toxicroak",
    "instance": "2",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Focus Blast",
    "move2": "Sludge Bomb",
    "move3": "Substitute",
    "move4": "Protect",
    "speed": 137
  },
  {
    "entry": 627,
    "name": "P 627",
    "species": "Toxicroak",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Sludge Bomb",
    "move2": "Focus Blast",
    "move3": "Shadow Ball",
    "move4": "Dark Pulse",
    "speed": 137
  },
  {
    "entry": 802,
    "name": "P 802",
    "species": "Toxicroak",
    "instance": "4",
    "nature": "Adamant",
    "item": "Wide Lens",
    "move1": "Cross Chop",
    "move2": "Sucker Punch",
    "move3": "Gunk Shot",
    "move4": "Taunt",
    "speed": 137
  },
  {
    "entry": 213,
    "name": "P 213",
    "species": "Typhlosion",
    "instance": "1",
    "nature": "Rash",
    "item": "Passho Berry",
    "move1": "Flame Burst",
    "move2": "Flamethrower",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 152
  },
  {
    "entry": 388,
    "name": "P 388",
    "species": "Typhlosion",
    "instance": "2",
    "nature": "Naive",
    "item": "Wide Lens",
    "move1": "Inferno",
    "move2": "Focus Blast",
    "move3": "Extrasensory",
    "move4": "Will-O-Wisp",
    "speed": 167
  },
  {
    "entry": 563,
    "name": "P 563",
    "species": "Typhlosion",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Scarf",
    "move1": "Eruption",
    "move2": "Focus Blast",
    "move3": "Heat Wave",
    "move4": "Extrasensory",
    "speed": 152
  },
  {
    "entry": 738,
    "name": "P 738",
    "species": "Typhlosion",
    "instance": "4",
    "nature": "Modest",
    "item": "Power Herb",
    "move1": "Extrasensory",
    "move2": "Lava Plume",
    "move3": "Bulldoze",
    "move4": "SolarBeam",
    "speed": 152
  },
  {
    "entry": 378,
    "name": "P 378",
    "species": "Tyranitar",
    "instance": "1",
    "nature": "Impish",
    "item": "Iron Ball",
    "move1": "Rock Slide",
    "move2": "Stealth Rock",
    "move3": "Thunder Wave",
    "move4": "Fling",
    "speed": 40
  },
  {
    "entry": 553,
    "name": "P 553",
    "species": "Tyranitar",
    "instance": "2",
    "nature": "Hasty",
    "item": "King's Rock",
    "move1": "Rock Slide",
    "move2": "Crunch",
    "move3": "Ice Beam",
    "move4": "Dragon Dance",
    "speed": 124
  },
  {
    "entry": 728,
    "name": "P 728",
    "species": "Tyranitar",
    "instance": "3",
    "nature": "Jolly",
    "item": "Chople Berry",
    "move1": "Stone Edge",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Dragon Dance",
    "speed": 124
  },
  {
    "entry": 903,
    "name": "P 903",
    "species": "Tyranitar",
    "instance": "4",
    "nature": "Brave",
    "item": "Focus Sash",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Superpower",
    "move4": "Dragon Tail",
    "speed": 72
  },
  {
    "entry": 344,
    "name": "P 344",
    "species": "Umbreon",
    "instance": "1",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Confuse Ray",
    "move2": "Payback",
    "move3": "Curse",
    "move4": "Moonlight",
    "speed": 85
  },
  {
    "entry": 519,
    "name": "P 519",
    "species": "Umbreon",
    "instance": "2",
    "nature": "Careful",
    "item": "Chople Berry",
    "move1": "Payback",
    "move2": "Moonlight",
    "move3": "Stored Power",
    "move4": "Work Up",
    "speed": 85
  },
  {
    "entry": 694,
    "name": "P 694",
    "species": "Umbreon",
    "instance": "3",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Faint Attack",
    "move2": "Swagger",
    "move3": "Psych Up",
    "move4": "Screech",
    "speed": 85
  },
  {
    "entry": 869,
    "name": "P 869",
    "species": "Umbreon",
    "instance": "4",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Curse",
    "move2": "Trump Card",
    "move3": "Payback",
    "move4": "Rest",
    "speed": 85
  },
  {
    "entry": 247,
    "name": "P 247",
    "species": "Unfezant",
    "instance": "1",
    "nature": "Jolly",
    "item": "Enigma Berry",
    "move1": "Aerial Ace",
    "move2": "U-turn",
    "move3": "Razor Wind",
    "move4": "Tailwind",
    "speed": 124
  },
  {
    "entry": 422,
    "name": "P 422",
    "species": "Unfezant",
    "instance": "2",
    "nature": "Jolly",
    "item": "Power Herb",
    "move1": "Giga Impact",
    "move2": "Quick Attack",
    "move3": "Hypnosis",
    "move4": "Sky Attack",
    "speed": 159
  },
  {
    "entry": 597,
    "name": "P 597",
    "species": "Unfezant",
    "instance": "3",
    "nature": "Jolly",
    "item": "Power Herb",
    "move1": "Sky Attack",
    "move2": "Return",
    "move3": "Detect",
    "move4": "U-turn",
    "speed": 159
  },
  {
    "entry": 772,
    "name": "P 772",
    "species": "Unfezant",
    "instance": "4",
    "nature": "Impish",
    "item": "BrightPowder",
    "move1": "Detect",
    "move2": "FeatherDance",
    "move3": "Toxic",
    "move4": "Fly",
    "speed": 113
  },
  {
    "entry": 305,
    "name": "P 305",
    "species": "Ursaring",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Thrash",
    "move2": "Crunch",
    "move3": "Rest",
    "move4": "Counter",
    "speed": 75
  },
  {
    "entry": 480,
    "name": "P 480",
    "species": "Ursaring",
    "instance": "2",
    "nature": "Jolly",
    "item": "Toxic Orb",
    "move1": "Facade",
    "move2": "Hammer Arm",
    "move3": "Scary Face",
    "move4": "Yawn",
    "speed": 117
  },
  {
    "entry": 655,
    "name": "P 655",
    "species": "Ursaring",
    "instance": "3",
    "nature": "Adamant",
    "item": "Toxic Orb",
    "move1": "Facade",
    "move2": "Superpower",
    "move3": "Crunch",
    "move4": "Protect",
    "speed": 75
  },
  {
    "entry": 830,
    "name": "P 830",
    "species": "Ursaring",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Return",
    "move2": "Cross Chop",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed": 75
  },
  {
    "entry": 363,
    "name": "P 363",
    "species": "Vanilluxe",
    "instance": "1",
    "nature": "Calm",
    "item": "NeverMeltIce",
    "move1": "Ice Beam",
    "move2": "Frost Breath",
    "move3": "Mirror Coat",
    "move4": "Icy Wind",
    "speed": 99
  },
  {
    "entry": 538,
    "name": "P 538",
    "species": "Vanilluxe",
    "instance": "2",
    "nature": "Lonely",
    "item": "Occa Berry",
    "move1": "Avalanche",
    "move2": "Ice Shard",
    "move3": "Natural Gift",
    "move4": "Giga Impact",
    "speed": 99
  },
  {
    "entry": 713,
    "name": "P 713",
    "species": "Vanilluxe",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Hail",
    "move2": "Blizzard",
    "move3": "Flash Cannon",
    "move4": "Sheer Cold",
    "speed": 99
  },
  {
    "entry": 888,
    "name": "P 888",
    "species": "Vanilluxe",
    "instance": "4",
    "nature": "Calm",
    "item": "Sitrus Berry",
    "move1": "Taunt",
    "move2": "Ice Beam",
    "move3": "Acid Armor",
    "move4": "Mirror Coat",
    "speed": 99
  },
  {
    "entry": 340,
    "name": "P 340",
    "species": "Vaporeon",
    "instance": "1",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Wish",
    "move2": "Surf",
    "move3": "Helping Hand",
    "move4": "Shadow Ball",
    "speed": 76
  },
  {
    "entry": 515,
    "name": "P 515",
    "species": "Vaporeon",
    "instance": "2",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Ice Beam",
    "move2": "Hydro Pump",
    "move3": "Acid Armor",
    "move4": "Aqua Ring",
    "speed": 85
  },
  {
    "entry": 690,
    "name": "P 690",
    "species": "Vaporeon",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Muddy Water",
    "move2": "Blizzard",
    "move3": "Aqua Ring",
    "move4": "Yawn",
    "speed": 85
  },
  {
    "entry": 865,
    "name": "P 865",
    "species": "Vaporeon",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Shadow Ball",
    "move4": "Signal Beam",
    "speed": 85
  },
  {
    "entry": 209,
    "name": "P 209",
    "species": "Venusaur",
    "instance": "1",
    "nature": "Calm",
    "item": "Big Root",
    "move1": "Leech Seed",
    "move2": "Toxic",
    "move3": "Synthesis",
    "move4": "Ingrain",
    "speed": 100
  },
  {
    "entry": 384,
    "name": "P 384",
    "species": "Venusaur",
    "instance": "2",
    "nature": "Brave",
    "item": "Miracle Seed",
    "move1": "Roar",
    "move2": "Venoshock",
    "move3": "Power Whip",
    "move4": "Earthquake",
    "speed": 90
  },
  {
    "entry": 559,
    "name": "P 559",
    "species": "Venusaur",
    "instance": "3",
    "nature": "Timid",
    "item": "Salac Berry",
    "move1": "Energy Ball",
    "move2": "Sludge Bomb",
    "move3": "Grass Knot",
    "move4": "Protect",
    "speed": 145
  },
  {
    "entry": 734,
    "name": "P 734",
    "species": "Venusaur",
    "instance": "4",
    "nature": "Bold",
    "item": "Black Sludge",
    "move1": "Leech Seed",
    "move2": "Substitute",
    "move3": "Sludge Bomb",
    "move4": "Protect",
    "speed": 100
  },
  {
    "entry": 238,
    "name": "P 238",
    "species": "Vespiquen",
    "instance": "1",
    "nature": "Sassy",
    "item": "Quick Claw",
    "move1": "Defend Order",
    "move2": "Toxic",
    "move3": "Protect",
    "move4": "Heal Order",
    "speed": 54
  },
  {
    "entry": 413,
    "name": "P 413",
    "species": "Vespiquen",
    "instance": "2",
    "nature": "Quiet",
    "item": "Insect Plate",
    "move1": "Attack Order",
    "move2": "Power Gem",
    "move3": "Captivate",
    "move4": "Confuse Ray",
    "speed": 54
  },
  {
    "entry": 588,
    "name": "P 588",
    "species": "Vespiquen",
    "instance": "3",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Attack Order",
    "move2": "Defend Order",
    "move3": "Roost",
    "move4": "Confuse Ray",
    "speed": 60
  },
  {
    "entry": 763,
    "name": "P 763",
    "species": "Vespiquen",
    "instance": "4",
    "nature": "Brave",
    "item": "Custap Berry",
    "move1": "Attack Order",
    "move2": "U-turn",
    "move3": "Aerial Ace",
    "move4": "Destiny Bond",
    "speed": 54
  },
  {
    "entry": 249,
    "name": "P 249",
    "species": "Victreebel",
    "instance": "1",
    "nature": "Quiet",
    "item": "Payapa Berry",
    "move1": "Leaf Tornado",
    "move2": "Stockpile",
    "move3": "Swallow",
    "move4": "Gastro Acid",
    "speed": 81
  },
  {
    "entry": 424,
    "name": "P 424",
    "species": "Victreebel",
    "instance": "2",
    "nature": "Rash",
    "item": "Grass Gem",
    "move1": "Leaf Storm",
    "move2": "Sleep Powder",
    "move3": "Stockpile",
    "move4": "Encore",
    "speed": 122
  },
  {
    "entry": 599,
    "name": "P 599",
    "species": "Victreebel",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Sunny Day",
    "move2": "SolarBeam",
    "move3": "Sludge Bomb",
    "move4": "Weather Ball",
    "speed": 122
  },
  {
    "entry": 774,
    "name": "P 774",
    "species": "Victreebel",
    "instance": "4",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Weather Ball",
    "move2": "SolarBeam",
    "move3": "Sludge Bomb",
    "move4": "Gastro Acid",
    "speed": 122
  },
  {
    "entry": 248,
    "name": "P 248",
    "species": "Vileplume",
    "instance": "1",
    "nature": "Calm",
    "item": "Persim Berry",
    "move1": "Petal Dance",
    "move2": "Stun Spore",
    "move3": "Teeter Dance",
    "move4": "Moonlight",
    "speed": 102
  },
  {
    "entry": 423,
    "name": "P 423",
    "species": "Vileplume",
    "instance": "2",
    "nature": "Modest",
    "item": "Power Herb",
    "move1": "SolarBeam",
    "move2": "Sludge Bomb",
    "move3": "Synthesis",
    "move4": "Double Team",
    "speed": 70
  },
  {
    "entry": 598,
    "name": "P 598",
    "species": "Vileplume",
    "instance": "3",
    "nature": "Modest",
    "item": "Big Root",
    "move1": "Double Team",
    "move2": "Ingrain",
    "move3": "Toxic",
    "move4": "Giga Drain",
    "speed": 70
  },
  {
    "entry": 773,
    "name": "P 773",
    "species": "Vileplume",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Giga Drain",
    "move2": "SolarBeam",
    "move3": "Teeter Dance",
    "move4": "Sludge Bomb",
    "speed": 102
  },
  {
    "entry": 920,
    "name": "P 920",
    "species": "Virizion",
    "instance": "1",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Sacred Sword",
    "move2": "Leaf Blade",
    "move3": "Taunt",
    "move4": "Stone Edge",
    "speed": 176
  },
  {
    "entry": 940,
    "name": "P 940",
    "species": "Virizion",
    "instance": "2",
    "nature": "Timid",
    "item": "Sitrus Berry",
    "move1": "Energy Ball",
    "move2": "Focus Blast",
    "move3": "Calm Mind",
    "move4": "Toxic",
    "speed": 176
  },
  {
    "entry": 960,
    "name": "P 960",
    "species": "Virizion",
    "instance": "3",
    "nature": "Jolly",
    "item": "Coba Berry",
    "move1": "Leaf Blade",
    "move2": "Stone Edge",
    "move3": "Sacred Sword",
    "move4": "Protect",
    "speed": 176
  },
  {
    "entry": 980,
    "name": "P 980",
    "species": "Virizion",
    "instance": "4",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Leaf Blade",
    "move2": "Swords Dance",
    "move3": "Sacred Sword",
    "move4": "Rest",
    "speed": 128
  },
  {
    "entry": 374,
    "name": "P 374",
    "species": "Volcarona",
    "instance": "1",
    "nature": "Modest",
    "item": "Power Herb",
    "move1": "Fire Spin",
    "move2": "Heat Wave",
    "move3": "SolarBeam",
    "move4": "Whirlwind",
    "speed": 152
  },
  {
    "entry": 549,
    "name": "P 549",
    "species": "Volcarona",
    "instance": "2",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Bug Buzz",
    "move2": "Flamethrower",
    "move3": "Protect",
    "move4": "Calm Mind",
    "speed": 167
  },
  {
    "entry": 724,
    "name": "P 724",
    "species": "Volcarona",
    "instance": "3",
    "nature": "Bold",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Quiver Dance",
    "move3": "Bug Buzz",
    "move4": "Protect",
    "speed": 120
  },
  {
    "entry": 899,
    "name": "P 899",
    "species": "Volcarona",
    "instance": "4",
    "nature": "Bold",
    "item": "Leftovers",
    "move1": "Hurricane",
    "move2": "Quiver Dance",
    "move3": "Bug Buzz",
    "move4": "Heat Wave",
    "speed": 120
  },
  {
    "entry": 308,
    "name": "P 308",
    "species": "Wailord",
    "instance": "1",
    "nature": "Brave",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Heavy Slam",
    "move3": "Curse",
    "move4": "Rest",
    "speed": 72
  },
  {
    "entry": 483,
    "name": "P 483",
    "species": "Wailord",
    "instance": "2",
    "nature": "Timid",
    "item": "Quick Claw",
    "move1": "Water Spout",
    "move2": "Rest",
    "move3": "Sleep Talk",
    "move4": "Ice Beam",
    "speed": 123
  },
  {
    "entry": 658,
    "name": "P 658",
    "species": "Wailord",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Waterfall",
    "move2": "Avalanche",
    "move3": "Aqua Ring",
    "move4": "Curse",
    "speed": 80
  },
  {
    "entry": 833,
    "name": "P 833",
    "species": "Wailord",
    "instance": "4",
    "nature": "Modest",
    "item": "Zoom Lens",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Fissure",
    "move4": "Hyper Beam",
    "speed": 80
  },
  {
    "entry": 355,
    "name": "P 355",
    "species": "Walrein",
    "instance": "1",
    "nature": "Calm",
    "item": "Chesto Berry",
    "move1": "Frost Breath",
    "move2": "Snore",
    "move3": "Stockpile",
    "move4": "Rest",
    "speed": 85
  },
  {
    "entry": 530,
    "name": "P 530",
    "species": "Walrein",
    "instance": "2",
    "nature": "Calm",
    "item": "Metronome",
    "move1": "Ice Ball",
    "move2": "Earthquake",
    "move3": "Encore",
    "move4": "Curse",
    "speed": 85
  },
  {
    "entry": 705,
    "name": "P 705",
    "species": "Walrein",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Blizzard",
    "move3": "Hail",
    "move4": "Signal Beam",
    "speed": 85
  },
  {
    "entry": 880,
    "name": "P 880",
    "species": "Walrein",
    "instance": "4",
    "nature": "Bold",
    "item": "Lax Incense",
    "move1": "Sheer Cold",
    "move2": "Fissure",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed": 85
  },
  {
    "entry": 323,
    "name": "P 323",
    "species": "Weavile",
    "instance": "1",
    "nature": "Hasty",
    "item": "Razor Fang",
    "move1": "Fake Out",
    "move2": "Taunt",
    "move3": "Night Slash",
    "move4": "Fling",
    "speed": 194
  },
  {
    "entry": 498,
    "name": "P 498",
    "species": "Weavile",
    "instance": "2",
    "nature": "Jolly",
    "item": "NeverMeltIce",
    "move1": "Ice Shard",
    "move2": "Ice Punch",
    "move3": "Torment",
    "move4": "Protect",
    "speed": 194
  },
  {
    "entry": 673,
    "name": "P 673",
    "species": "Weavile",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Fake Out",
    "move2": "Ice Punch",
    "move3": "Night Slash",
    "move4": "Protect",
    "speed": 194
  },
  {
    "entry": 848,
    "name": "P 848",
    "species": "Weavile",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Taunt",
    "move2": "Ice Punch",
    "move3": "Night Slash",
    "move4": "Fake Out",
    "speed": 194
  },
  {
    "entry": 264,
    "name": "P 264",
    "species": "Weezing",
    "instance": "1",
    "nature": "Impish",
    "item": "Payapa Berry",
    "move1": "Pain Split",
    "move2": "Explosion",
    "move3": "Haze",
    "move4": "Will-O-Wisp",
    "speed": 80
  },
  {
    "entry": 439,
    "name": "P 439",
    "species": "Weezing",
    "instance": "2",
    "nature": "Rash",
    "item": "Poison Gem",
    "move1": "Sludge Bomb",
    "move2": "Fire Blast",
    "move3": "Stockpile",
    "move4": "Swallow",
    "speed": 80
  },
  {
    "entry": 614,
    "name": "P 614",
    "species": "Weezing",
    "instance": "3",
    "nature": "Modest",
    "item": "Black Sludge",
    "move1": "Sludge Bomb",
    "move2": "Thunder",
    "move3": "Fire Blast",
    "move4": "Shadow Ball",
    "speed": 80
  },
  {
    "entry": 789,
    "name": "P 789",
    "species": "Weezing",
    "instance": "4",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Toxic",
    "move2": "Will-O-Wisp",
    "move3": "Stockpile",
    "move4": "Rest",
    "speed": 80
  },
  {
    "entry": 236,
    "name": "P 236",
    "species": "Whiscash",
    "instance": "1",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Earthquake",
    "move2": "Tickle",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed": 80
  },
  {
    "entry": 411,
    "name": "P 411",
    "species": "Whiscash",
    "instance": "2",
    "nature": "Adamant",
    "item": "Soft Sand",
    "move1": "Aqua Tail",
    "move2": "Earthquake",
    "move3": "Zen Headbutt",
    "move4": "Dragon Dance",
    "speed": 80
  },
  {
    "entry": 586,
    "name": "P 586",
    "species": "Whiscash",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Earth Power",
    "move2": "Surf",
    "move3": "Blizzard",
    "move4": "Protect",
    "speed": 80
  },
  {
    "entry": 761,
    "name": "P 761",
    "species": "Whiscash",
    "instance": "4",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Rest",
    "move2": "Sleep Talk",
    "move3": "Fissure",
    "move4": "Muddy Water",
    "speed": 80
  },
  {
    "entry": 332,
    "name": "P 332",
    "species": "Yanmega",
    "instance": "1",
    "nature": "Rash",
    "item": "Cheri Berry",
    "move1": "Air Slash",
    "move2": "Bug Buzz",
    "move3": "Detect",
    "move4": "U-turn",
    "speed": 115
  },
  {
    "entry": 507,
    "name": "P 507",
    "species": "Yanmega",
    "instance": "2",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Psychic",
    "move2": "Bug Buzz",
    "move3": "Swagger",
    "move4": "Substitute",
    "speed": 115
  },
  {
    "entry": 682,
    "name": "P 682",
    "species": "Yanmega",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Silver Wind",
    "move2": "Air Slash",
    "move3": "Detect",
    "move4": "Giga Drain",
    "speed": 147
  },
  {
    "entry": 857,
    "name": "P 857",
    "species": "Yanmega",
    "instance": "4",
    "nature": "Modest",
    "item": "King's Rock",
    "move1": "Bug Buzz",
    "move2": "Air Slash",
    "move3": "Detect",
    "move4": "Shadow Ball",
    "speed": 147
  },
  {
    "entry": 910,
    "name": "P 910",
    "species": "Zapdos",
    "instance": "1",
    "nature": "Timid",
    "item": "Magnet",
    "move1": "Thunderbolt",
    "move2": "Signal Beam",
    "move3": "Air Cutter",
    "move4": "AncientPower",
    "speed": 167
  },
  {
    "entry": 930,
    "name": "P 930",
    "species": "Zapdos",
    "instance": "2",
    "nature": "Bold",
    "item": "BrightPowder",
    "move1": "Charge Beam",
    "move2": "Heat Wave",
    "move3": "Double Team",
    "move4": "Roost",
    "speed": 120
  },
  {
    "entry": 950,
    "name": "P 950",
    "species": "Zapdos",
    "instance": "3",
    "nature": "Naive",
    "item": "Petaya Berry",
    "move1": "Thunder",
    "move2": "Light Screen",
    "move3": "Rain Dance",
    "move4": "Drill Peck",
    "speed": 167
  },
  {
    "entry": 970,
    "name": "P 970",
    "species": "Zapdos",
    "instance": "4",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Volt Switch",
    "move3": "Heat Wave",
    "move4": "Detect",
    "speed": 167
  },
  {
    "entry": 293,
    "name": "P 293",
    "species": "Zebstrika",
    "instance": "1",
    "nature": "Naughty",
    "item": "Electric Gem",
    "move1": "Swagger",
    "move2": "Volt Switch",
    "move3": "Wild Charge",
    "move4": "Pursuit",
    "speed": 136
  },
  {
    "entry": 468,
    "name": "P 468",
    "species": "Zebstrika",
    "instance": "2",
    "nature": "Timid",
    "item": "Magnet",
    "move1": "Discharge",
    "move2": "Thunder Wave",
    "move3": "Thunder",
    "move4": "Rain Dance",
    "speed": 184
  },
  {
    "entry": 643,
    "name": "P 643",
    "species": "Zebstrika",
    "instance": "3",
    "nature": "Jolly",
    "item": "Air Balloon",
    "move1": "Flame Charge",
    "move2": "Toxic",
    "move3": "Wild Charge",
    "move4": "Volt Switch",
    "speed": 184
  },
  {
    "entry": 818,
    "name": "P 818",
    "species": "Zebstrika",
    "instance": "4",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Me First",
    "move2": "Wild Charge",
    "move3": "Thunder Wave",
    "move4": "Volt Switch",
    "speed": 184
  },
  {
    "entry": 325,
    "name": "P 325",
    "species": "Zoroark",
    "instance": "1",
    "nature": "Naive",
    "item": "Focus Sash",
    "move1": "Night Slash",
    "move2": "Shadow Claw",
    "move3": "Taunt",
    "move4": "Counter",
    "speed": 172
  },
  {
    "entry": 500,
    "name": "P 500",
    "species": "Zoroark",
    "instance": "2",
    "nature": "Jolly",
    "item": "Expert Belt",
    "move1": "Grass Knot",
    "move2": "Shadow Ball",
    "move3": "Flamethrower",
    "move4": "Nasty Plot",
    "speed": 172
  },
  {
    "entry": 675,
    "name": "P 675",
    "species": "Zoroark",
    "instance": "3",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Swords Dance",
    "move2": "Night Slash",
    "move3": "U-turn",
    "move4": "Sucker Punch",
    "speed": 172
  },
  {
    "entry": 850,
    "name": "P 850",
    "species": "Zoroark",
    "instance": "4",
    "nature": "Timid",
    "item": "Focus Band",
    "move1": "Protect",
    "move2": "Counter",
    "move3": "Dark Pulse",
    "move4": "Focus Blast",
    "speed": 172
  }
];
